webpackJsonp([1],{

/***/ "+bXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgetPassword_vue__ = __webpack_require__("Siir");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0642c4b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgetPassword_vue__ = __webpack_require__("Ej8v");
function injectStyle (ssrContext) {
  __webpack_require__("bGgp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0642c4b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0642c4b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+vrv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_index_api__ = __webpack_require__("TGqv");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityList: {} //数据
  },
  data: function data() {
    return {
      refundApplyTime: null //申请退款时间
    };
  },
  created: function created() {
    this.getPayment();
  },

  methods: {
    // 详情接口
    getPayment: function getPayment() {
      var _this = this;

      var params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["a" /* getDetail */])(params).then(function (res) {
        //申请退款时间
        if (res.refundApplyTime != undefined) {
          var date1 = new Date(res.refundApplyTime);
          var YY1 = date1.getFullYear() + '-';
          var MM1 = (date1.getMonth() + 1 < 10 ? '0' + (date1.getMonth() + 1) : date1.getMonth() + 1) + '-';
          var DD1 = date1.getDate() < 10 ? '0' + date1.getDate() : date1.getDate();
          var hh1 = (date1.getHours() < 10 ? '0' + date1.getHours() : date1.getHours()) + ':';
          var mm1 = (date1.getMinutes() < 10 ? '0' + date1.getMinutes() : date1.getMinutes()) + ':';
          var ss1 = date1.getSeconds() < 10 ? '0' + date1.getSeconds() : date1.getSeconds();
          _this.refundApplyTime = YY1 + MM1 + DD1 + " " + hh1 + mm1 + ss1;
        }
      });
    }
  }
});

/***/ }),

/***/ "//yH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityListDetails: {} //数据
  },
  data: function data() {
    return {
      orderTime: null, //用户下单时间
      applyTime: null, //申请结算时间
      settleTime: null, //确认结算时间
      accomplishTime: null //完成时间
    };
  },
  created: function created() {
    var _commodityListDetails = this.commodityListDetails,
        orderTime = _commodityListDetails.orderTime,
        applyTime = _commodityListDetails.applyTime,
        settleTime = _commodityListDetails.settleTime,
        accomplishTime = _commodityListDetails.accomplishTime;

    if (orderTime) {
      this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(orderTime);
    }
    if (applyTime) {
      this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
    }
    if (settleTime) {
      this.settleTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(settleTime);
    }
    if (accomplishTime) {
      this.accomplishTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(accomplishTime);
    }
  },

  watch: {
    commodityListDetails: {
      handler: function handler(newVal) {
        var orderTime = newVal.orderTime,
            applyTime = newVal.applyTime,
            settleTime = newVal.settleTime,
            accomplishTime = newVal.accomplishTime;

        this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(orderTime);
        this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
        this.settleTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(settleTime);
        this.accomplishTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(accomplishTime);
      },

      deep: true
    }
  }
});

/***/ }),

/***/ "/uab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  language: {
    name: 'English'
  },
  // footer
  footer: {
    navbar: {
      page: 'Home',
      shop: 'Mall',
      trading: 'Trading',
      wallet: 'Wallet',
      mine: 'Me'
    }
  },
  // 公共文字
  common: {
    zwgg: 'No advertisement',
    szzjmm: 'Please enter trading password',
    jzz: 'Loading',
    zzzr: 'Loading...',
    jzwb: 'All loaded',
    czcg: 'Success',
    txwz: 'Please complete',
    qx: 'Cancel',
    fq: 'Cancel',
    qr: 'Ok',
    qd: 'Ok',
    jg: 'Price',
    je: 'Amount',
    sl: 'Quantity',
    gm: 'Buy',
    cs: 'Sell',
    zfb: 'Alipay',
    wx: 'Wechat',
    yhkzz: 'Bankcard',
    qdlhcz: 'Please log in first',
    xdcg: 'Success',
    mr: 'Buy',
    mc: 'Sell',
    jy: 'Trade',
    hp: 'Praises',
    xr: 'Trusted',
    cp: 'Complaints',
    buyFMVP: 'Buy FMVP',
    qxdl: 'Please Login',
    jytx: 'Trading reminder',
    zwsj: 'No Data',
    qxzf: 'Cancel',
    bjfk: 'Mark payment',
    type: 'Type'
  },
  // page页
  page: {
    navbar: {
      title: 'FUNMVP'
    },
    cate: {
      game: 'Game',
      xss: 'Game',
      exchange: 'Used-car exchange',
      otc: 'Fiat',
      splendid: 'Wonderful view full of passion',
      bbDeal: 'Exchange',
      realTime: 'Global real-time market',
      xtgg: 'System Notice',
      sstsjcnr: 'Push exciting news in time',
      ptjs: 'FUNMVP',
      ljwm: 'Know more about us'
    }
  },
  // 游戏商城页
  shop: {
    navbar: {
      title: 'Mall',
      txt: 'Blockchain game',
      car: 'Used-car',
      escdh: 'Used-car exchange'
    },
    subject: {
      yxye: 'Balances',
      jryx: 'Enter',
      zryx: 'Deposit',
      cz: 'Deposit',
      qsrczsl: 'Deposit amount',
      czslbnwk: 'The amount of recharge can not be empty'
    }
  },
  // 系统公告
  notice: {
    subject: {
      zwgg: 'No advertisement',
      gg: 'Announcement'
    }
  },
  // 场外交易-列表页
  otc: {
    navbar: {
      txt: 'Fiat',
      buyB: 'Buy',
      sellB: 'Sell',
      bbjy: 'Exchange'
    },
    navtxt: {
      xz: 'Choose',
      zfb: 'Alipay',
      wx: 'Wechat',
      yhk: 'Bankcard'
    },
    subject: {
      ysm: 'Auth',
      wsm: 'UnAuth',
      jy: 'Trades',
      hp: 'Praises',
      xr: 'Trusted',
      xe: 'Limit',
      bj: 'Edit',
      cs: 'Sell',
      gm: 'Buy',
      fbgm: 'Release buying advertisement',
      fbcs: 'Release selling advertisement',
      fb: 'Post'
    }
  },
  // 发布广告
  buyPublish: {
    subject: {
      jybz: 'Currency',
      jg: 'Price',
      yjl: 'Margin',
      gm: 'Buy',
      cs: 'Sell',
      zdj: 'Min price',
      zgj: 'Max price',
      kjyzdj: 'Min limit',
      kyjzgj: 'Max limit',
      zxj: 'Minimum amount',
      zced: 'Minimum amount',
      zdjg: 'Maximum amount',
      zded: 'Maximum amount',
      zl: ' total amount',
      ye: 'Balances',
      sbzl: 'Please enter the total amount of coins sold',
      fkfs: 'Payment mehod',
      zfb: 'Alipay',
      wx: 'Wechat',
      yhk: 'Bankcard',
      fkqx: 'The payment term',
      qsfkqx: 'The payment term',
      fz: 'Minute',
      ggly: 'BTC/ETH, digital currency, blockchain, etc. must not appear in the payment notes.',
      gjsz: 'Advanced settings',
      kfsj: 'Schedule',
      rhsh: 'Anytime',
      zdy: 'User-defined',
      jfs: 'Only trusted traders',
      zjfb: 'Release directly',
      bccg: 'Save drafts',
      zgcjjg: 'The highest advertised price',
      zdcjjg: 'The lowest advertised price',
      xqy: 'Monday',
      xqe: 'Tuesday',
      xqs: 'Wednesday',
      xqi: 'Thursday',
      xqw: 'Friday',
      xql: 'Saturday',
      xqt: 'Sunday',
      yjlv: 'The premium rate should be between -50 and 50',
      gb: 'close',
      gglx: 'Type'
    }
  },
  // 购买页面
  otcBuy: {
    userMsg: {
      xe: 'Limit',
      jycs: 'Trades',
      xrcs: 'Trusted',
      xrl: 'Praises',
      lsjy: 'Trades history'
    },
    subject: {
      ggly: 'Advertising message',
      nx: 'How much do you want to ',
      ds: '？',
      kyye: 'Available balances',
      syjyl: 'advertisement left to be traded ',
      srsz: 'Please enter the number',
      srsi: 'Please enter the number',
      xldf: 'Contact',
      zjmm: 'Trading password',
      qsrzj: 'Please enter trading password',
      xdqr: 'Confirm the order',
      xdtxt: 'Please confirm the price and place an order again. After placing the order, the ',
      xdtxw: ' will be frozen and locked. Please rest assured.',
      fq: 'Give up',
      qr: 'ok',
      qszjmm: 'Please enter trading password',
      gmslje: 'Please enter the purchase quantity and amount.',
      ddtjcg: 'Order submitted successfully'
    }
  },
  // 个人主页
  homepage: {
    subject: {
      jycs: 'Trades',
      xrcs: 'Trusted',
      xrl: 'Praises',
      lsjy: 'Trades history',
      xr: 'Trusted',
      hmd: 'Blacklist',
      grzy: 'Homepage',
      yxr: 'Trusted',
      ylh: 'Blacklisted'

    }
  },
  // 币币交易
  trading: {
    bbDeal: {
      cwjy: 'Fiat',
      bbjy: 'Exchange',
      mr: 'Buy ',
      mc: 'Sell ',
      xj: 'Limit',
      sj: 'Market',
      pk: '',
      sl: 'Amount',
      sczjjg: 'Optimal market price',
      wtjg: 'Price',
      wtsl: 'Amount',
      jye: 'Total',
      ky: 'Available ',
      km: 'Available to buy ',
      dj: 'Frozen ',
      kmai: 'Available to sell ',
      mai: '',
      m: '',
      dqwt: 'Open Orders',
      ls: 'History',
      cx: 'Cancel',
      sjcj: 'Executed',
      zwdd: 'No orders'
    },
    bbDepth: {
      xj: 'Market price',
      zf: 'Change%',
      zg: 'High',
      zd: 'Low',
      cj: 'Trades',
      gd: 'Order',
      sdt: 'Depth',
      jj: 'Introduction',
      bkbwl: 'Cannot be null or less than or equal to zero',
      xsbdy: 'No more than 8 decimal places',
      xsldy: 'No more than 2 decimal places',
      cjsj: 'Date',
      cjjg: 'Price',
      cjl: 'Amount',
      more: 'More'
    },
    putUp: {
      buy20: 'Buy 20',
      sell20: 'Sell 20',
      sl: 'Amount',
      jg: 'Price'
    }
  },
  // 历史委托
  historyEntrust: {
    subject: {
      mr: 'Buy',
      mc: 'Sell',
      sj: 'Market price',
      ze: 'Amount',
      sjcj: 'Avg price',
      zwdd: 'No orders ',
      lswt: 'Order History',
      ycj: 'Executed'
    }
  },
  // 钱包
  wallet: {
    subject: {
      zzc: 'Total value',
      b: 'coin',
      bzzc: ' currency asset ',
      dj: 'Frozen ',
      ky: 'Available ',
      zr: 'Deposit',
      zc: 'Withdraw',
      zd: 'Bill',
      cz: 'Buy',
      tx: 'Sell',
      ddjl: 'Records',
      wdzc: 'My balances',
      xyzsf: 'Please authenticate first',
      szjymm: 'Please set the trading password first'
    }
  },
  // 转入
  walletInto: {
    subject: {
      qbtscz: 'No recharge of assets other than this currency is allowed at the wallet address. The recharge of assets other than this currency will not be recovered.',
      qbjz: ' wallet address is forbidden to recharge other assets except ',
      qbzw: '. Any ',
      qbzh: ' asset recharge will not be recovered.',
      zrdz: 'My transfer-in address',
      dz: 'Address',
      jl: 'Records',
      fzskdz: 'Copy payment address',
      zr: 'transferred-in',
      gbzc: 'The mobile model does not support click copy, please long press the text to copy.',
      fzcg: 'Replicating success'
    }
  },
  // 转出
  walletOut: {
    subject: {
      zc: 'transferred-out',
      kyye: 'Balances',
      jl: 'Records',
      jsdz: 'Address',
      qsrzzdz: 'Please enter the withdrawal address',
      zzsl: 'Amount',
      qsrsl: 'Please enter the withdrawal amount',
      zjmm: 'Password',
      qsrzjmm: 'Trading password',
      txsm: 'Remark',
      qsrsm: 'Please enter the notes',
      kgf: 'Charge rates',
      kgfzz: 'The miner’s fee will be deducted from the available balance and the balance will be deducted from the transfer amount.',
      zzssmf: 'Mutual transfers within the platform are real-time and free of charge.',
      qrzz: 'Confirm'
    }
  },
  // 转账记录
  walletBill: {
    subject: {
      zwjl: 'No open orders yet',
      qb: 'All',
      cb: 'Deposit',
      tb: 'Withdrawal',
      jymr: 'Buy',
      jymc: 'Sell',
      zzjl: 'Transfer records',
      sxf: 'Charges',
      yxzr: 'Transferred-in game',
      yxzc: 'Transferred-out game',
      djjd: 'Freezing and thaw'
    }
  },
  // 账单详情
  billDetail: {
    subject: {
      bdqje: 'Pre-change',
      bdhje: 'Changed',
      sxf: 'Charges',
      bdsj: 'Date',
      jymx: 'Instruction',
      zdxq: 'Billing details'
    }
  },
  // 买卖fmvp
  walletBuy: {
    subject: {
      gmb: 'Buy FMVP',
      csb: 'Sell FMVP',
      zjbz: 'Own currency',
      dj: 'Unit price',
      gmje: 'Purchase amount',
      gmsl: 'Quantity',
      csje: 'Selling amount',
      cssl: 'Quantity',
      sxf: 'Charges',
      ky: ' ',
      zffs: 'Payment mehod',
      qsrzh: 'Please enter your alipay account (for confirmation)',
      bzxx: 'BTC/ETH/FMVP, digital currency, blockchain, etc. must not appear in the payment notes.',
      qxz: 'Please choose',
      zhhkh: 'Please enter your account number or bank card number',
      zjmm: 'Trading password',
      qszjmm: 'Please enter trading password',
      qrgm: 'confirm to buy',
      qrcs: 'Confirm to sell',
      dksm: 'Please fill in the instructions',
      jeyzzj: 'The amount should be between 1 and 2',
      jeyz: 'The amount should be between ',
      y: ' and ',
      zj: '',
      dbxz: 'Limit',
      zded: 'Minimum amount'
    }
  },
  // 订单记录
  walletRecord: {
    subject: {
      zje: 'Total',
      zwdd: 'No orders',
      ddjl: 'Orders records'
    }
  },
  // 订单详情
  orderDetail: {
    subject: {
      lx: 'Type',
      skr: 'Payee',
      skfs: 'Payment methods',
      zh: 'account number',
      khh: 'Bank',
      ptrz: 'Beneficiary account has been certified via platform, please feel free to collect payment.',
      wcfk: 'Already paid',
      qxjy: 'Cancel',
      dzf: 'Pending to pay',
      dqr: 'Pending to confirm',
      ywc: 'Completed',
      yqx: 'Cancelled',
      ptyqx: 'FUNMVP cancelled',
      ddxq: 'Order details',
      ggly: 'Advertising message',
      otcBusiness: 'Otc business'
    }
  },
  // 个人主页
  mine: {
    subject: {
      jy: 'Trades',
      hpl: 'Praises',
      xr: 'Trusted',
      wygm: 'Buy',
      wycs: 'Sell',
      wdgg: 'My advertisement',
      wddd: 'My orders',
      jyds: 'Counterparty',
      yqhy: 'Invitiation',
      aqzx: 'Security',
      gywm: 'About us',
      grzx: 'User',
      ghcg: 'Success',
      tpsc: 'Image upload error',
      nyxxx: 'New message'
    }
  },
  // 我的广告
  myAdvertising: {
    subject: {
      dfb: 'Pending release',
      yfb: 'Released',
      xe: 'Limit',
      fb: 'Release',
      bj: 'Edit',
      xj: 'Unrelease',
      zwgg: 'No advertisement',
      wdgg: 'My advertisement',
      type: 'Type'
    }
  },
  // 我的订单
  myOrder: {
    subject: {
      jxz: 'Processing',
      yjs: 'Finished',
      jyje: 'Amount',
      jysl: 'Quantity',
      ddbh: 'No.',
      zwdd: 'No orders',
      wddd: 'My Order',
      wd: 'Unread'
    }
  },
  // 我的订单详情
  myOrderDetail: {
    subject: {
      ddbh: 'No.',
      jyje: 'Amount',
      jysl: 'Quantity',
      jyjg: 'Price',
      mj: 'Buyer',
      maij: 'Seller',
      pj: 'praise',
      pjyj: 'Very satisfied with this transaction, and will continue to cooperate next time.',
      ltnr: 'Please enter to chat',
      zcly: 'Arbitration reason',
      sqly: 'Please enter the reason for the application',
      jypj: 'Comment',
      yhyx: 'What is your comment on this transaction? Come and make a comment',
      klpj: 'come and make a comment',
      ddxq: 'Order details',
      qdp: 'Please make a comment',
      pjsh: 'Success, and need to be reviewed as keywords included.',
      pjcg: 'Success',
      ddbcd: 'The order will be hosted until',
      zdqx: 'Overdue transactions will be cancelled automatically',
      bjfk: 'Mark payment',
      qxjy: 'Cancel',
      sfhb: 'Release currency',
      sqlybk: 'The reason for the application cannot be empty',
      fqcg: 'Success',
      sqzc: 'Apply Arbitration'
    }
  },
  // 交易对手
  myGuest: {
    subject: {
      wxrd: 'Trusted by me',
      xrwd: 'Trust me',
      wpbd: 'Blocked by me',
      jycs: 'Trades',
      xrrs: 'Trusted by',
      hpl: 'Praises',
      zwxx: 'No information',
      jyds: 'Counterparty'
    }
  },
  // 邀请好友
  myInviteFriends: {
    subject: {
      yqnjr: 'Invite you to join FUNMVP',
      casb: 'Long press to identify the QR code',
      yqhy: 'Invitiation',
      fuzzs: 'Copy your exclusive invitation link',
      fz: 'Copy',
      bzbd: 'Please long press to save pictures and scan QR code to invite'
    }
  },
  // 安全中心
  securityCenter: {
    subject: {
      jymm: 'Trading password',
      sfrz: 'ID Verification',
      ggrz: 'Google authentication',
      ykq: 'Turned on',
      bdyx: 'Bind mailbox',
      ybdyx: 'Binded mailbox',
      bdsjh: 'Bind cellphone number',
      ybdsjh: 'Binded cellphone number',
      xgdlmm: 'Modify the login password',
      tcdl: 'Log out',
      aqzx: 'Security'
    }
  },
  // 修改交易密码
  securityTradePassword: {
    subject: {
      zg: 'China',
      sryzm: 'Please enter the code',
      hqyzm: 'Get code',
      cxhq: 'Reacquire',
      mmjw: 'Password 6-16 digits',
      qrmm: 'confirm password',
      qd: 'Submit',
      xgjymm: 'Modify the trading password',
      szjymm: 'Please enter trading password',
      txwz: 'Please complete',
      mmbyz: 'Password is inconsistent, please re-enter',
      czcg: 'Reset password successfully',
      szcg: 'Set password successfully'
    }
  },
  // 身份认证
  securityIdentity: {
    subject: {
      sfzrz: 'ID card',
      hzrz: 'Passport',
      jzrz: 'Driving license',
      wrz: 'uncertified',
      sfrz: 'ID Verification'
    }
  },
  // 进行身份认证
  securityIdcard: {
    subject: {
      qsrxm: 'Please enter your name',
      qsr: 'please enter ',
      h: '',
      sc: 'Upload ',
      zm: 'positive',
      fm: 'Negative',
      qd: 'Submit',
      fqcg: 'Authenticated successfully',
      sfz: 'ID card ',
      hz: 'passport ',
      jz: 'Driving license ',
      rz: 'Certification',
      tpcc: 'Image upload error'
    }
  },
  // google认证
  securityGoogle: {
    subject: {
      mm: 'password',
      ggyzm: 'Google verification code',
      sjyzm: 'cellphone verification code',
      hqyzm: 'Get code',
      cxhq: 'Reacquire',
      qd: 'Submit',
      ggrz: 'Google authentication',
      kqcg: 'success',
      gbcg: 'success'
    }
  },
  // 绑定邮箱
  bindEmail: {
    subject: {
      sryx: 'Please enter email address',
      sryz: 'Please enter the code',
      hqyz: 'Get code',
      cxhq: 'Reacquire',
      qd: 'Submit',
      bdyx: 'Bind mailbox'
    }
  },
  // 绑定手机
  securityPhone: {
    subject: {
      sjh: 'Please enter your cellphone number',
      yzm: 'Please enter the code',
      hqyz: 'Get code',
      cxhq: 'Reacquire',
      qd: 'Submit',
      qtx: 'Please fill in your cellphone number',
      txwz: 'Please complete'
    }
  },
  // 修改登录密码
  exitLoginPassword: {
    subject: {
      sryxsj: 'Please enter your email or cellphone number',
      yzm: 'Enter verification code',
      hqyzm: 'Get code',
      cxhq: 'Reacquire',
      xmm: 'New password 6-16 digits',
      jmm: 'Please enter the original password',
      ywsz: 'Please enter a 6-16 bit password',
      qrmm: 'confirm password',
      qd: 'Submit',
      xgdlmm: 'Modify the login password',
      zhmm: 'Retrieve password',
      mmbyz: 'Password is inconsistent, please re-enter',
      czmmcg: 'Reset password successfully'

    }
  },
  // 登录
  login: {
    subject: {
      hyhl: 'Welcome back',
      srzh: 'Please enter the account number',
      srldsl: 'Please enter a 6-16 bit login password',
      dl: 'Login',
      ljzc: 'Sign up now',
      wjmm: 'Forget password?'
    }
  },
  // 注册
  registered: {
    subject: {
      zc: 'Register',
      sjzc: 'Cellphone',
      yxzc: 'Welcome to join COWEX',
      zcfs: 'Please register by email',
      srnc: 'Please enter a username',
      srsjh: 'Please enter your cellphone number',
      sryxh: 'Please input your email',
      sryzm: 'Enter code',
      hqyzm: 'Get code',
      cxfs: 'Reacquire',
      ldslw: 'Please enter a 6-16 bit password',
      qrmm: 'Please confirm your password',
      wyjs: 'I agree',
      xytk: '《Registration agreement》',
      zcxy: 'Registration Agreement',
      sjhwk: 'Cellphone number cannot be empty',
      yxhwk: 'Email cannot be empty',
      txwz: 'Please complete',
      mmbyz: 'Password is inconsistent, please re-enter',
      zccg: 'Registered success'
    }
  },
  //协议
  aboutprivacy: {
    subject: {
      ptjs: 'FUNMVP',
      yhxy: 'User Agreement',
      ystk: 'Privacy Policy',
      flsm: 'Legal Statement',
      fvsm: 'Fee Rate',
      lxwm: 'Contact us',
      gg: 'System Notice',
      bzzx: 'Help',
      gywm: 'About us'
    }
  },
  // 聊天
  messageChat: {
    subject: {
      ltnr: 'Enter to chat',
      sdsm: 'say something',
      fs: 'Send',
      xxnrbnwk: 'Message content can not be empty'
    }
  },
  // 错误信息
  error: {
    subject: {
      notNull: 'Can\'t be empty'
    }
  }
});

/***/ }),

/***/ "02pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0QnF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0YHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityListDetails: {} //数据
  },
  data: function data() {
    return {
      refundApplyTime: null, //申请退款时间
      affirmRefundTime: null //确认退款时间
    };
  },
  created: function created() {
    var _commodityListDetails = this.commodityListDetails,
        refundApplyTime = _commodityListDetails.refundApplyTime,
        affirmRefundTime = _commodityListDetails.affirmRefundTime;

    if (refundApplyTime) {
      this.refundApplyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(refundApplyTime);
    }
    if (affirmRefundTime) {
      this.affirmRefundTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(affirmRefundTime);
    }
  },

  watch: {
    commodityListDetails: {
      handler: function handler(newVal) {
        var refundApplyTime = newVal.refundApplyTime,
            affirmRefundTime = newVal.affirmRefundTime;

        this.refundApplyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(refundApplyTime);
        this.affirmRefundTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(affirmRefundTime);
      },

      deep: true
    }
  },
  methods: {}
});

/***/ }),

/***/ "0w2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSystemType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_fetch__ = __webpack_require__("BXx+");


// 系统参数 type查
function getSystemType(type) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/config/public/list", { type: type });
}

/***/ }),

/***/ "1H7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1J1E":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAs0lEQVQ4T+3UQQoCIRQG4P+R+3ApHaLu5Cq6QEETUotOEM0svMCcpu5QuZT2kmFQRIuo6V/mUvTzV95TQB5C9iBt2/ZijEsAEwD9jgecAWy01gtpmmYKYN0Ret02K+ABwIAEHgt4AcB6y1zATEp3Y1jJHpn4IP3Kf/BtBSmlRtba/fMi7/0wpbS7z31Vh5+C9E45ATCkbglS1/VcRFYMMOdciXNOGWMKOP7xP9yGECp6610BqqtLmXE06UgAAAAASUVORK5CYII="

/***/ }),

/***/ "2aYV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settledAmount"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("用户下单时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请结算时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.applyTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("确认结算时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.settleTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Hpq":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "3IMD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3k5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__ = __webpack_require__("y/jF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__["a" /* default */]
  },
  data: function data() {
    return {
      list: [1, 2, 3],
      loading: false,
      finished: false,
      isLoading: true
    };
  },

  methods: {
    goWithdrawal: function goWithdrawal() {
      this.$router.push("/withdrawal");
    },

    // 去详情
    toDetial: function toDetial() {
      this.$router.push("/goods_payment/goods_payment_detail");
    },
    onLoad: function onLoad() {
      var _this = this;

      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(function () {
        for (var i = 0; i < 10; i++) {
          _this.list.push(_this.list.length + 1);
        }
        // 加载状态结束 
        _this.loading = false;
        // 数据全部加载完成
        if (_this.list.length >= 100) {
          _this.finished = true;
        }
      }, 2000);
    }
  }
});

/***/ }),

/***/ "4FzC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5WXv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5uRJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6G2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amountOf"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请退款时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.refundApplyTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "74jZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pub_box"},[_c('h5',{staticClass:"p_h5"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"p_txt",domProps:{"innerHTML":_vm._s(_vm.serviceConfig)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "87vh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showFlag: false
    };
  },

  props: {
    title: {
      type: String,
      default: '正在载入'
    }
  },
  methods: {
    show: function show() {
      this.showFlag = true;
    },
    hide: function hide() {
      this.showFlag = false;
    },
    getTitle: function getTitle(text) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js_util__["a" /* getTranslateText */])(text);
    }
  }
});

/***/ }),

/***/ "8EyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = delCookie;
function setCookie(name, value, expires) {
  var expr = '';
  if (!expires) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    expr = ';expires=' + exp.toGMTString();
  }
  document.cookie = name + '=' + escape(value) + expr + ';path=/;';
}

function getCookie(name) {
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  var arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/;';
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  setLang: function setLang(lang) {
    window.localStorage.setItem('user_lang', lang);
  },
  getLang: function getLang(defaultLang) {
    var localLang = window.localStorage.getItem('user_lang');
    if (localLang === null) {
      return defaultLang;
    } else {
      return localLang;
    }
  }
});

/***/ }),

/***/ "8OU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_util__ = __webpack_require__("hhm8");




var GENDER = {
  '0': '女',
  '1': '男'
};

var User = function () {
  function User(_ref) {
    var userId = _ref.userId,
        birthday = _ref.birthday,
        gender = _ref.gender,
        level = _ref.level,
        mobile = _ref.mobile,
        nickname = _ref.nickname,
        photo = _ref.photo,
        totalFansNum = _ref.totalFansNum,
        totalFollowNum = _ref.totalFollowNum,
        tradepwdFlag = _ref.tradepwdFlag,
        loginDatetime = _ref.loginDatetime,
        h5OpenId = _ref.h5OpenId,
        introduce = _ref.introduce,
        createDatetime = _ref.createDatetime;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, User);

    this.userId = userId;
    // this.birthday = birthday;
    // this.gender = gender;
    this.level = level;
    this.mobile = mobile;
    this.nickname = nickname;
    this.photo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["b" /* isUnDefined */])(photo) ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["c" /* formatAvatar */])(photo);
    // this.totalFansNum = totalFansNum;
    // this.totalFollowNum = totalFollowNum;
    this.tradepwdFlag = tradepwdFlag;
    this.loginDatetime = loginDatetime;
    this.h5OpenId = h5OpenId;
    // this.introduce = introduce;
    this.createDatetime = createDatetime;
    this.totalDays = calcTotalDays(createDatetime);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(User, [{
    key: 'setAvatar',
    value: function setAvatar(photo) {
      this.photo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["c" /* formatAvatar */])(photo);
    }
    // getDescription() {
    //   let infos = this.getInfos();
    //   infos.gender = infos.gender ? infos.gender + '生' : '';
    //   let str = infos.age + infos.constellation + infos.gender;
    //   if (str) {
    //     str += '，';
    //   }
    //   return str + '加入' + this.totalDays + '天。' + (this.introduce || '');
    // }

  }, {
    key: 'getLoginTime',
    value: function getLoginTime() {
      var logTime = '';
      if (this.loginDatetime) {
        logTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["d" /* calcSpace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util__["e" /* formatDate */])(this.loginDatetime, 'yyyy-MM-dd-hh-mm'));
      }
      return logTime;
    }
  }, {
    key: 'getInfos',
    value: function getInfos() {
      var age = '';
      var constellation = '';
      var gender = '';
      if (this.birthday) {
        var arr = this.birthday.split('-');
        var birth = +arr[0];
        if (birth < 2000) {
          age = Math.floor((birth - 1900) / 10) + '0后';
        } else {
          age = Math.floor((birth - 2000) / 10) + '0后';
        }
        constellation = getCostellation(+arr[1], +arr[2]);
      }
      if (this.gender) {
        gender = GENDER[this.gender];
      }
      return {
        age: age,
        constellation: constellation,
        gender: gender
      };
    }
  }, {
    key: 'toString',
    value: function toString() {
      var age = '';
      var constellation = '';
      var gender = '';
      var infos = this.getInfos();
      if (infos.age) {
        age = infos.age + ' ' + infos.constellation + ' ';
      }
      if (infos.gender) {
        gender = infos.gender + ' ';
      }
      return age + constellation + gender + this.getLoginTime();
    }
  }]);

  return User;
}();

/* harmony default export */ __webpack_exports__["a"] = (User);


function getCostellation(month, day) {
  var constellation = '';
  switch (month) {
    case 1:
      constellation = day <= 19 ? '摩羯座' : '水瓶座';
      break;
    case 2:
      constellation = day <= 18 ? '水瓶座' : '双鱼座';
      break;
    case 3:
      constellation = day <= 20 ? '双鱼座' : '白羊座';
      break;
    case 4:
      constellation = day <= 20 ? '白羊座' : '金牛座';
      break;
    case 5:
      constellation = day <= 20 ? '金牛座' : '双子座';
      break;
    case 6:
      constellation = day <= 21 ? '双子座' : '巨蟹座';
      break;
    case 7:
      constellation = day <= 22 ? '巨蟹座' : '狮子座';
      break;
    case 8:
      constellation = day <= 22 ? '狮子座' : '处女座';
      break;
    case 9:
      constellation = day <= 22 ? '处女座' : '天秤座';
      break;
    case 10:
      constellation = day <= 22 ? '天秤座' : '天蝎座';
      break;
    case 11:
      constellation = day <= 21 ? '天蝎座' : '射手座';
      break;
    case 12:
      constellation = day <= 22 ? '射手座' : '摩羯座';
      break;
    default:
      constellation = '';
  }
  return constellation;
}

function calcTotalDays(createDatetime) {
  var start = new Date(createDatetime).getTime();
  var now = new Date().getTime();
  return Math.ceil((now - start) / 86400000);
}

/***/ }),

/***/ "8YlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goodsPaymentDetail"},[_c('Tab',{attrs:{"title":"详情"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods"},[_c('div',{staticClass:"showMoney"},[_c('p',[_vm._v("变动金额")]),_vm._v(" "),_c('p',[_vm._v("+4989.00")])]),_vm._v(" "),_c('div',{staticClass:"goodslist"},[_c('div',{staticClass:"goodsDetail"},[_c('img',{attrs:{"src":"","alt":""}}),_vm._v(" "),_c('div',[_c('p',{staticClass:"goodsTitle"},[_vm._v("天然新疆和田玉帝王青玉南瓜手串")]),_vm._v(" "),_c('span',[_vm._v("规格一")]),_vm._v(" "),_c('p',{staticClass:"money"},[_vm._v("¥498")])]),_vm._v(" "),_c('span',{staticClass:"goodsNumber"},[_vm._v("x1")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('p',[_c('span',[_vm._v("交易号：")]),_vm._v(" "),_c('span',[_vm._v("7654338768757605")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("交易时间：")]),_vm._v(" "),_c('span',[_vm._v("2020/06/12 10:07:10")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("商户信息：")]),_vm._v(" "),_c('span',[_vm._v("店铺名称")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9CC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityListDetails: {} //数据
  },
  data: function data() {
    return {
      applyTime: null, //申请结算时间
      refundApplyTime: null //申请退款时间
    };
  },

  watch: {
    commodityListDetails: {
      handler: function handler(newVal) {
        var refundApplyTime = newVal.refundApplyTime,
            applyTime = newVal.applyTime;

        this.refundApplyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(refundApplyTime);
        this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
      },

      deep: true
    }
  },
  created: function created() {
    var _commodityListDetails = this.commodityListDetails,
        refundApplyTime = _commodityListDetails.refundApplyTime,
        applyTime = _commodityListDetails.applyTime;

    if (refundApplyTime) {
      this.refundApplyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(refundApplyTime);
    }
    if (applyTime) {
      this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
    }
  }
});

/***/ }),

/***/ "AD07":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cookie__ = __webpack_require__("8EyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_message_message__ = __webpack_require__("kib/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_util__ = __webpack_require__("hhm8");








var ERR_OK = '200';
var ERR_TIME_OUT = '4';

var message = new __WEBPACK_IMPORTED_MODULE_4_base_message_message__["a" /* default */]();

function fetch(code, param) {
  var url = '/api' + code;
  var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, param);

  param = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
  var locale = window.localStorage.getItem('user_lang');
  var token = localStorage.getItem('access_token');
  return __WEBPACK_IMPORTED_MODULE_5_axios___default()({
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': JSON.parse(token) || '',
      "Accept-Language": locale === 'en_US' ? 'en_US' : 'zh_CN'
    },
    url: url,
    data: param
  }).then(function (res) {
    res = res.data;
    if (res.errorCode === ERR_TIME_OUT) {
      message.show('登录超时，请重新登录');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_common_js_util__["f" /* clearUser */])();
      setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_common_js_util__["g" /* goLogin */])();
      }, 800);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('timeout');
    }
    if (res.errorCode === 'A50004') {
      message.show('登录超时，请重新登录');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_common_js_util__["f" /* clearUser */])();
      setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_common_js_util__["g" /* goLogin */])();
      }, 800);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('timeout');
    }
    if (res.code !== ERR_OK) {
      if (res.errorInfo) {
        message.show(res.errorInfo.toString());
      } else if (res.errorMsg) {
        message.show(res.errorMsg.toString());
      } else {
        message.show(res.errorMsg || '操作失败');
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.errorInfo);
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

/***/ }),

/***/ "CjYO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DGkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('Toast',{ref:"toast",attrs:{"text":_vm.textMsg,"id":"toast"}}),_vm._v(" "),_c('FullLoading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"id":"fullLoading"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DbrZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsBAMAAACLU5NGAAAALVBMVEXu7u7IyMjf39/a2trc3NzU1NTQ0NDY2Nji4uLMzMzr6+vm5ubk5OTp6enh4eGI7drNAAACN0lEQVR42u3aP2tTURjH8YekabRpxd+QJkWRWsU5QcS1Fhe3BBfHZBL/IMZdSAcHnZrVKZPgIMR3kA46VxBHqe/E5CYkEG5yESTPA/1+lrt+OfceDueeYwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCFVbr9MMXRwFy90xJPzNF3LfXS3BS1wmtzstXWCrt987Epae/xQYp7PUkt89GRygNLVWpKFXOxLWnflshJGpqHTem6LXXq9RaPpXNbKidVzUNTZUtcuv8mZda1VTYP0rVJVS/18/4qmYOSdGJjdY08t0WXJY+VMSc1pk8p5YUVpH1bvw2pNhmVRNcW5KVDW7+N6Wj8UaKRMpo1W7d5VkeJq8GymmT9Q9YDJU6CZf1QohYsq6BEP1jWVk8jNyxYlv3SSDdclt3R3luLl2Vf+jb389nTYYyshaVQu2fRsiabtGq0rE9KnAfLaitRjZVV1NRZqKxjTbUiZW31NFWJlFXQTDdQ1k3NfIyTtaO5coCs3wcfpn8l5g7csx5JejXZbcxVvLPea+yFbWuBa1ZeE4efQ2V1NFFpRsoqaiZSVidkVlEhszohs/IKmVUPmZVXyKx6yKy8QmbVQ2bdUsisXswskfXfsnyOC64og8/hSk6ZBrZ+O8pkHprKUDYPp8pQNQ+bytAyDyVlGJqLulaqmI+CVmqYk2a8eRj3olTUa2Vm30JewhtfWbyb4mhgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJDtL06RqBuAz8PgAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_STATE", function() { return SET_USER_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_MAP", function() { return SET_USER_MAP; });
// 设置用户
var SET_USER_STATE = 'SET_USER_STATE';
// 设置聊过天的所有用户的头像、昵称
var SET_USER_MAP = 'SET_USER_MAP';

/***/ }),

/***/ "DyAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: '正在载入...'
    }
  }
});

/***/ }),

/***/ "EfWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_index_api__ = __webpack_require__("TGqv");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityList: {} //数据
  },
  data: function data() {
    return {
      orderTime: null //用户下单时间
    };
  },
  created: function created() {
    this.getPayment();
  },

  methods: {
    // 详情接口
    getPayment: function getPayment() {
      var _this = this;

      var params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["a" /* getDetail */])(params).then(function (res) {
        // 用户下单时间
        if (res.orderTime != undefined) {
          var orderTimeDate = new Date(res.orderTime);
          var YY4 = orderTimeDate.getFullYear() + '-';
          var MM4 = (orderTimeDate.getMonth() + 1 < 10 ? '0' + (orderTimeDate.getMonth() + 1) : orderTimeDate.getMonth() + 1) + '-';
          var DD4 = orderTimeDate.getDate() < 10 ? '0' + orderTimeDate.getDate() : orderTimeDate.getDate();
          var hh4 = (orderTimeDate.getHours() < 10 ? '0' + orderTimeDate.getHours() : orderTimeDate.getHours()) + ':';
          var mm4 = (orderTimeDate.getMinutes() < 10 ? '0' + orderTimeDate.getMinutes() : orderTimeDate.getMinutes()) + ':';
          var ss4 = orderTimeDate.getSeconds() < 10 ? '0' + orderTimeDate.getSeconds() : orderTimeDate.getSeconds();
          _this.orderTime = YY4 + MM4 + DD4 + " " + hh4 + mm4 + ss4;
        }
      });
    }
  }
});

/***/ }),

/***/ "Ej8v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgetPassword"},[_c('Tab',{attrs:{"title":"忘记密码"}}),_vm._v(" "),_c('div',{staticClass:"operation"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"code"},[_c('input',{attrs:{"type":"number","placeholder":"请输入验证码"}}),_vm._v(" "),_c('div',{class:_vm.countdown?'waitcode':'getcode'},[(!_vm.countdown)?_c('span',{on:{"click":function($event){return _vm.getCountdown()}}},[_vm._v("获取验证码")]):_c('span',[_vm._v("重新获取("+_vm._s(_vm.second)+"秒)")])])]),_vm._v(" "),_c('div',{staticClass:"newPad"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pwd),expression:"pwd"}],attrs:{"type":"password","placeholder":"新密码（不少于6位）"},domProps:{"value":(_vm.pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pwd=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"conPad"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repwd),expression:"repwd"}],attrs:{"type":"password","placeholder":"确认密码"},domProps:{"value":(_vm.repwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repwd=$event.target.value}}})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.confirm()}}},[_vm._v("确定")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone"},[_c('input',{attrs:{"type":"text","placeholder":"请输入手机号码"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FPsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sunRefund_vue__ = __webpack_require__("K8TN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83acff42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sunRefund_vue__ = __webpack_require__("HWDg");
function injectStyle (ssrContext) {
  __webpack_require__("Y3im")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83acff42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sunRefund_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83acff42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sunRefund_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FhWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fmky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_withdrawal_vue__ = __webpack_require__("INVZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6390ad36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdrawal_vue__ = __webpack_require__("aPQ+");
function injectStyle (ssrContext) {
  __webpack_require__("hSvd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6390ad36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_withdrawal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6390ad36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdrawal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GTrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__ = __webpack_require__("f2ku");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1101f2bd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__ = __webpack_require__("SfZo");
function injectStyle (ssrContext) {
  __webpack_require__("5uRJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1101f2bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1101f2bd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HAhm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HWDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completerecords"},[_c('Tab',{attrs:{"title":"详情"}}),_vm._v(" "),(_vm.isLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"completerecords-one"},[_c('div',{staticClass:"completerecords-one-lfet"},[_c('span',[_vm._v(_vm._s(_vm.titleName)+"金额")])]),_vm._v(" "),_c('div',{staticClass:"completerecords-one-right"},[_c('span',[_vm._v("\n        ¥\n        "),_c('span',{staticClass:"right-twoSpan"},[_vm._v(_vm._s(_vm.commodityList.totalAmount))])])])]),_vm._v(" "),_vm._l((_vm.commodityList.paymentGoodsList),function(item,index){return _c('div',{key:index,staticClass:"completerecords-two"},[_c('div',{staticClass:"completerecords-two-left"},[_c('img',{attrs:{"src":item.productNormsImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"completerecords-two-right"},[_c('div',{staticClass:"completerecords-two-right-one"},[_c('span',[_vm._v(_vm._s(_vm.ellipsis))]),_vm._v(" "),_c('span',[_vm._v("(货号:"+_vm._s(item.artNo)+")")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"right-one-span"},[_vm._v(_vm._s(item.productNormsName))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-two-right-two"},[_c('p',[_vm._v("\n          ¥\n          "),_c('span',{staticClass:"completerecords-span"},[_vm._v(_vm._s(item.costPrice))]),_vm._v(" "),_c('span',{staticClass:"completerecords-TwoSpan"},[_vm._v("x"+_vm._s(item.number))])]),_vm._v(" "),(_vm.id == '1')?_c('p',{staticClass:"right-p",on:{"click":function($event){return _vm.onClickEdit(item, index)}}},[_c('span',[_vm._v("修正数量")])]):_vm._e()])])])}),_vm._v(" "),_c('div',{staticClass:"completerecords-three"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("订单号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.commodityList.serialNumber))])]),_vm._v(" "),(_vm.moneyState)?_c('div',[_c('vForthe',{attrs:{"commodityList":_vm.commodityList}})],1):_vm._e(),_vm._v(" "),(_vm.refundOfState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('vAmountOf',{attrs:{"commodityList":_vm.commodityList}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"completerecords-four"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right"},[_c('p',[_vm._v(_vm._s(_vm.commodityList.sellerName))]),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right-TwoP"},[_c('img',{attrs:{"src":__webpack_require__("Q452"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.commodityList.phone))])])])]),_vm._v(" "),(_vm.refundOfState)?_c('div',[_c('div',{staticClass:"completerecords-four"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right"},[_c('p',[_vm._v(_vm._s(_vm.commodityList.contacts))]),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right-TwoP"},[_c('img',{attrs:{"src":__webpack_require__("1J1E"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.commodityList.bankAccountNum))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"completerecords-footer"},[_c('span',[_vm._v("\n      待结算金额\n      "),_c('span',{staticClass:"footer-span"},[_vm._v("¥"+_vm._s(_vm.commodityList.totalAmount))])]),_vm._v(" "),_c('van-button',{directives:[{name:"preventReClick",rawName:"v-preventReClick"}],staticClass:"footer-span-button",on:{"click":function($event){$event.preventDefault();return _vm.onclickSumbit.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.id != 1 ? "我已退款" : "结算"))])],1),_vm._v(" "),(_vm.editState)?_c('div',[_c('vEdit',{attrs:{"commodityData":_vm.commodityData},on:{"onClickOpen":_vm.onClickOpen,"onClickClose":_vm.cancel}})],1):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completerecords-four-left"},[_c('span',[_vm._v("商户信息")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completerecords-four-left"},[_c('span',[_vm._v("退款信息")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hgrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forRefund"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请退款时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.refundApplyTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I7UZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I7eg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "INVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    confirmWithdrawal: function confirmWithdrawal() {
      this.$router.push("/withdrawal/withdrawal_detail");
    },
    forget: function forget() {
      this.$router.push("/withdrawal/forget_password");
    }
  },
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ "JKiR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jf3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_index_api__ = __webpack_require__("TGqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__ = __webpack_require__("y/jF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details_accomplish__ = __webpack_require__("Yhcw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__details_cancel__ = __webpack_require__("ck3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__details_refund__ = __webpack_require__("RcBs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__details_settlement__ = __webpack_require__("p+YF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__details_forRefund__ = __webpack_require__("VrJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__details_settledAmount__ = __webpack_require__("hX0j");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 //已完成
 //已取消
 //已退回
 //结算中
 //退回中
 //已结算
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_2_base_tab_tab__["a" /* default */],
    Vaccomplish: __WEBPACK_IMPORTED_MODULE_3__details_accomplish__["a" /* default */],
    vCancel: __WEBPACK_IMPORTED_MODULE_4__details_cancel__["a" /* default */],
    vRefund: __WEBPACK_IMPORTED_MODULE_5__details_refund__["a" /* default */],
    vSettlement: __WEBPACK_IMPORTED_MODULE_6__details_settlement__["a" /* default */],
    vForRefund: __WEBPACK_IMPORTED_MODULE_7__details_forRefund__["a" /* default */],
    vSettledAmount: __WEBPACK_IMPORTED_MODULE_8__details_settledAmount__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true, //加载动画
      accomplishState: false, //已完成
      cancelledState: false, //已取消
      refundState: false, //已退回
      settlementState: false, //结算中
      settledAmountState: false, //已结算
      forRefundState: false, //退回中
      titleName: null, //完成状态
      totalAmount: 0, //总金额
      moneyData: 0, //待结算金额
      serialNumber: null, //订单号
      ellipsis: null, //显示字数
      commodityListDetails: "", //详情数据
      commodityList: [] //订单商品
    };
  },
  created: function created() {
    var _this = this;

    this.isLoading = true;
    this.getPayment(this.$route.query.id).then(function () {
      _this.titleName = _this.commodityList.statusName;
      // this.totalAmount = this.commodityList.totalAmount;
      // 待结算金额
      var f = Math.round(_this.commodityList.totalAmount * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      _this.totalAmount = s;
      _this.id = _this.commodityListDetails.status;
      // 限制title显示字数
      _this.commodityList.paymentGoodsList.forEach(function (item, index) {
        if (item.productName.length > 17) {
          // 限制字数17个字
          _this.ellipsis = item.productName.slice(0, 20) + "...";
        } else {
          _this.ellipsis = item.productName.slice(0, 20);
        }
      });
      if (_this.id == "3") {
        _this.settledAmountState = true;
      }
      if (_this.id == "4") {
        _this.accomplishState = true;
      }
      if (_this.id == "8") {
        _this.cancelledState = true;
      }
      if (_this.id == "7") {
        _this.refundState = true;
      }
      if (_this.id == "6") {
        _this.forRefundState = true;
      }
      if (_this.id == "2") {
        _this.settlementState = true;
      }
    }).finally(function () {
      _this.isLoading = false;
    });
  },

  methods: {
    // 详情接口
    getPayment: function getPayment() {
      var _this2 = this;

      var _$route$query = this.$route.query,
          serialNumber = _$route$query.serialNumber,
          sellerId = _$route$query.sellerId,
          status = _$route$query.status;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["a" /* getDetail */])({ serialNumber: serialNumber, sellerId: sellerId, status: status }).then(function (res) {
        _this2.commodityListDetails = res;
        _this2.commodityList = res;
      });
    }
  }
});

/***/ }),

/***/ "K8TN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_index_api__ = __webpack_require__("TGqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__ = __webpack_require__("y/jF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit__ = __webpack_require__("GTrk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amountOf__ = __webpack_require__("d6wY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forthe__ = __webpack_require__("xgP1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base_message_message__ = __webpack_require__("kib/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





 //修改数量
 //退款中
 //待结算


var message = new __WEBPACK_IMPORTED_MODULE_6_base_message_message__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_2_base_tab_tab__["a" /* default */],
    vEdit: __WEBPACK_IMPORTED_MODULE_3__edit__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__["a" /* default */],
    vAmountOf: __WEBPACK_IMPORTED_MODULE_4__amountOf__["a" /* default */],
    vForthe: __WEBPACK_IMPORTED_MODULE_5__forthe__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true, //加载动画
      totalPrices: 0, //总价
      editState: false, //修改数量状态
      refundOfState: false, //待退回
      moneyState: false, //待结算
      titleName: "", //完成状态
      typesData: "", // 交易种类
      ellipsis: null, //显示多少字符
      commodityData: "",
      moneyData: 0, //待结算金额
      //订单商品
      commodityList: []
    };
  },
  created: function created() {
    var _this = this;

    this.isLoading = true;
    this.getPayment().then(function () {
      // 待结算金额
      var f = Math.round(_this.commodityList.totalAmount * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      // console.log(s,'sssss')
      // this.totalAmount = s;
      _this.totalAmount = _this.commodityList.totalAmount;
      _this.titleName = _this.commodityList.statusName;
      _this.id = _this.commodityList.status;
      if (_this.id == "5") {
        _this.refundOfState = true;
      }
      if (_this.id == "1") {
        _this.moneyState = true;
      }
      // 限制title显示字数
      _this.commodityList.paymentGoodsList.forEach(function (item, index) {
        if (item.productName.length > 17) {
          // 限制字数17个字
          _this.ellipsis = item.productName.slice(0, 20) + "...";
        } else {
          _this.ellipsis = item.productName.slice(0, 20);
        }
      });
      _this.sunTotalAmount();
    }).finally(function () {
      _this.isLoading = false;
    });
  },

  methods: {
    // 详情接口
    getPayment: function getPayment() {
      var _this2 = this;

      var _$route$query = this.$route.query,
          serialNumber = _$route$query.serialNumber,
          sellerId = _$route$query.sellerId,
          status = _$route$query.status;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["a" /* getDetail */])({ serialNumber: serialNumber, sellerId: sellerId, status: status }).then(function (res) {
        _this2.commodityList = res;
      });
    },

    //供应商端单订单结算
    getApply: function getApply() {
      var _this3 = this;

      var params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["b" /* getSettleApply */])(params).then(function (res) {
        _this3.isLoading = true;
        message.show("结算成功");
        // Toast.success("结算成功");
        _this3.$router.push({
          path: "/order"
        });
      });
    },

    // 我已退款
    getRefunded: function getRefunded() {
      var _this4 = this;

      var params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["c" /* getSupplierRefunded */])(params).then(function (res) {
        _this4.isLoading = true;
        message.show("退款成功");
        // Toast.success("退款成功");
        _this4.$router.push({
          path: "/order"
        });
      });
    },
    onclickSumbit: function onclickSumbit() {
      if (this.id == "1") {
        this.getApply();
      }
      if (this.id == "5") {
        this.getRefunded();
      }
    },

    // 弹窗确定按钮
    onClickOpen: function onClickOpen(item) {
      if (item > 0) {
        this.commodityData.number = item; // 修改完的总数
        this.sunTotalAmount();
        this.getModification();
      }
      this.editState = false;
    },

    // 修改货款
    getModification: function getModification() {
      var params = {
        number: this.commodityData.number,
        id: this.commodityData.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_index_api__["d" /* getModify */])(params).then(function (res) {});
    },

    // 计算总金额
    sunTotalAmount: function sunTotalAmount() {
      var _this5 = this;

      this.commodityList.totalAmount = 0;
      this.commodityList.paymentGoodsList.map(function (i) {
        _this5.commodityList.totalAmount += Number(i.number) * Number(i.costPrice);
      });
    },

    // 弹窗关闭按钮
    cancel: function cancel() {
      this.editState = false;
    },

    // 修改数量
    onClickEdit: function onClickEdit(item, index) {
      this.editState = true;
      this.commodityData = item;
    }
  }
});

/***/ }),

/***/ "KqAE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Liaw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af1e7b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DGkh");
function injectStyle (ssrContext) {
  __webpack_require__("FhWl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af1e7b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = getVerificationCode;
/* harmony export (immutable) */ __webpack_exports__["b"] = changePwd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_fetch__ = __webpack_require__("BXx+");


// 登录 http://sys.malldev.hichengdai.com/api/core/v1/user/login/sys
function login(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/user/login/supplier", params);
}

// 获取手机验证码
function getVerificationCode(mobile) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/sms_out/permission_none/sms_code", {
    mobile: mobile,
    bizType: "FORGET_LOGINPWD"
  });
}

// 修改登录密码
function changePwd(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/user/forget_loginPwd", params);
}

/***/ }),

/***/ "Mkak":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MmhY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MzN/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N1OF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      flag: true //true 提现成功；false 提现失败
    };
  },

  methods: {
    handleBtn: function handleBtn() {
      if (this.flag) {
        this.$router.push('/goods_payment');
      } else {
        this.$router.push('/withdrawal');
      }
    }
  },
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "N5TS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settlement"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("用户下单时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请结算时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.applyTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_overlay_style__ = __webpack_require__("UuFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_overlay__ = __webpack_require__("J1XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_sticky_style__ = __webpack_require__("2Dfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_sticky__ = __webpack_require__("7e3Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_toast_style__ = __webpack_require__("eqfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_toast__ = __webpack_require__("/QYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_pull_refresh_style__ = __webpack_require__("yffH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_pull_refresh__ = __webpack_require__("sdMh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_button_style__ = __webpack_require__("3Lne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_es_button__ = __webpack_require__("SSsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vant_es_stepper_style__ = __webpack_require__("10Qn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_es_stepper__ = __webpack_require__("UQoe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vant_es_dialog_style__ = __webpack_require__("XmAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vant_es_dialog__ = __webpack_require__("il3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vant_es_tabs_style__ = __webpack_require__("jAcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant_es_tabs__ = __webpack_require__("86U2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vant_es_tab_style__ = __webpack_require__("yIEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vant_es_tab__ = __webpack_require__("OIh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vant_es_list_style__ = __webpack_require__("9++/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vant_es_list__ = __webpack_require__("QhyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_lazyload__ = __webpack_require__("AXdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_common_js_validate__ = __webpack_require__("rM4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_clipboard__ = __webpack_require__("TQvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_lang_zh__ = __webpack_require__("xZXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_lang_en__ = __webpack_require__("/uab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_default_passive_events__ = __webpack_require__("uJe8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_default_passive_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_default_passive_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_common_scss_index_scss__ = __webpack_require__("zO3H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_common_scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_common_scss_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__libs_rem_js__ = __webpack_require__("nM5b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__libs_rem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__libs_rem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_js_preventReClick__ = __webpack_require__("a752");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__base_toast_index__ = __webpack_require__("XJG4");

































// import VConsole from 'vconsole';

 //防多次点击，重复提交

__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].prototype.clipboard = __WEBPACK_IMPORTED_MODULE_28_clipboard___default.a;
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vant_es_list__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17_vant_es_tab__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vant_es_tabs__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vant_es_dialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vant_es_stepper__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vant_es_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vant_es_pull_refresh__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vant_es_toast__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vant_es_sticky__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_overlay__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_34__assets_js_preventReClick__["a" /* default */]);

// const isDebug = true;
// if (isDebug) {
//   new VConsole();
// }
// 全局引入Toast

__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_35__base_toast_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_25_vue_lazyload__["a" /* default */], {
  loading: __webpack_require__("DbrZ")
});

__WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_27_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_27_vue_i18n__["a" /* default */]({
  locale: localStorage.getItem("lang") || "zh",
  messages: {
    'zh': __WEBPACK_IMPORTED_MODULE_29__common_lang_zh__["a" /* default */],
    'en': __WEBPACK_IMPORTED_MODULE_30__common_lang_en__["a" /* default */]
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_21_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_23__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_24__store__["a" /* default */],
  i18n: i18n,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_22__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "OQ78":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PDPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goodsPayment"},[_c('Tab',{attrs:{"title":"货款","arrow":"hidden"}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"exhibition"},[_vm._m(0),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.goWithdrawal()}}},[_vm._v("提现")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('van-list',{attrs:{"finished":_vm.finished,"finished-text":"没有更多了"},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('div',{staticClass:"accountDetail"},[_c('p',{staticClass:"title"},[_vm._v("账户明细")]),_vm._v(" "),(_vm.list.length!=0)?_c('div',{staticClass:"practicallist"},[_c('div',{staticClass:"practical",on:{"click":function($event){return _vm.toDetial()}}},[_c('div',[_c('p',[_vm._v("货款")]),_vm._v(" "),_c('span',[_vm._v("订单号 7893478623587436578")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"plus"},[_vm._v("+123.00")])]),_vm._v(" "),_c('div',{staticClass:"practical"},[_c('div',[_c('p',[_vm._v("提现失败")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"plus"},[_vm._v("+23.00")])]),_vm._v(" "),_c('div',{staticClass:"practical"},[_c('div',[_c('p',[_vm._v("提现")]),_vm._v(" "),_c('span',[_vm._v("提现成功")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"reduce"},[_vm._v("-23.00")])]),_vm._v(" "),_c('div',{staticClass:"practical"},[_c('div',[_c('p',[_vm._v("退货款")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"reduce"},[_vm._v("-2000.00")])]),_vm._v(" "),_c('div',{staticClass:"practical"},[_c('div',[_c('p',[_vm._v("提现失败")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"plus"},[_vm._v("+23.00")])]),_vm._v(" "),_c('div',{staticClass:"practical"},[_c('div',[_c('p',[_vm._v("提现")]),_vm._v(" "),_c('span',[_vm._v("提现成功")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"reduce"},[_vm._v("-23.00")])]),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('div',{key:item,staticClass:"practical"},[_c('div',[_c('p',[_vm._v("退货款")]),_vm._v(" "),_c('span',[_vm._v("2019-07-07 11:02:00")])]),_vm._v(" "),_c('div',{staticClass:"reduce"},[_vm._v("-2000.00")])])})],2):_c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":"static/img/blank.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("您还没有账户明细哦")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("余额")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("¥")]),_vm._v(" "),_c('span',[_vm._v("12345.00")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('p',[_c('span',[_vm._v("累计货款(元)")]),_vm._v(" "),_c('span',[_vm._v("12345.00")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("累计提现(元)")]),_vm._v(" "),_c('span',[_vm._v("12345.00")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("提现中(元)")]),_vm._v(" "),_c('span',[_vm._v("12345.00")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PfiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__ = __webpack_require__("sNP6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9312cf5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__ = __webpack_require__("8YlR");
function injectStyle (ssrContext) {
  __webpack_require__("MzN/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9312cf5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9312cf5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q452":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAB1ElEQVQ4T63UQUgUURgH8P/3diA2yItBG3kSAiWkUxAeAiGKQBEkkA4uxM68j/XWISoo2ENB0cVL8N4bFjyEyh6FLPLiSUMlvAd5kA51cJHo1Ox7MaDLc1xldukd533/3/fNvJkh/OdFvqeUuiqEeOucuwPgixDiQRRFP7vp2QaNMbettctEVPSAz8x8tydQa70J4EY2HATBaKVS2ciLtifUWv8BcD4bJKI3UsqnvYAHAPo6gC+llC96AXcAXM8E1wuFwkQYhvtdg0qpd0Q06wW/ArjJzH/zYmmdf8r3nHMrXvigWCxeKZfL6bPNvdpgo9EoNJvNPQCXvfQzZn6dW/MnTEPGmCfOOR/4ba0drlarP/Kix76Uer1+IUmS7wAuesAHZh7vCUxDWusQQJwBHjHzXB702IRpwDlHxpg1ALc8IBFC3I+iaNkYMwVgVAixGobhpxPvbaeucRwPtFqtHSLq9/ZbAL4BGPKuvWLm575xYsKjTa31GICPAM6ddatE9FBKOX9UcyqYFiilpgG8J6LgDHSXmQdzgWlRHMeT1tqFTj+OQ+QXM1/KDR6e/AiARQDXMpMmRDQjpVzqCkyLa7VaUCqVQiKqABgGsE1Ej6WUW36Tf/VIjBWDHeA4AAAAAElFTkSuQmCC"

/***/ }),

/***/ "QcwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityListDetails: {} //数据
  },
  data: function data() {
    return {
      orderTime: null, //用户下单时间
      applyTime: null //申请结算时间
    };
  },

  watch: {
    commodityListDetails: {
      handler: function handler(newVal) {
        var orderTime = newVal.orderTime,
            applyTime = newVal.applyTime;

        this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(orderTime);
        this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
      },

      deep: true
    }
  },
  created: function created() {
    var _commodityListDetails = this.commodityListDetails,
        orderTime = _commodityListDetails.orderTime,
        applyTime = _commodityListDetails.applyTime;

    if (orderTime) {
      this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(orderTime);
    }
    if (applyTime) {
      this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
    }
  }
});

/***/ }),

/***/ "Qrsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.CloseState1)?_c('div',{staticClass:"settleAccounts"},[_c('div',{staticClass:"settleAccounts-center"},[_c('div',{staticClass:"settleAccounts-one"},[_c('img',{attrs:{"src":_vm.closeImg,"alt":""},on:{"click":_vm.onclickImg}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"settleAccounts-three"},[_c('div',{staticClass:"settleAccounts-three-left"},[_c('span',[_vm._v("当前可结算金额")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalToBeSettleAmount))])]),_vm._v(" "),_c('div',{staticClass:"settleAccounts-three-left",staticStyle:{"margin":"20px 0"}},[_c('span',[_vm._v("订单")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderNum)+"个")])]),_vm._v(" "),_c('div',{staticClass:"settleAccounts-three-left"},[_c('span',[_vm._v("商品")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.goodsNum)+"件")])]),_vm._v(" "),_c('div',{staticClass:"settleAccounts-footer"},[_c('van-button',{directives:[{name:"preventReClick",rawName:"v-preventReClick"}],staticClass:"settleAccounts-footer-button",on:{"click":_vm.onClickSumbit}},[_vm._v("提交结算申请")])],1)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settleAccounts-two"},[_c('p',[_vm._v("一键结算")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("KqAE"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RcBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refund_vue__ = __webpack_require__("0YHz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fabc2d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refund_vue__ = __webpack_require__("VksT");
function injectStyle (ssrContext) {
  __webpack_require__("MmhY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8fabc2d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refund_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fabc2d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refund_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RsMb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S6Ip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SfZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-dialog',{attrs:{"title":"修正数量","show-cancel-button":"","before-close":_vm.beforeClose},on:{"confirm":_vm.onClickOpen,"cancel":_vm.onClickClose},model:{value:(_vm.editState),callback:function ($$v) {_vm.editState=$$v},expression:"editState"}},[_c('div',{staticClass:"edit"},[_c('span',[_vm._v("采购数量:  "+_vm._s(_vm.commodityData.number)+"件")]),_vm._v(" "),_c('p',{staticClass:"edit-one"},[_c('span',[_vm._v("修正数量")]),_vm._v(" "),_c('van-stepper',{attrs:{"async-change":""},on:{"change":_vm.stepperChange},model:{value:(_vm.purchaseData),callback:function ($$v) {_vm.purchaseData=$$v},expression:"purchaseData"}})],1),_vm._v(" "),_c('p',[_vm._v("最终采购数量:  "+_vm._s(_vm.purchaseData)+"件")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Siir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      second: 60,
      countdown: false,
      pwd: "", // 密码
      repwd: "" // 确认密码
    };
  },

  methods: {
    getCountdown: function getCountdown() {
      var _this = this;

      this.countdown = true;
      var time = setInterval(function () {
        if (_this.second == 0) {
          _this.countdown = false;
          _this.second = 60;
          clearInterval(time);
        } else {
          --_this.second;
        }
      }, 1000);
    },
    confirm: function confirm() {
      var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_util_js__["h" /* rePwdValid */])(this.repwd, this.pwd);
    }
  },
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "SuOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgetPassword"},[_c('Tab',{attrs:{"title":"忘记密码"}}),_vm._v(" "),_c('div',{staticClass:"operation"},[_c('div',{staticClass:"phone"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],attrs:{"type":"text","placeholder":"请输入手机号码"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"code"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],attrs:{"type":"number","placeholder":"请输入验证码"},domProps:{"value":(_vm.code)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.code=$event.target.value},_vm.changeCode]}}),_vm._v(" "),_c('div',{class:_vm.countdown ? 'waitcode' : 'getcode'},[(!_vm.countdown)?_c('span',{on:{"click":function($event){return _vm.getCode()}}},[_vm._v("获取验证码")]):_c('span',[_vm._v("重新获取("+_vm._s(_vm.second)+"秒)")])])]),_vm._v(" "),_c('div',{staticClass:"newPad"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pwd),expression:"pwd"}],attrs:{"type":"password","placeholder":"新密码（不少于6位）"},domProps:{"value":(_vm.pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pwd=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"conPad"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.repwd),expression:"repwd"}],attrs:{"type":"password","placeholder":"确认密码"},domProps:{"value":(_vm.repwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.repwd=$event.target.value}}})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.confirm()}}},[_vm._v("确定")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T2s0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getSupplier;
/* harmony export (immutable) */ __webpack_exports__["h"] = getSupplierDisposable;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSupplierApply;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSupplierpage;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSettleApply;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSupplierRefunded;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDetail;
/* harmony export (immutable) */ __webpack_exports__["d"] = getModify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_fetch__ = __webpack_require__("BXx+");

// 供应商端账目统计
function getSupplier(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/supplier_statistic", params);
}
// 供应商端一键结算结算
function getSupplierDisposable(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/supplier_disposable_settle", params);
}
// 供应商端提交结算
function getSupplierApply(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/disposable_settle_apply", params);
}
//供应商端list列表
function getSupplierpage(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/supplier_page", params);
}
//供应商端单订单结算
function getSettleApply(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/settle_apply", params);
}
//供应商端我已退款
function getSupplierRefunded(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/supplier_refunded", params);
}
// 供应商端货款订单详情
function getDetail(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/payment_goods_detail", params);
}
// 供应商端修改货款明细
function getModify(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_fetch__["a" /* default */])("/core/v1/payment_goods/modify", params);
}

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "curChatUserId", function() { return curChatUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tencentLogined", function() { return tencentLogined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userMap", function() { return userMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unreadMsgNum", function() { return unreadMsgNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newMsg", function() { return newMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupList", function() { return groupList; });

var curChatUserId = function curChatUserId(state) {
  return state.curChatUserId;
};

var tencentLogined = function tencentLogined(state) {
  return state.tencentLogined;
};

var userMap = function userMap(state) {
  return state.userMap;
};

var unreadMsgNum = function unreadMsgNum(state) {
  return state.unreadMsgNum;
};

var newMsg = function newMsg(state) {
  return state.newMsg;
};

var groupList = function groupList(state) {
  return state.groupList;
};

/***/ }),

/***/ "UruN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACMUlEQVRIS6WUyY7TQBCGq7ptn4jY3yLAMHhJnPtMluEFuPAkIA48DdyQEDABiSWOF/mYF5k4zEix3YU6Glseb/EE3+y2v6+q+m8jAEAYhneTJPnAOX9jGEYgnx16hWH4ZLvdvtU07bWu65co4XEcnwOACQAXiqKcHCrxPO8pEX0HgMcA8FNV1Rl6nveNiE4KFV8AwOlwOPRv00UJvvuUiD5jEARGkiTniHjvUEkdHAD+EtEMJfR/JNfwHwDwqFDgDm7b9q+doE2iquqpruu142qAb4joTMIlNxfIG8dxDESsjKtO0gTnnM9M0/ydFX5DIB/6vq+naTov70lR0hVe6SCzSokQQkb3fl4JokzXGBGvZBSJqDjzTbnyxg46SOKu8MYO2iSls9FY+d4OOkg2jLGpZVl/2g5kZZPLL/u+/0wIIXP+sLS2FkKMR6ORe7CgBZ4x90oaO3Ac54gxJn9ceeVEtEHEuJguAFgzxsaWZdV2UisIguAoTdMKXNO0SZIkV0IIeU7yCLdJKoI6OABEqqpOdV1fyNl4nveiq+SGoAmOiNPBYLCDZ1dXSS5YLpfPEXFeSktUB88kYRgex3Esv3lQcK+JaGLb9jI/aBLOGJsTUTGKrfB9Es75xDTNJTbBFUWZGIbhtGU8W3Nd9xgAKp1ICbqu+wkAXhZA0W3geyRfcbFY9DjnXwBgJNNyCLxB4qRpOtlt8mq1uhNF0UdFUd53HUvT6K7H9a7X673q9/ubf1qNdip3qeRsAAAAAElFTkSuQmCC"

/***/ }),

/***/ "VMF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withrawalDetail",style:(_vm.flag?'background:#f4f5f8':'background:#fff')},[_c('Tab',{attrs:{"title":"提现详情"}}),_vm._v(" "),(_vm.flag)?_c('div',{staticClass:"success",on:{"click":function($event){_vm.flag=!_vm.flag}}},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_c('div',{staticClass:"fail",on:{"click":function($event){_vm.flag=!_vm.flag}}},[_c('img',{attrs:{"src":"/static/img/withdrawal_failure.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("提现申请失败")]),_vm._v(" "),_c('span',[_vm._v("请检查您的网络")])]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.handleBtn()}}},[_vm._v(_vm._s(_vm.flag?'确定':'重新提现'))])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sinformation"},[_c('img',{attrs:{"src":"/static/img/withdrawal_s.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("提现申请成功")]),_vm._v(" "),_c('span',[_vm._v("\n        等待审核\n        "),_c('br'),_vm._v("具体状态请在「货款」-「账户明细」中查看\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdetail"},[_c('div',[_c('p',[_vm._v("收款账户")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"","alt":""}}),_vm._v(" "),_c('span',[_vm._v("招商银行(6523)")])])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("提现金额")]),_vm._v(" "),_c('p',[_vm._v("500.00元")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VksT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refund"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请退款时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.refundApplyTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("确认退款时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.affirmRefundTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VrJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forRefund_vue__ = __webpack_require__("9CC4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6eb1f2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forRefund_vue__ = __webpack_require__("Hgrd");
function injectStyle (ssrContext) {
  __webpack_require__("0QnF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6eb1f2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forRefund_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6eb1f2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forRefund_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WA6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completerecords"},[_c('Tab',{attrs:{"title":"详情"}}),_vm._v(" "),(_vm.isLoading)?_c('loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"completerecords-one"},[_c('div',{staticClass:"completerecords-one-lfet"},[_c('span',[_vm._v(_vm._s(_vm.titleName)+"金额")])]),_vm._v(" "),_c('div',{staticClass:"completerecords-one-right"},[_c('span',{staticClass:"completerecords-one-right-oneSpan"},[_vm._v("\n        ¥\n        "),_c('span',{staticClass:"completerecords-one-right-twoSpan"},[_vm._v(_vm._s(_vm.totalAmount))])])])]),_vm._v(" "),_vm._l((_vm.commodityList.paymentGoodsList),function(isitem){return _c('div',{key:isitem.id,staticClass:"completerecords-two"},[_c('div',{staticClass:"completerecords-two-left"},[_c('img',{attrs:{"src":isitem.productNormsImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"completerecords-two-right"},[_c('div',{staticClass:"completerecords-two-right-one"},[_c('span',[_vm._v(_vm._s(_vm.ellipsis))]),_vm._v(" "),_c('span',[_vm._v("(货号:"+_vm._s(isitem.artNo)+")")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"right-one-span"},[_vm._v(_vm._s(isitem.productNormsName))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-two-right-two"},[_c('p',[_vm._v("\n          ¥\n          "),_c('span',{staticClass:"completerecords-span"},[_vm._v(_vm._s(isitem.costPrice))]),_vm._v(" "),_c('span',{staticClass:"completerecords-TwoSpan"},[_vm._v("x"+_vm._s(isitem.number))])])])])])}),_vm._v(" "),_c('div',{staticClass:"completerecords-three"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("订单号：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.commodityList.serialNumber))])]),_vm._v(" "),(_vm.cancelledState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('vCancel',{attrs:{"commodityListDetails":_vm.commodityListDetails}})],1):_vm._e(),_vm._v(" "),(_vm.refundState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('vRefund',{attrs:{"commodityListDetails":_vm.commodityListDetails}})],1):_vm._e(),_vm._v(" "),(_vm.accomplishState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('Vaccomplish',{attrs:{"commodityListDetails":_vm.commodityListDetails}})],1):_vm._e(),_vm._v(" "),(_vm.settledAmountState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('vSettledAmount',{attrs:{"commodityListDetails":_vm.commodityListDetails}})],1):_vm._e(),_vm._v(" "),(_vm.settlementState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('vSettlement',{attrs:{"commodityListDetails":_vm.commodityListDetails}})],1):_vm._e(),_vm._v(" "),(_vm.forRefundState)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('vForRefund',{attrs:{"commodityListDetails":_vm.commodityListDetails}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"completerecords-four"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right"},[_c('p',[_vm._v(_vm._s(_vm.commodityListDetails.sellerName))]),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right-TwoP"},[_c('img',{attrs:{"src":__webpack_require__("Q452"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.commodityListDetails.phone))])])])]),_vm._v(" "),(_vm.refundState || _vm.forRefundState)?_c('div',[_c('div',{staticClass:"completerecords-four"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right"},[_c('p',[_vm._v(_vm._s(_vm.commodityListDetails.contacts))]),_vm._v(" "),_c('div',{staticClass:"completerecords-four-right-TwoP"},[_c('img',{attrs:{"src":__webpack_require__("1J1E"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.commodityListDetails.bankAccountNum))])])])])]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completerecords-four-left"},[_c('span',[_vm._v("商户信息")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completerecords-four-left"},[_c('span',[_vm._v("退款信息")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WElz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var LANGUAGE = {
  '正在载入': {
    'zh': '正在载入...',
    'en': 'Loading...'
  },
  '已经全部加载完毕': {
    'zh': '已经全部加载完毕',
    'en': 'All loaded'
  },
  '不能为空': {
    'zh': '不能为空',
    'en': "Can't be empty"
  },
  '格式错误': {
    'zh': '格式错误',
    'en': 'Formatting error'
  },
  '只能包含数字': {
    'zh': '只能包含数字',
    'en': 'Only numbers'
  },
  '邮箱格式错误': {
    'zh': '邮箱格式错误',
    'en': 'Formatting error'
  },
  '手机号格式错误': {
    'zh': '手机号格式错误',
    'en': 'Formatting error'
  },
  '邮箱或手机号格式错误': {
    'zh': '邮箱或手机号格式错误',
    'en': 'Formatting error'
  },
  '密码格式不正确': {
    'zh': '密码格式不正确',
    'en': 'Formatting error'
  },
  '昵称2-20位': {
    'zh': '昵称2-20位',
    'en': 'Nickname 2-20'
  },
  '密码长度为6位且为数字': {
    'zh': '密码长度为6位且为数字',
    'en': 'The password length is 6 bits and is numeric'
  },
  '字母数字组合6-16位': {
    'zh': '字母数字组合6-16位',
    'en': 'Alphanumeric combination 6-16 bits'
  },
  '不能少于': {
    'zh': '不能少于',
    'en': 'No less than '
  },
  '不能多于': {
    'zh': '不能多于',
    'en': 'No more than '
  },
  '位': {
    'zh': '位',
    'en': ''
  },
  '系统消息：交易已下单，等待买家标记打款': {
    'zh': '系统消息：交易已下单，等待买家标记打款',
    'en': 'System Message: The transaction has placed an order waiting for the buyer to mark the payment'
  },
  '系统消息：订单支付超时，系统自动取消': {
    'zh': '系统消息：订单支付超时，系统自动取消',
    'en': 'System Message: Order payment timeout, system cancel automatically'
  },
  '系统消息：订单已取消': {
    'zh': '系统消息：订单已取消',
    'en': 'System Message: Order has cancelled'
  },
  '系统消息：买家已标记打款': {
    'zh': '系统消息：买家已标记打款',
    'en': 'System Message: Buyer has marked the payment'
  },
  '系统消息：卖家已释放': {
    'zh': '系统消息：卖家已释放',
    'en': 'System Message: Seller has released'
  },
  '系统消息：订单已申请仲裁': {
    'zh': '系统消息：订单已申请仲裁',
    'en': 'System Message: Order has applied for arbitration'
  },
  '系统消息：仲裁申请已处理完成': {
    'zh': '系统消息：仲裁申请已处理完成',
    'en': 'System Message: The arbitration application has been processed'
  },
  '系统消息：买家申请仲裁不通过，买家实际未付款，订单取消': {
    'zh': '系统消息：买家申请仲裁不通过，买家实际未付款，订单取消',
    'en': 'System Message: Buyer to apply for arbitration does not pass, the buyer is not actually paid, order cancelled'
  },
  '系统消息：买家申请仲裁通过，买家实际已付款，自动解冻': {
    'zh': '系统消息：买家申请仲裁通过，买家实际已付款，自动解冻',
    'en': 'System message: Buyer apply for arbitration through the buyer has actually paid, automatic thawing'
  },
  '系统消息：买家已评价': {
    'zh': '系统消息：买家已评价',
    'en': 'System Message: Buyer has evaluated'
  },
  '系统消息：卖家已评价': {
    'zh': '系统消息：卖家已评价',
    'en': 'System Message: Seller has evaluated'
  },
  // 流水
  '提交卖出[FMVP/ETH]委托单': {
    'ZH': '提交卖出[FMVP/ETH]委托单',
    'EN': 'Commit sell FMVP/ETH order'
  },
  '提交购买[FMVP/ETH]委托单': {
    'ZH': '提交购买[FMVP/ETH]委托单',
    'EN': 'Commit buy FMVP/ETH order'
  },
  '提交卖出[FMVP/BTC]委托单': {
    'ZH': '提交卖出[FMVP/BTC]委托单',
    'EN': 'Selling orders [FMVP/BTC]'
  },
  '提交购买[FMVP/BTC]委托单': {
    'ZH': '提交购买[FMVP/BTC]委托单',
    'EN': 'Buy FMVP/BTC order'
  },
  '充币-来自地址': {
    'zh': '充币-来自地址',
    'en': 'Charge-from address '
  },
  '充币-来自交易': {
    'zh': '充币-来自交易',
    'en': 'Charge-from transactional '
  },
  '充币-交易id': {
    'zh': '充币-交易id',
    'en': 'Charge-from id'
  },
  '充币-外部地址': {
    'zh': '充币-外部地址',
    'en': 'Charge-from external address'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  getText: function getText(text, lang) {
    if (lang === '' || !lang) {
      lang = window.localStorage.getItem('user_lang') || 'zh';
    }
    var t = LANGUAGE[text] && LANGUAGE[text][lang] ? LANGUAGE[text][lang] : '';
    if (!LANGUAGE[text] || t === '') {
      if (!LANGUAGE[text]) {
        t = text;
        console.log('[' + text + ']没有翻译配置');
      } else {
        if (!LANGUAGE[text]['zh']) {
          t = LANGUAGE[text]['en'];
        } else {
          t = LANGUAGE[text]['zh'];
        }
        console.log(lang + ': [' + text + ']没有翻译配置');
      }
    }
    return t;
  }
});

/***/ }),

/***/ "WHH4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_full_loading_vue__ = __webpack_require__("87vh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35430fd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_loading_vue__ = __webpack_require__("uKvY");
function injectStyle (ssrContext) {
  __webpack_require__("HAhm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35430fd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_full_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35430fd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_full_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wbwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_login__ = __webpack_require__("M9A7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  校验短信验证码、校验手机号



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: "",
      pwd: ""
    };
  },
  mounted: function mounted() {
    //   console.log(captValid);
  },

  methods: {
    logging: function logging() {
      var _this = this;

      var param = {
        loginName: this.name,
        loginPwd: this.pwd,
        userKind: "S"
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_login__["c" /* login */])(param).then(function (res) {
        var token = res.token;

        localStorage.setItem("access_token", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(token));
        _this.$router.push("/order");
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_util_js__["k" /* setUser */])(res);
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "WpgC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XJ4x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XJG4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toast_vue__ = __webpack_require__("m/lI");


var toast = {};
toast.install = function (vue) {
  var ToastCon = vue.extend(__WEBPACK_IMPORTED_MODULE_0__toast_vue__["a" /* default */]);
  var ins = new ToastCon();
  ins.$mount(document.createElement('div'));
  document.body.appendChild(ins.$el);
  vue.prototype.$toast = function (msg) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

    ins.message = msg;
    ins.visible = true;
    setTimeout(function () {
      ins.visible = false;
    }, duration);
  };
};
/* harmony default export */ __webpack_exports__["a"] = (toast);

/***/ }),

/***/ "Y3im":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pages_login_index__ = __webpack_require__("jT7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_login_forgetPassword__ = __webpack_require__("dzi2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_goodsPayment_index__ = __webpack_require__("c1re");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_goodsPayment_detail__ = __webpack_require__("PfiF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_withdrawal_withdrawal__ = __webpack_require__("Fmky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_withdrawal_withdrawalDetail__ = __webpack_require__("dUhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_withdrawal_forgetPassword__ = __webpack_require__("+bXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_completeRecords_completerecords__ = __webpack_require__("d1Q1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_completeRecords_order__ = __webpack_require__("r6TT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_completeRecords_details_sunRefund__ = __webpack_require__("FPsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_public_publicNote__ = __webpack_require__("qhpB");



// import OwnerRecord from 'pages/ownerRecord/ownerRecord';

// 登录


// 货款


// 提现



// 详情
// 完成金额

// 订单


// 公共详情页面


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    redirect: "/login"
  }, {
    path: "/login",
    component: __WEBPACK_IMPORTED_MODULE_2_pages_login_index__["a" /* default */]
  }, {
    path: "/login/forget_password",
    component: __WEBPACK_IMPORTED_MODULE_3_pages_login_forgetPassword__["a" /* default */]
  }, {
    path: "/order",
    component: __WEBPACK_IMPORTED_MODULE_10_pages_completeRecords_order__["a" /* default */]
  }, {
    path: "/goods_payment",
    component: __WEBPACK_IMPORTED_MODULE_4_pages_goodsPayment_index__["a" /* default */]
  }, {
    path: "/goods_payment/goods_payment_detail",
    component: __WEBPACK_IMPORTED_MODULE_5_pages_goodsPayment_detail__["a" /* default */]
  }, {
    path: "/withdrawal",
    component: __WEBPACK_IMPORTED_MODULE_6_pages_withdrawal_withdrawal__["a" /* default */]
  }, {
    path: "/withdrawal/withdrawal_detail",
    component: __WEBPACK_IMPORTED_MODULE_7_pages_withdrawal_withdrawalDetail__["a" /* default */]
  }, {
    path: "/withdrawal/forget_password",
    component: __WEBPACK_IMPORTED_MODULE_8_pages_withdrawal_forgetPassword__["a" /* default */]
  }, {
    path: "/complete/records",
    component: __WEBPACK_IMPORTED_MODULE_9_pages_completeRecords_completerecords__["a" /* default */]
  }, {
    path: "/sunRefund",
    component: __WEBPACK_IMPORTED_MODULE_11_pages_completeRecords_details_sunRefund__["a" /* default */]
  }, {
    path: "/publicNote",
    component: __WEBPACK_IMPORTED_MODULE_12_pages_public_publicNote__["a" /* default */]
  }, {
    path: "*",
    redirect: "/login"
  }],
  mode: "history",
  // mode: 'hash',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // vue滚动行为
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ "Yhcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accomplish_vue__ = __webpack_require__("//yH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73068314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accomplish_vue__ = __webpack_require__("sUnH");
function injectStyle (ssrContext) {
  __webpack_require__("subR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73068314"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accomplish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73068314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accomplish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ytfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"dialog-tips dialog-center",attrs:{"id":"toast"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZZgd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a752":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        // 防重复点击(指令实现)
        Vue.directive('preventReClick', {
            inserted: function inserted(el, binding) {
                el.addEventListener('click', function () {
                    if (!el.disabled) {
                        el.disabled = true;
                        setTimeout(function () {
                            el.disabled = false;
                        }, binding.value || 1500);
                    }
                });
            }
        });
    }
});

/***/ }),

/***/ "aPQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdrawal"},[_c('Tab',{attrs:{"title":"提现"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"paypwd"},[_c('p',[_vm._v("支付密码")]),_vm._v(" "),_c('input',{attrs:{"type":"number","placeholder":"请输入"}}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.forget()}}},[_vm._v("忘记密码")])]),_vm._v(" "),_c('button',{staticClass:"confirm",on:{"click":function($event){return _vm.confirmWithdrawal()}}},[_vm._v("确认提现")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank"},[_c('p',[_vm._v("提现至")]),_vm._v(" "),_c('div',{staticClass:"selectBank"},[_c('img',{attrs:{"src":"","alt":""}}),_vm._v(" "),_c('p',[_vm._v("招商银行")]),_vm._v(" "),_c('span',[_vm._v("尾号6666")])]),_vm._v(" "),_c('div',{staticClass:"arrowR"},[_c('img',{attrs:{"src":"static/img/list_arrow.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"money"},[_c('div',{staticClass:"write"},[_c('p',[_vm._v("提现金额")]),_vm._v(" "),_c('input',{attrs:{"type":"number","placeholder":"请输入提现金额"}})]),_vm._v(" "),_c('span',[_vm._v("可提现金额：888.88元")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aj2C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bFPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGgp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c1re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("3k5V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9d0ff5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("PDPJ");
function injectStyle (ssrContext) {
  __webpack_require__("mMua")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f9d0ff5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9d0ff5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c2uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_toast_style__ = __webpack_require__("eqfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__ = __webpack_require__("/QYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_index_api__ = __webpack_require__("TGqv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base_loading_loading__ = __webpack_require__("y/jF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orderForm_settleAccounts__ = __webpack_require__("vFEF");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // 一键结算

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_base_loading_loading__["a" /* default */],
    vSettleAccounts: __WEBPACK_IMPORTED_MODULE_7__orderForm_settleAccounts__["a" /* default */]
  },
  data: function data() {
    return {
      // offsetTop: "8.639rem",
      isLoadingState: true,
      pageIndex: 0, //页码
      pagesize: 10, // 每页条数
      isLoading: false, //控制下拉刷新的加载动画
      finished: false, // 上拉加载完毕
      isUpLoading: false, // 上拉加载
      totalToBeSettleAmount: 0, //待结算总额
      totalRefundAmount: 0, //待退回总金额
      totalSettlingAmount: 0, //结算中总金额
      totalSettleAmount: 0, //累计结算总金额
      offsetTopState: false,
      finishedText: null, //没数据提示样式
      ellipsis: null, //显示多少字符
      status: 0, //售后状态类型
      token: "", //登陆信息
      settleObj: {}, //一键结算数据
      CloseState: false, // 一键结算状态
      imgState: false, //购物车为空状态
      //订单商品
      shopList: [],
      // title
      wholeList: [{ id: "0", name: "全部" }, { id: "1", name: "待结算" }, { id: "2", name: "结算中" }, { id: "3", name: "已结算" }, { id: "4", name: "已完成" }, { id: "5", name: "待退款" }, { id: "6", name: "退款中" }, { id: "7", name: "已退款" }, { id: "8", name: "已取消" }],
      // 状态类型
      statusObj: {
        1: "待结算",
        2: "结算中",
        3: "已结算",
        4: "已完成",
        5: "待退款",
        6: "退款中",
        7: "已退款",
        8: "已取消"
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.onGetSupplier();
    this.onRequestList();
    var getuserInfo = JSON.parse(localStorage.getItem("access_token"));
    this.token = getuserInfo;
    window.addEventListener("beforeunload", function (e) {
      return _this2.beforeunloadHandler(e);
    });
    // this.$nextTick(() => {
    //   this.offsetTop = "45px";
    // });
  },
  created: function created() {
    var getStatus = JSON.parse(localStorage.getItem("status"));
    this.status = Number(getStatus);
  },
  destroyed: function destroyed() {
    var _this3 = this;

    window.removeEventListener("beforeunload", function (e) {
      return _this3.beforeunloadHandler(e);
    });
  },

  methods: {
    beforeunloadHandler: function beforeunloadHandler(e) {
      localStorage.removeItem("status");
    },

    // 下拉显示账目
    vanStickyScroll: function vanStickyScroll(event) {
      if (event.isFixed) {
        this.offsetTopState = true;
      } else {
        this.offsetTopState = false;
      }
    },

    // 结算中/已结算/已完成/已取消/退款中/已退款
    onClickShop: function onClickShop(e) {
      localStorage.setItem("status", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(e.status));
      if (e.status == 2 || e.status == 4 || e.status == 6 || e.status == 7 || e.status == 8 || e.status == 3 || this.status == 3 || this.status == 2 || this.status == 4 || this.status == 6 || this.status == 7 || this.status == 8) {
        this.$router.push({
          path: "/complete/records",
          query: {
            // id: this.status || e.status,
            // commodityName: e,
            serialNumber: e.serialNumber,
            sellerId: e.sellerId,
            status: e.status
          }
        });
      }
    },

    // 待结算/待退回
    onclickAccount: function onclickAccount(e, value) {
      localStorage.setItem("status", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(e.status));
      if (this.status == 1 || this.status == 5 || e.status == 1 || e.status == 5) {
        this.$router.push({
          path: "/sunRefund",
          query: {
            // id: this.status || e.status,
            // commodityName: e,
            serialNumber: e.serialNumber,
            sellerId: e.sellerId,
            status: e.status
          }
        });
      }
    },

    // 限制title显示字数
    controlTextList: function controlTextList(value) {
      var _this4 = this;

      value.forEach(function (item, index) {
        item.paymentGoodsList.forEach(function (e, index) {
          if (e.productName.length > 17) {
            // 限制字数17个字
            _this4.ellipsis = e.productName.slice(0, 20) + "...";
          } else {
            _this4.ellipsis = e.productName.slice(0, 20);
          }
        });
      });
    },

    //  提交结算申请
    onClickSumbit: function onClickSumbit() {
      var _this5 = this;

      var params = {
        Authorization: this.token
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_api_index_api__["e" /* getSupplierApply */])(params).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__["a" /* default */].success("提交成功");
        _this5.onGetSupplier();
        _this5.onRequestList();
        _this5.CloseState = false;
      });
    },

    // 首页List
    onRequestList: function onRequestList() {
      var _this6 = this;

      var _this = this;
      var params = {
        status: this.status,
        pageNum: this.pageIndex,
        pageSize: this.pagesize
      };
      this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_api_index_api__["f" /* getSupplierpage */])(params).then(function (res) {
        _this6.isLoading = false; //加载完毕。。。
        if (res) {
          _this6.controlTextList(res.list);
          res.list.map(function (item) {
            var totalAmountF = Math.round(item.totalAmount * 100) / 100;
            var totalAmountS = totalAmountF.toString();
            var totalAmountFS = totalAmountS.indexOf(".");
            if (totalAmountFS < 0) {
              totalAmountFS = totalAmountS.length;
              totalAmountS += ".";
            }
            while (totalAmountS.length <= totalAmountFS + 2) {
              totalAmountS += "0";
            }
            _this6.totalAmount = totalAmountS;
          });
          var resData = res.list.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
              statusName: _this6.statusObj[item.status]
            });
          });

          if (resData.length < _this6.pagesize) {
            // 最后一页不足10条的情况
            _this.finished = true;
          } else {
            _this.finished = false;
          }
          if (_this6.pageIndex == 1) {
            _this.shopList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(resData));
          } else {
            _this.shopList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.shopList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(resData));
          }
          if (_this.shopList.length == 0) {
            _this6.imgState = true;
            _this.finishedText = "";
          } else {
            _this6.imgState = false;
            _this.finishedText = "我是有底线的";
          }
        }
      }).catch(function (error) {
        // this.$message({
        //   showClose: true,
        //   message: '获取资源列表异常{' + error + '}',
        //   type: 'error'
        // })
      }).finally(function () {
        _this.isLoading = false;
        _this.isUpLoading = false;
      });
    },

    // 获取账目统计
    onGetSupplier: function onGetSupplier() {
      var _this7 = this;

      var getuserInfo = JSON.parse(localStorage.getItem("access_token"));
      var params = {
        Authorization: getuserInfo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_api_index_api__["g" /* getSupplier */])(params).then(function (res) {
        if (res) {
          _this7.isLoadingState = false;
          var resData = res;
          var str1 = resData.totalToBeSettleAmount.toString();
          var reg1 = str1.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
          var val1 = str1.replace(reg1, "$1,");
          _this7.totalToBeSettleAmount = val1;
          // 结算中
          var str = resData.totalSettlingAmount.toString();
          var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
          var val = str.replace(reg, "$1,");
          _this7.totalSettlingAmount = val;
          // 累计结算
          var str2 = resData.totalSettleAmount.toString();
          var reg2 = str2.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
          var val2 = str2.replace(reg2, "$1,");
          _this7.totalSettleAmount = val2;
          // 待退回
          var str3 = resData.totalRefundAmount.toString();
          var reg3 = str3.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
          var val3 = str3.replace(reg3, "$1,");
          _this7.totalRefundAmount = val3;
        } else {
          _this7.isLoadingState = true;
        }
      });
    },

    // 下拉刷新
    onRefresh: function onRefresh() {
      this.shopList = [];
      this.finished = false;
      this.pageIndex = 1;
      this.onGetSupplier();
      this.onRequestList();
    },
    //上拉加载
    onLoadList: function onLoadList() {
      if (this.isLoading == false && this.finished == false) {
        this.pageIndex++;
        this.onRequestList();
      }
    },

    //滑动
    change: function change(index, item) {
      this.status = index;
      this.shopList = [];
      this.pageIndex = 1;
      this.finished = false;
      this.isLoading = true; //清空数据
      this.onGetSupplier();
      this.onRequestList();
    },

    //点击
    onclickHighlight: function onclickHighlight(index, item) {
      this.status = index;
      this.shopList = [];
      this.pageIndex = 1;
      this.finished = false;
      this.isLoading = true; //清空数据
      this.onGetSupplier();
      this.onRequestList();
    },

    // 关闭一键结算弹窗
    onclickImg: function onclickImg() {
      this.CloseState = false;
      var mo = function mo(e) {
        e.stopImmediatePropagation();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },

    //一键结算
    getrDisposable: function getrDisposable() {
      var _this8 = this;

      var params = {
        Authorization: this.token
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_api_index_api__["h" /* getSupplierDisposable */])(params).then(function (res) {
        if (res) {
          _this8.settleObj = res;
        }
      });
    },

    // 一键结算操作
    onclickClose: function onclickClose() {
      this.CloseState = true;
      this.getrDisposable();
      var mo = function mo(e) {
        e.stopImmediatePropagation();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false);
    }
  }
});

/***/ }),

/***/ "ci21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"operation"},[_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","placeholder":"请输入账号"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pwd),expression:"pwd"}],attrs:{"type":"password","placeholder":"请输入密码（6～16个字符或字母组成）"},domProps:{"value":(_vm.pwd)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logging()},"input":function($event){if($event.target.composing){ return; }_vm.pwd=$event.target.value}}})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.logging()}}},[_vm._v("登  录")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.$router.push('/login/forget_password')}}},[_vm._v("忘记密码？")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"lefe"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("登录")]),_vm._v(" "),_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"static/img/dl_logo.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("怀南会供应商结算中心")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ck3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancel_vue__ = __webpack_require__("wiYR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b67f773_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancel_vue__ = __webpack_require__("q6NO");
function injectStyle (ssrContext) {
  __webpack_require__("lfvQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b67f773"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b67f773_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d1Q1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_completerecords_vue__ = __webpack_require__("Jf3p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a1b15a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_completerecords_vue__ = __webpack_require__("WA6y");
function injectStyle (ssrContext) {
  __webpack_require__("lqk2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47a1b15a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_completerecords_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a1b15a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_completerecords_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d22Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d6wY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amountOf_vue__ = __webpack_require__("+vrv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3285d508_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amountOf_vue__ = __webpack_require__("6G2o");
function injectStyle (ssrContext) {
  __webpack_require__("Liaw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3285d508"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_amountOf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3285d508_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_amountOf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dUhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_withdrawalDetail_vue__ = __webpack_require__("N1OF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b203776_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdrawalDetail_vue__ = __webpack_require__("VMF8");
function injectStyle (ssrContext) {
  __webpack_require__("5WXv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b203776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_withdrawalDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b203776_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_withdrawalDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dzi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgetPassword_vue__ = __webpack_require__("pO/e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1cd196a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgetPassword_vue__ = __webpack_require__("SuOM");
function injectStyle (ssrContext) {
  __webpack_require__("Mkak")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1cd196a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1cd196a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eh36":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f2ku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityData: {}
  },
  data: function data() {
    return {
      editState: true,
      resultData: '0', //最终采购数量
      purchaseData: "0" //采购数量
    };
  },
  created: function created() {
    this.purchaseData = this.commodityData.number;
  },

  methods: {
    stepperChange: function stepperChange(v) {
      if (v < 1) {
        this.purchaseData = 1;
      }
    },
    onClickOpen: function onClickOpen() {
      this.$emit("onClickOpen", this.purchaseData);
    },

    // 关闭
    onClickClose: function onClickClose() {
      this.$emit("onClickClose");
    }
  }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "hFqa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/youhuiquan_blank.c48700e.png";

/***/ }),

/***/ "hSvd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hVqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util_js__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityListDetails: {} //数据
  },
  data: function data() {
    return {
      orderTime: null, //用户下单时间
      applyTime: null, //申请结算时间
      settleTime: null //确认结算时间
    };
  },

  watch: {
    commodityListDetails: {
      handler: function handler(newVal) {
        var orderTime = newVal.orderTime,
            applyTime = newVal.applyTime,
            settleTime = newVal.settleTime;

        this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(orderTime);
        this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
        this.settleTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(settleTime);
      },

      deep: true
    }
  },
  created: function created() {
    var _commodityListDetails = this.commodityListDetails,
        orderTime = _commodityListDetails.orderTime,
        applyTime = _commodityListDetails.applyTime,
        settleTime = _commodityListDetails.settleTime;

    if (orderTime) {
      this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(orderTime);
    }
    if (applyTime) {
      this.applyTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(applyTime);
    }
    if (settleTime) {
      this.settleTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util_js__["e" /* formatDate */])(settleTime);
    }
  }
});

/***/ }),

/***/ "hW8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hX0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settledAmount_vue__ = __webpack_require__("hVqc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69476ef8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settledAmount_vue__ = __webpack_require__("2aYV");
function injectStyle (ssrContext) {
  __webpack_require__("OQ78")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69476ef8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settledAmount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69476ef8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settledAmount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hhm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = formatDate;
/* unused harmony export timestampToTime */
/* unused harmony export isUndefined */
/* unused harmony export getUserId */
/* harmony export (immutable) */ __webpack_exports__["k"] = setUser;
/* unused harmony export getSign */
/* unused harmony export getAccountType */
/* unused harmony export getTxAppCode */
/* unused harmony export getTencentParams */
/* harmony export (immutable) */ __webpack_exports__["f"] = clearUser;
/* harmony export (immutable) */ __webpack_exports__["g"] = goLogin;
/* unused harmony export isLogin */
/* unused harmony export getLangType */
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslateText;
/* harmony export (immutable) */ __webpack_exports__["b"] = isUnDefined;
/* unused harmony export formatImg */
/* harmony export (immutable) */ __webpack_exports__["c"] = formatAvatar;
/* unused harmony export formatAvatarSyl */
/* unused harmony export formatAmount */
/* unused harmony export moneyReplaceComma */
/* unused harmony export formatMoneyMultiply */
/* unused harmony export formatMoneySubtract */
/* unused harmony export getCoinData */
/* unused harmony export getCoinList */
/* unused harmony export getCoinUnit */
/* unused harmony export getUrlParam */
/* unused harmony export getPic */
/* unused harmony export getAvatar */
/* unused harmony export getPercentum */
/* unused harmony export ISIOS */
/* unused harmony export setTitle */
/* unused harmony export debounce */
/* unused harmony export clearTag */
/* unused harmony export isFunction */
/* unused harmony export getImgData */
/* unused harmony export setWxMobAndCapt */
/* unused harmony export getWxMobAndCapt */
/* harmony export (immutable) */ __webpack_exports__["j"] = captValid;
/* harmony export (immutable) */ __webpack_exports__["i"] = mobileValid;
/* unused harmony export CheckMail */
/* unused harmony export tradeValid */
/* harmony export (immutable) */ __webpack_exports__["h"] = rePwdValid;
/* unused harmony export nicknameValid */
/* unused harmony export realNameValid */
/* unused harmony export bankNameValid */
/* unused harmony export subbranchValid */
/* unused harmony export bankcardNumberValid */
/* unused harmony export amountValid */
/* unused harmony export emptyValid */
/* unused harmony export addressValid */
/* harmony export (immutable) */ __webpack_exports__["d"] = calcSpace;
/* unused harmony export formatChatDate */
/* unused harmony export calculateDays */
/* unused harmony export deepCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cookie__ = __webpack_require__("8EyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BigDecimal__ = __webpack_require__("papl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BigDecimal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BigDecimal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_language__ = __webpack_require__("WElz");





// import {setProfilePortrait} from 'common/js/message';

// 日期格式化
function formatDate(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm:ss';

  date = new Date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function timestampToTime(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var strDate = h + m;
  return strDate;
}

/**
 * 是否是空
 * @param value
 */
function isUndefined(value) {
  return value === undefined || value === null || value === '';
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

// 获取userId
function getUserId() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["a" /* getCookie */])('userId') || '';
}

// 保存用户登录信息
function setUser(data) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["b" /* setCookie */])('userId', data.userId);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["b" /* setCookie */])('token', data.token);
}

// 获取腾讯云登录的sig
function getSign() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["a" /* getCookie */])('__sign__') || '';
}

// 获取腾讯云登录的accountType
function getAccountType() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["a" /* getCookie */])('__accountType__') || '';
}

// 获取腾讯云登录的txAppCode
function getTxAppCode() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["a" /* getCookie */])('__txAppCode__') || '';
}

// 获取腾讯云登录的参数
function getTencentParams() {
  return {
    sig: getSign(),
    accountType: getAccountType(),
    txAppCode: getTxAppCode()
  };
}

// 删除用户登录信息
function clearUser() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["c" /* delCookie */])('userId');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["c" /* delCookie */])('token');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["c" /* delCookie */])('__sign__');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["c" /* delCookie */])('__accountType__');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["c" /* delCookie */])('__txAppCode__');
  window.localStorage.removeItem('__message__');
  window.localStorage.removeItem('__usermap__');
  webim && webim.logout();
  sessionStorage.clear();
}

// 跳转登陆
function goLogin() {
  location.href = location.href.split('://')[0] + '://' + location.host + '/login';
}

// 是否登录
function isLogin() {
  return !!getUserId();
}

// 获取当前语言
function getLangType() {
  var locale = window.localStorage.getItem('user_lang') || 'zh';
  return locale;
}

// 获取当前语言
function getTranslateText(text, lang) {
  return __WEBPACK_IMPORTED_MODULE_4__lang_language__["a" /* default */].getText(text, lang);
}

// 是否为空
function isUnDefined(value) {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return false;
}

// 格式化图片地址
function formatImg(imgs) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?imageMogr2/auto-orient';

  if (!imgs) {
    return '';
  }
  var img = imgs.split(/\|\|/)[0];

  if (!/^http|^data:image/i.test(img)) {
    var index = img.indexOf('?imageMogr2');
    if (index !== -1) {
      suffix = img.substr(index);
      img = img.substr(0, index);
    }
    img = PIC_PREFIX + encodeURIComponent(img) + suffix;
  }
  return img;
}

// 格式化头像
function formatAvatar(img) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?imageMogr2/auto-orient';

  return isUnDefined(img) ? avatarDefault : formatImg(img, suffix);
}

// 格式化头像 - backgroundImage
function formatAvatarSyl(imgs) {
  var img = isUnDefined(imgs) ? avatarDefault : formatImg(imgs);
  return {
    backgroundImage: 'url(' + img + ')'
  };
}

/**
 * 金额格式转化 根据币种格式化金额
 * @param money
 * @param format
 * @param coin 币种
 * @param isRe 是否去零
 */
function formatAmount(money, format, coin) {
  var isRe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (money.toString() === '0') {
    return 0;
  }
  var unit = coin && getCoinData()[coin] ? getCoinUnit(coin) : '1000';
  var flag = false; // 是否是负数
  if (isNaN(money)) {
    return '-';
  } else {
    money = Number(money);
  }
  if (money < 0) {
    money = -1 * money;
    flag = true;
  }
  if (coin && isUnDefined(format)) {
    format = 4;
  } else if (isUnDefined(format) || (typeof format === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(format)) === 'object') {
    // 默认格式为2位小数
    format = 2;
  }
  // 金额格式化 金额除以unit并保留format位小数
  money = new BigDecimal(money.toString());
  money = money.divide(new BigDecimal(unit), format, MathContext.ROUND_DOWN).toString();

  // 是否去零
  if (isRe) {
    var re = /\d{1,3}(?=(\d{3})+$)/g;
    money = money.replace(/^(\d+)((\.\d+)?)$/, function (s, s1, s2) {
      return s1.replace(re, '$&,') + s2;
    });
  }
  if (flag) {
    money = '-' + money;
  }
  return money;
}

/**
 * 把格式化金额去掉逗号
 * @param money
 */
function moneyReplaceComma(money) {
  return ('' + money).replace(/,/g, '');
}

/**
 * 金额放大 根据币种的单位把金额放大
 * @param money
 * @param format
 * @param coin 币种
 */
function formatMoneyMultiply(money, rate, coin) {
  var unit = coin && getCoinData()[coin] ? getCoinUnit(coin) : '1000';

  if (isUnDefined(money) || money === '') {
    return '-';
  } else {
    money = Number(money).toString();
  }
  rate = rate || new BigDecimal(unit);
  money = new BigDecimal(money);
  money = money.multiply(rate).toString();
  return money;
}

/**
 * 金额减法 s1 - s2
 * @param s1
 * @param s2
 * @param coin 币种
 */
function formatMoneySubtract(s1, s2, format, coin) {
  if (isUnDefined(s1) || isUnDefined(s2) || s1 === '' || s2 === '') {
    return '-';
  } else {
    s1 = Number(s1);
    s2 = Number(s2);
  }
  var num1 = new BigDecimal(s1.toString());
  var num2 = new BigDecimal(s2.toString());
  return formatAmount(num1.subtract(num2).toString(), format, coin);
}

/**
 * 获取币种Data
 * return {
 *  'BTC': {
 *      'coin': 'BTC',
 *      'unit': '1e8',
 *      'name': '比特币',
 *      'type': '0',
 *      'status': '0'
 *  }
 *}
 */
function getCoinData() {
  var coinData = sessionStorage.getItem('coinData');
  if (coinData) {
    return JSON.parse(coinData);
  } else {
    return false;
  }
}

/**
 * 获取币种列表
 * return [{
 *      key: 'BTC',
 *      value: '比特币'
 *}]
 */
function getCoinList() {
  return JSON.parse(sessionStorage.getItem('coinList'));
}

// 获取币种unit
function getCoinUnit(coin) {
  if (!coin) {
    console.log('coin不能为空');
    return;
  }
  var unit = getCoinData()[coin].unit;
  return unit;
}

//获取链接入参
function getUrlParam(name, locat) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var locat = locat ? "?" + locat.split("?")[1] : '';
  var r = (locat ? locat : window.location.search).substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return '';
}

//图片格式化
function getPic(pic, suffix) {
  if (!pic) {
    return "";
  }
  pic = pic.split(/\|\|/)[0];
  if (!/^http|^data:image/i.test(pic)) {
    suffix = suffix || "?imageMogr2/auto-orient/interlace/1";
    pic = PIC_PREFIX + pic + suffix;
  }
  return {
    backgroundImage: 'url(' + pic + ')'
  };
}

//图片格式化-头像
var PHOTO_SUFFIX = '?imageMogr2/auto-orient/thumbnail/!150x150r';
function getAvatar(pic, suffix) {
  var defaultAvatar = '';
  var suffix = suffix || PHOTO_SUFFIX;
  if (!pic) {
    pic = defaultAvatar;
  }
  return getPic(pic, suffix);
}

//计算百分比
function getPercentum(n1, n2) {
  if (n1 == '0' && n2 == '0') {
    return '0';
  }
  var n = n1 / n2 * 100;
  return parseInt(n) + "%";
}
// 判断是否 ios
var ISIOS = /(iphone|ipod|ipad)/i.test(navigator.userAgent);

// 微信设置页面标题
function setTitle(title) {
  if (document.title !== title) {
    document.title = title;
    if (ISIOS) {
      var iframe = document.createElement('iframe');
      iframe.src = '//m.baidu.com/favicon.ico';
      iframe.style.display = 'none';
      iframe.onload = function () {
        setTimeout(function () {
          iframe.remove();
        }, 9);
      };
      document.body.appendChild(iframe);
    }
  }
}

// 延时函数的执行
function debounce(func, delay) {
  var timer = void 0;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, delay);
  };
}

// 清除内容里的标签
function clearTag(content) {
  return content.replace(/<[^>]+>|<\/[^>]+>|<[^>]+\/>|&nbsp;/ig, '');
}

// 是否是function
function isFunction(fn) {
  var getType = {};
  return fn && getType.toString.call(fn) === '[object Function]';
}

// 获取图片base64
function getImgData(fileType, img, dir, next) {
  var image = new Image();
  image.onload = function () {
    var degree = 0;
    var drawWidth = void 0;
    var drawHeight = void 0;
    var width = void 0;
    var height = void 0;
    drawWidth = this.naturalWidth;
    drawHeight = this.naturalHeight;
    var canvas = document.createElement('canvas');
    canvas.width = width = drawWidth;
    canvas.height = height = drawHeight;
    var context = canvas.getContext('2d');
    // 判断图片方向，重置canvas大小，确定旋转角度，iphone默认的是home键在右方的横屏拍摄方式
    switch (dir) {
      // iphone横屏拍摄，此时home键在左侧
      case 3:
        degree = 180;
        drawWidth = -width;
        drawHeight = -height;
        break;
      // iphone竖屏拍摄，此时home键在下方(正常拿手机的方向)
      case 6:
        canvas.width = height;
        canvas.height = width;
        degree = 90;
        drawWidth = width;
        drawHeight = -height;
        break;
      // iphone竖屏拍摄，此时home键在上方
      case 8:
        canvas.width = height;
        canvas.height = width;
        degree = 270;
        drawWidth = -width;
        drawHeight = height;
        break;
    }
    // 使用canvas旋转校正
    context.rotate(degree * Math.PI / 180);
    context.drawImage(this, 0, 0, drawWidth, drawHeight);
    // 返回校正图片
    next(canvas.toDataURL(fileType, 0.8));
  };
  image.src = img;
}

// 设置微信登录时填写的手机号和验证码
function setWxMobAndCapt(mobile, captcha) {
  sessionStorage.setItem('__mob__', mobile);
  sessionStorage.setItem('__capt__', captcha);
}

// 获取微信登录时填写的手机号和验证码
function getWxMobAndCapt() {
  var mobile = sessionStorage.getItem('__mob__');
  var captcha = sessionStorage.getItem('__capt__');
  sessionStorage.removeItem('__mob__');
  sessionStorage.removeItem('__capt__');
  if (mobile && captcha) {
    return {
      mobile: mobile,
      captcha: captcha
    };
  }
  return null;
}

// 校验短信验证码
function captValid(capt) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(capt)) {
    result.err = 1;
    result.msg = '验证码不能为空';
  } else if (!/^\d{4}$/.test(capt)) {
    result.err = 1;
    result.msg = '验证码格式错误';
  }
  return result;
}

// 校验手机号
function mobileValid(mobile) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(mobile)) {
    result.err = 1;
    result.msg = '手机号码不能为空';
  } else if (!/^1[3|4|5|6|7|8]\d{9}$/.test(mobile)) {
    result.err = 1;
    result.msg = '手机号码格式错误';
  }
  return result;
}

// 检验邮箱格式
function CheckMail(mail) {
  var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (filter.test(mail)) {
    return true;
  } else {
    return false;
  }
}

// 支付密码校验
function tradeValid(trade) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(trade)) {
    result.err = 1;
    result.msg = '不能为空';
  } else if (trade.length < 6) {
    result.err = 1;
    result.msg = '长度不能小于6位';
  }
  return result;
}

// 校验第二次密码是否和第一次相同
function rePwdValid(rePwd, pwd) {
  // console.log(rePwd,'确认密码')
  console.log(pwd, '密码');
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(rePwd)) {
    result.err = 1;
    result.msg = '密码不能为空';
  } else if (pwd.length < 6) {
    result.err = 1;
    result.msg = '密码不能小于六位数';
  } else if (pwd !== rePwd) {
    result.err = 1;
    result.msg = '两次密码不同';
  }
  return result;
}

// 昵称校验
function nicknameValid(nickname) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(nickname)) {
    result.err = 1;
    result.msg = '昵称不能为空';
    // } else if (nickname.length > 20) {
    //   result.err = 1;
    //   result.msg = '昵称不能超过20位';
  }
  return result;
}

// 真实姓名校验
function realNameValid(realName) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(realName)) {
    result.err = 1;
    result.msg = '不能为空';
  } else if (realName.length > 16) {
    result.err = 1;
    result.msg = '不能超过16位';
  }
  return result;
}
// 银行名称校验
function bankNameValid(bankName) {
  return realNameValid(bankName);
}
// 支行校验
function subbranchValid(subbranch) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(subbranch)) {
    result.err = 1;
    result.msg = '不能为空';
  } else if (subbranch.length > 255) {
    result.err = 1;
    result.msg = '不能超过255位';
  }
  return result;
}

// 银行卡号校验
function bankcardNumberValid(bankcardNumber) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(bankcardNumber)) {
    result.err = 1;
    result.msg = '不能为空';
  } else if (!/^(\d{16}|\d{19})$/.test(bankcardNumber)) {
    result.err = 1;
    result.msg = '格式错误';
  }
  return result;
}

// 金额校验
function amountValid(amount) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(amount)) {
    result.err = 1;
    result.msg = '不能为空';
  } else if (!/^\d+(?:\.\d{1,2})?$/.test(amount)) {
    result.err = 1;
    result.msg = '最多两位小数';
  }
  return result;
}

// 非空校验
function emptyValid(value) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(value)) {
    result.err = 1;
    result.msg = '不能为空';
  }
  return result;
}

// 地址校验
function addressValid(value) {
  var result = {
    err: 0,
    msg: ''
  };
  if (isUnDefined(value)) {
    result.err = 1;
    result.msg = '不能为空';
  } else if (value.length > 50) {
    result.err = 1;
    result.msg = '长度不能超过50位';
  }
  return result;
}

/**
 * 获取用户登录系统的时间间隔
 * @param {yyyy-MM-dd-hh-mm} beforeTime
 */
function calcSpace(beforeTime) {
  var now = formatDate(new Date().getTime(), 'yyyy-MM-dd-hh-mm').split('-');
  var before = beforeTime.split('-');
  var nowYear = +now[0];
  var beforeYear = +before[0];
  var nowMonth = +now[1];
  var beforeMonth = +before[1];
  if (nowYear > beforeYear) {
    var diffY = nowYear - beforeYear;
    var diffM = diffY * 12 + nowMonth - beforeMonth;
    return diffM < 12 ? diffM + '月前来过' : diffY + '年前来过';
  }
  if (nowMonth > beforeMonth) {
    return nowMonth - beforeMonth + '月前来过';
  }
  var nowDay = now[2];
  var beforeDay = before[2];
  if (nowDay > beforeDay) {
    return nowDay - beforeDay + '天前来过';
  }
  var nowHour = now[3];
  var beforeHour = before[3];
  if (nowHour > beforeHour) {
    return nowHour - beforeHour + '小时前来过';
  }
  var nowMinute = now[4];
  var beforeMinute = before[4];
  var diffMinute = nowMinute - beforeMinute;
  return diffMinute <= 5 ? '刚刚来过' : diffMinute + '分钟前来过';
}

// 聊天日期格式化
function formatChatDate(timeStamp, param) {
  var now = new Date();
  var nowStamp = now.getTime();
  var before = new Date(timeStamp);
  var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  var oneDay = 3600000 * 24;
  var sevenDay = 7 * oneDay;
  var twoDay = 2 * oneDay;
  if (nowStamp - timeStamp > sevenDay) {
    return param ? formatDate(timeStamp, 'yyyy年MM月dd日 hh:mm') : formatDate(timeStamp, 'yyyy/MM/dd');
  }
  if (nowStamp - timeStamp > twoDay) {
    return param ? week[before.getDay()] + ' ' + formatDate(timeStamp, 'hh:mm') : week[before.getDay()];
  }
  if (now.getDate() === before.getDate()) {
    return formatDate(timeStamp, 'hh:mm');
  }
  var _before = new Date(timeStamp);
  _before.setDate(_before.getDate() + 1);
  if (_before.getDate() === now.getDate()) {
    return param ? '昨天 ' + formatDate(timeStamp, 'hh:mm') : '昨天';
  }
  return param ? week[before.getDay()] + ' ' + formatDate(timeStamp, 'hh:mm') : week[before.getDay()];
}

//计算日期相隔时间
function calculateDays(start, end) {
  if (!start || !end) return 0;
  start = new Date(start);
  end = new Date(end);
  return (end - start) / (60 * 1000);
}

// 深拷贝
function deepCopy(initalObj, finalObj) {
  var obj = finalObj || {};
  for (var i in initalObj) {
    var prop = initalObj[i];
    // 避免相互引用对象导致死循环，如initalObj.a = initalObj的情况
    if (prop === obj) {
      continue;
    }
    if ((typeof prop === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(prop)) === 'object') {
      obj[i] = prop.constructor === Array ? [] : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(prop);
    } else {
      obj[i] = prop;
    }
  }
  return obj;
}

/***/ }),

/***/ "i9Lx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_public__ = __webpack_require__("0w2Z");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: "隐私政策",
      serviceConfig: ""
    };
  },
  created: function created() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api_public__["a" /* getSystemType */])("privacy_agreement_config").then(function (d) {
      _this.serviceConfig = d.privacy_agreement_textarea;
    });
  },

  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "jT7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Wbwb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1f9aee8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ci21");
function injectStyle (ssrContext) {
  __webpack_require__("xB31")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1f9aee8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1f9aee8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kib/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message_scss__ = __webpack_require__("AD07");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__message_scss__);




var Message = function () {
  function Message() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Message);

    var elem = document.createElement("div");
    elem.className = "message-module-cont";
    var span = document.createElement("span");
    span.className = "message-module-text";
    elem.appendChild(span);
    this.elem = elem;
    this.span = span;
    this.append = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Message, [{
    key: "show",
    value: function show(text) {
      var _this = this;

      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

      this.span.innerText = text;
      this.elem.style.display = "block";
      if (!this.append) {
        this.append = true;
        document.body.appendChild(this.elem);
      }
      setTimeout(function () {
        _this.destory();
      }, delay);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.elem.style.display = "none";
    }
  }, {
    key: "destory",
    value: function destory() {
      this.elem.remove();
      this.append = false;
    }
  }]);

  return Message;
}();

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),

/***/ "kniT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_toast_style__ = __webpack_require__("eqfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__ = __webpack_require__("/QYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_index_api__ = __webpack_require__("TGqv");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // CloseState: {},
    token: {}, //登陆token
    settleObj: {} // 一键结算数据
  },
  data: function data() {
    return {
      CloseState1: true,
      closeImg: __webpack_require__("UruN"),
      orderNum: null, //订单个数
      goodsNum: null, //商品件数
      totalToBeSettleAmount: null //待结算总额
    };
  },

  watch: {
    settleObj: function settleObj(newVal, oldVal) {
      this.orderNum = this.settleObj.orderNum;
      this.goodsNum = this.settleObj.goodsNum;
      this.totalToBeSettleAmount = this.settleObj.totalToBeSettleAmount;
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    //关闭图片
    onclickImg: function onclickImg() {
      this.$emit("onclickImg");
    },
    getSupplier: function getSupplier() {
      var params = {
        Authorization: this.token
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_index_api__["e" /* getSupplierApply */])(params).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */].success("提交成功");
      });
    },

    // 提交
    onClickSumbit: function onClickSumbit() {
      this.$emit('onClickSumbit', this.CloseState1);
      // this.getSupplier();
    }
  }
});

/***/ }),

/***/ "lfvQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lqk2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "m/lI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toast_vue__ = __webpack_require__("wGIz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_590b188f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toast_vue__ = __webpack_require__("Ytfa");
function injectStyle (ssrContext) {
  __webpack_require__("I7UZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-590b188f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_590b188f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mMua":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "muJA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nFVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[(_vm.arrow?false:true)?_c('div',{staticClass:"type1"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":"/static/img/top_arrow_b.png","alt":""},on:{"click":function($event){return _vm.$router.go(-1)}}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"right"})]):_c('div',{staticClass:"type2"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nM5b":
/***/ (function(module, exports) {

// 设置 rem 函数
function setRem() {

    // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
    var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    //得到html的Dom元素
    var htmlDom = document.getElementsByTagName('html')[0];
    //设置根元素字体大小
    htmlDom.style.fontSize = htmlWidth / 20 + 'px';
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem();
};

/***/ }),

/***/ "nYwz":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "nsZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p+YF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settlement_vue__ = __webpack_require__("QcwO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8dae358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settlement_vue__ = __webpack_require__("N5TS");
function injectStyle (ssrContext) {
  __webpack_require__("uAid")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8dae358"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settlement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8dae358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settlement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pO/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_util_js__ = __webpack_require__("hhm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_message_message__ = __webpack_require__("kib/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 检验输入密码是否一致，检验手机号，检验手机验证码



var message = new __WEBPACK_IMPORTED_MODULE_3_base_message_message__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      second: 60,
      countdown: false,
      phone: "", // 手机号码
      code: "", // 验证码
      pwd: "", // 密码
      repwd: "" // 确认密码
    };
  },

  methods: {
    changeCode: function changeCode() {
      if (this.code.length > 4) {
        this.code = this.code.slice(0, 4);
      }
    },

    // 获取验证码
    getCode: function getCode() {
      var _this = this;

      var msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util_js__["i" /* mobileValid */])(this.phone);
      if (msg.err == 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api_login__["a" /* getVerificationCode */])(this.phone).then(function (res) {
          _this.showCountdown();
        });
      } else {
        message.show(msg.msg);
      }
    },
    showCountdown: function showCountdown() {
      var _this2 = this;

      this.countdown = true;
      var time = setInterval(function () {
        if (_this2.second == 0) {
          _this2.countdown = false;
          _this2.second = 60;
          clearInterval(time);
        } else {
          --_this2.second;
        }
      }, 1000);
    },
    confirm: function confirm() {
      var _this3 = this;

      var msg1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util_js__["i" /* mobileValid */])(this.phone);
      var msg2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_util_js__["j" /* captValid */])(this.code);
      if (msg2.err != 0 || msg1.err != 0) {
        message.show(msg1.msg || msg2.msg);
        return;
      }
      if (!this.pwd) {
        message.show("请输入密码");
        return;
      }
      if (this.pwd.length < 6) {
        message.show("密码不能小于六位数");
        return;
      }
      if (!this.repwd) {
        message.show("请输入确认密码");
        return;
      }
      if (this.pwd != this.repwd) {
        message.show("密码输入不一致");
        return;
      }
      var params = {
        mobile: this.phone,
        userKind: "S",
        smsCaptcha: this.code,
        loginPwd: this.pwd
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api_login__["b" /* changePwd */])(params).then(function (res) {
        message.show("修改成功");
        _this3.$router.push("/Login");
        if (code == "500") {
          message.show(errorMsg);
        }
      });
    }
  },
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "papl":
/***/ (function(module, exports) {

/** @license Copyright (c) 2012 Daniel Trebbien and other contributors
 Portions Copyright (c) 2003 STZ-IDA and PTV AG, Karlsruhe, Germany
 Portions Copyright (c) 1995-2001 International Business Machines Corporation and others

 All rights reserved.

 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, provided that the above copyright notice(s) and this permission notice appear in all copies of the Software and that both the above copyright notice(s) and this permission notice appear in supporting documentation.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF THIRD PARTY RIGHTS. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES, OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

 Except as contained in this notice, the name of a copyright holder shall not be used in advertising or otherwise to promote the sale, use or other dealings in this Software without prior written authorization of the copyright holder.
 */
(function () {

    var MathContext = function () {
        /* Generated from 'MathContext.nrx' 8 Sep 2000 11:07:48 [v2.00] */
        /* Options: Binary Comments Crossref Format Java Logo Strictargs Strictcase Trace2 Verbose3 */
        //--package com.ibm.icu.math;

        /* ------------------------------------------------------------------ */
        /* MathContext -- Math context settings                               */
        /* ------------------------------------------------------------------ */
        /* Copyright IBM Corporation, 1997, 2000.  All Rights Reserved.       */
        /*                                                                    */
        /*   The MathContext object encapsulates the settings used by the     */
        /*   BigDecimal class; it could also be used by other arithmetics.    */
        /* ------------------------------------------------------------------ */
        /* Notes:                                                             */
        /*                                                                    */
        /* 1. The properties are checked for validity on construction, so     */
        /*    the BigDecimal class may assume that they are correct.          */
        /* ------------------------------------------------------------------ */
        /* Author:    Mike Cowlishaw                                          */
        /* 1997.09.03 Initial version (edited from netrexx.lang.RexxSet)      */
        /* 1997.09.12 Add lostDigits property                                 */
        /* 1998.05.02 Make the class immutable and final; drop set methods    */
        /* 1998.06.05 Add Round (rounding modes) property                     */
        /* 1998.06.25 Rename from DecimalContext; allow digits=0              */
        /* 1998.10.12 change to com.ibm.icu.math package                          */
        /* 1999.02.06 add javadoc comments                                    */
        /* 1999.03.05 simplify; changes from discussion with J. Bloch         */
        /* 1999.03.13 1.00 release to IBM Centre for Java Technology          */
        /* 1999.07.10 1.04 flag serialization unused                          */
        /* 2000.01.01 1.06 copyright update                                   */
        /* ------------------------------------------------------------------ */

        /* JavaScript conversion (c) 2003 STZ-IDA and PTV AG, Karlsruhe, Germany */

        /**
         * The <code>MathContext</code> immutable class encapsulates the
         * settings understood by the operator methods of the {@link BigDecimal}
         * class (and potentially other classes).  Operator methods are those
         * that effect an operation on a number or a pair of numbers.
         * <p>
         * The settings, which are not base-dependent, comprise:
         * <ol>
         * <li><code>digits</code>:
         * the number of digits (precision) to be used for an operation
         * <li><code>form</code>:
         * the form of any exponent that results from the operation
         * <li><code>lostDigits</code>:
         * whether checking for lost digits is enabled
         * <li><code>roundingMode</code>:
         * the algorithm to be used for rounding.
         * </ol>
         * <p>
         * When provided, a <code>MathContext</code> object supplies the
         * settings for an operation directly.
         * <p>
         * When <code>MathContext.DEFAULT</code> is provided for a
         * <code>MathContext</code> parameter then the default settings are used
         * (<code>9, SCIENTIFIC, false, ROUND_HALF_UP</code>).
         * <p>
         * In the <code>BigDecimal</code> class, all methods which accept a
         * <code>MathContext</code> object defaults) also have a version of the
         * method which does not accept a MathContext parameter.  These versions
         * carry out unlimited precision fixed point arithmetic (as though the
         * settings were (<code>0, PLAIN, false, ROUND_HALF_UP</code>).
         * <p>
         * The instance variables are shared with default access (so they are
         * directly accessible to the <code>BigDecimal</code> class), but must
         * never be changed.
         * <p>
         * The rounding mode constants have the same names and values as the
         * constants of the same name in <code>java.math.BigDecimal</code>, to
         * maintain compatibility with earlier versions of
         * <code>BigDecimal</code>.
         *
         * @see     BigDecimal
         * @author  Mike Cowlishaw
         * @stable ICU 2.0
         */

        //--public final class MathContext implements java.io.Serializable{
        //--private static final java.lang.String $0="MathContext.nrx";

        //-- methods
        MathContext.prototype.getDigits = getDigits;
        MathContext.prototype.getForm = getForm;
        MathContext.prototype.getLostDigits = getLostDigits;
        MathContext.prototype.getRoundingMode = getRoundingMode;
        MathContext.prototype.toString = toString;
        MathContext.prototype.isValidRound = isValidRound;

        /* ----- Properties ----- */
        /* properties public constant */
        /**
         * Plain (fixed point) notation, without any exponent.
         * Used as a setting to control the form of the result of a
         * <code>BigDecimal</code> operation.
         * A zero result in plain form may have a decimal part of one or
         * more zeros.
         *
         * @see #ENGINEERING
         * @see #SCIENTIFIC
         * @stable ICU 2.0
         */
        //--public static final int PLAIN=0; // [no exponent]
        MathContext.PLAIN = MathContext.prototype.PLAIN = 0; // [no exponent]

        /**
         * Standard floating point notation (with scientific exponential
         * format, where there is one digit before any decimal point).
         * Used as a setting to control the form of the result of a
         * <code>BigDecimal</code> operation.
         * A zero result in plain form may have a decimal part of one or
         * more zeros.
         *
         * @see #ENGINEERING
         * @see #PLAIN
         * @stable ICU 2.0
         */
        //--public static final int SCIENTIFIC=1; // 1 digit before .
        MathContext.SCIENTIFIC = MathContext.prototype.SCIENTIFIC = 1; // 1 digit before .

        /**
         * Standard floating point notation (with engineering exponential
         * format, where the power of ten is a multiple of 3).
         * Used as a setting to control the form of the result of a
         * <code>BigDecimal</code> operation.
         * A zero result in plain form may have a decimal part of one or
         * more zeros.
         *
         * @see #PLAIN
         * @see #SCIENTIFIC
         * @stable ICU 2.0
         */
        //--public static final int ENGINEERING=2; // 1-3 digits before .
        MathContext.ENGINEERING = MathContext.prototype.ENGINEERING = 2; // 1-3 digits before .

        // The rounding modes match the original BigDecimal class values
        /**
         * Rounding mode to round to a more positive number.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * If any of the discarded digits are non-zero then the result
         * should be rounded towards the next more positive digit.
         * @stable ICU 2.0
         */
        //--public static final int ROUND_CEILING=2;
        MathContext.ROUND_CEILING = MathContext.prototype.ROUND_CEILING = 2;

        /**
         * Rounding mode to round towards zero.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * All discarded digits are ignored (truncated).  The result is
         * neither incremented nor decremented.
         * @stable ICU 2.0
         */
        //--public static final int ROUND_DOWN=1;
        MathContext.ROUND_DOWN = MathContext.prototype.ROUND_DOWN = 1;

        /**
         * Rounding mode to round to a more negative number.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * If any of the discarded digits are non-zero then the result
         * should be rounded towards the next more negative digit.
         * @stable ICU 2.0
         */
        //--public static final int ROUND_FLOOR=3;
        MathContext.ROUND_FLOOR = MathContext.prototype.ROUND_FLOOR = 3;

        /**
         * Rounding mode to round to nearest neighbor, where an equidistant
         * value is rounded down.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * If the discarded digits represent greater than half (0.5 times)
         * the value of a one in the next position then the result should be
         * rounded up (away from zero).  Otherwise the discarded digits are
         * ignored.
         * @stable ICU 2.0
         */
        //--public static final int ROUND_HALF_DOWN=5;
        MathContext.ROUND_HALF_DOWN = MathContext.prototype.ROUND_HALF_DOWN = 5;

        /**
         * Rounding mode to round to nearest neighbor, where an equidistant
         * value is rounded to the nearest even neighbor.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * If the discarded digits represent greater than half (0.5 times)
         * the value of a one in the next position then the result should be
         * rounded up (away from zero).  If they represent less than half,
         * then the result should be rounded down.
         * <p>
         * Otherwise (they represent exactly half) the result is rounded
         * down if its rightmost digit is even, or rounded up if its
         * rightmost digit is odd (to make an even digit).
         * @stable ICU 2.0
         */
        //--public static final int ROUND_HALF_EVEN=6;
        MathContext.ROUND_HALF_EVEN = MathContext.prototype.ROUND_HALF_EVEN = 6;

        /**
         * Rounding mode to round to nearest neighbor, where an equidistant
         * value is rounded up.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * If the discarded digits represent greater than or equal to half
         * (0.5 times) the value of a one in the next position then the result
         * should be rounded up (away from zero).  Otherwise the discarded
         * digits are ignored.
         * @stable ICU 2.0
         */
        //--public static final int ROUND_HALF_UP=4;
        MathContext.ROUND_HALF_UP = MathContext.prototype.ROUND_HALF_UP = 4;

        /**
         * Rounding mode to assert that no rounding is necessary.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * Rounding (potential loss of information) is not permitted.
         * If any of the discarded digits are non-zero then an
         * <code>ArithmeticException</code> should be thrown.
         * @stable ICU 2.0
         */
        //--public static final int ROUND_UNNECESSARY=7;
        MathContext.ROUND_UNNECESSARY = MathContext.prototype.ROUND_UNNECESSARY = 7;

        /**
         * Rounding mode to round away from zero.
         * Used as a setting to control the rounding mode used during a
         * <code>BigDecimal</code> operation.
         * <p>
         * If any of the discarded digits are non-zero then the result will
         * be rounded up (away from zero).
         * @stable ICU 2.0
         */
        //--public static final int ROUND_UP=0;
        MathContext.ROUND_UP = MathContext.prototype.ROUND_UP = 0;

        /* properties shared */
        /**
         * The number of digits (precision) to be used for an operation.
         * A value of 0 indicates that unlimited precision (as many digits
         * as are required) will be used.
         * <p>
         * The {@link BigDecimal} operator methods use this value to
         * determine the precision of results.
         * Note that leading zeros (in the integer part of a number) are
         * never significant.
         * <p>
         * <code>digits</code> will always be non-negative.
         *
         * @serial
         */
        //--int digits;

        /**
         * The form of results from an operation.
         * <p>
         * The {@link BigDecimal} operator methods use this value to
         * determine the form of results, in particular whether and how
         * exponential notation should be used.
         *
         * @see #ENGINEERING
         * @see #PLAIN
         * @see #SCIENTIFIC
         * @serial
         */
        //--int form; // values for this must fit in a byte

        /**
         * Controls whether lost digits checking is enabled for an
         * operation.
         * Set to <code>true</code> to enable checking, or
         * to <code>false</code> to disable checking.
         * <p>
         * When enabled, the {@link BigDecimal} operator methods check
         * the precision of their operand or operands, and throw an
         * <code>ArithmeticException</code> if an operand is more precise
         * than the digits setting (that is, digits would be lost).
         * When disabled, operands are rounded to the specified digits.
         *
         * @serial
         */
        //--boolean lostDigits;

        /**
         * The rounding algorithm to be used for an operation.
         * <p>
         * The {@link BigDecimal} operator methods use this value to
         * determine the algorithm to be used when non-zero digits have to
         * be discarded in order to reduce the precision of a result.
         * The value must be one of the public constants whose name starts
         * with <code>ROUND_</code>.
         *
         * @see #ROUND_CEILING
         * @see #ROUND_DOWN
         * @see #ROUND_FLOOR
         * @see #ROUND_HALF_DOWN
         * @see #ROUND_HALF_EVEN
         * @see #ROUND_HALF_UP
         * @see #ROUND_UNNECESSARY
         * @see #ROUND_UP
         * @serial
         */
        //--int roundingMode;

        /* properties private constant */
        // default settings
        //--private static final int DEFAULT_FORM=SCIENTIFIC;
        //--private static final int DEFAULT_DIGITS=9;
        //--private static final boolean DEFAULT_LOSTDIGITS=false;
        //--private static final int DEFAULT_ROUNDINGMODE=ROUND_HALF_UP;
        MathContext.prototype.DEFAULT_FORM = MathContext.prototype.SCIENTIFIC;
        MathContext.prototype.DEFAULT_DIGITS = 9;
        MathContext.prototype.DEFAULT_LOSTDIGITS = false;
        MathContext.prototype.DEFAULT_ROUNDINGMODE = MathContext.prototype.ROUND_HALF_UP;

        /* properties private constant */

        //--private static final int MIN_DIGITS=0; // smallest value for DIGITS.
        //--private static final int MAX_DIGITS=999999999; // largest value for DIGITS.  If increased,
        MathContext.prototype.MIN_DIGITS = 0; // smallest value for DIGITS.
        MathContext.prototype.MAX_DIGITS = 999999999; // largest value for DIGITS.  If increased,
        // the BigDecimal class may need update.
        // list of valid rounding mode values, most common two first
        //--private static final int ROUNDS[]=new int[]{ROUND_HALF_UP,ROUND_UNNECESSARY,ROUND_CEILING,ROUND_DOWN,ROUND_FLOOR,ROUND_HALF_DOWN,ROUND_HALF_EVEN,ROUND_UP};
        MathContext.prototype.ROUNDS = new Array(MathContext.prototype.ROUND_HALF_UP, MathContext.prototype.ROUND_UNNECESSARY, MathContext.prototype.ROUND_CEILING, MathContext.prototype.ROUND_DOWN, MathContext.prototype.ROUND_FLOOR, MathContext.prototype.ROUND_HALF_DOWN, MathContext.prototype.ROUND_HALF_EVEN, MathContext.prototype.ROUND_UP);

        //--private static final java.lang.String ROUNDWORDS[]=new java.lang.String[]{"ROUND_HALF_UP","ROUND_UNNECESSARY","ROUND_CEILING","ROUND_DOWN","ROUND_FLOOR","ROUND_HALF_DOWN","ROUND_HALF_EVEN","ROUND_UP"}; // matching names of the ROUNDS values
        MathContext.prototype.ROUNDWORDS = new Array("ROUND_HALF_UP", "ROUND_UNNECESSARY", "ROUND_CEILING", "ROUND_DOWN", "ROUND_FLOOR", "ROUND_HALF_DOWN", "ROUND_HALF_EVEN", "ROUND_UP"); // matching names of the ROUNDS values


        /* properties private constant unused */

        // Serialization version
        //--private static final long serialVersionUID=7163376998892515376L;

        /* properties public constant */
        /**
         * A <code>MathContext</code> object initialized to the default
         * settings for general-purpose arithmetic.  That is,
         * <code>digits=9 form=SCIENTIFIC lostDigits=false
         * roundingMode=ROUND_HALF_UP</code>.
         *
         * @see #SCIENTIFIC
         * @see #ROUND_HALF_UP
         * @stable ICU 2.0
         */
        //--public static final com.ibm.icu.math.MathContext DEFAULT=new com.ibm.icu.math.MathContext(DEFAULT_DIGITS,DEFAULT_FORM,DEFAULT_LOSTDIGITS,DEFAULT_ROUNDINGMODE);
        MathContext.prototype.DEFAULT = new MathContext(MathContext.prototype.DEFAULT_DIGITS, MathContext.prototype.DEFAULT_FORM, MathContext.prototype.DEFAULT_LOSTDIGITS, MathContext.prototype.DEFAULT_ROUNDINGMODE);

        /* ----- Constructors ----- */

        /**
         * Constructs a new <code>MathContext</code> with a specified
         * precision.
         * The other settings are set to the default values
         * (see {@link #DEFAULT}).
         *
         * An <code>IllegalArgumentException</code> is thrown if the
         * <code>setdigits</code> parameter is out of range
         * (&lt;0 or &gt;999999999).
         *
         * @param setdigits     The <code>int</code> digits setting
         *                      for this <code>MathContext</code>.
         * @throws IllegalArgumentException parameter out of range.
         * @stable ICU 2.0
         */

        //--public MathContext(int setdigits){
        //-- this(setdigits,DEFAULT_FORM,DEFAULT_LOSTDIGITS,DEFAULT_ROUNDINGMODE);
        //-- return;}


        /**
         * Constructs a new <code>MathContext</code> with a specified
         * precision and form.
         * The other settings are set to the default values
         * (see {@link #DEFAULT}).
         *
         * An <code>IllegalArgumentException</code> is thrown if the
         * <code>setdigits</code> parameter is out of range
         * (&lt;0 or &gt;999999999), or if the value given for the
         * <code>setform</code> parameter is not one of the appropriate
         * constants.
         *
         * @param setdigits     The <code>int</code> digits setting
         *                      for this <code>MathContext</code>.
         * @param setform       The <code>int</code> form setting
         *                      for this <code>MathContext</code>.
         * @throws IllegalArgumentException parameter out of range.
         * @stable ICU 2.0
         */

        //--public MathContext(int setdigits,int setform){
        //-- this(setdigits,setform,DEFAULT_LOSTDIGITS,DEFAULT_ROUNDINGMODE);
        //-- return;}

        /**
         * Constructs a new <code>MathContext</code> with a specified
         * precision, form, and lostDigits setting.
         * The roundingMode setting is set to its default value
         * (see {@link #DEFAULT}).
         *
         * An <code>IllegalArgumentException</code> is thrown if the
         * <code>setdigits</code> parameter is out of range
         * (&lt;0 or &gt;999999999), or if the value given for the
         * <code>setform</code> parameter is not one of the appropriate
         * constants.
         *
         * @param setdigits     The <code>int</code> digits setting
         *                      for this <code>MathContext</code>.
         * @param setform       The <code>int</code> form setting
         *                      for this <code>MathContext</code>.
         * @param setlostdigits The <code>boolean</code> lostDigits
         *                      setting for this <code>MathContext</code>.
         * @throws IllegalArgumentException parameter out of range.
         * @stable ICU 2.0
         */

        //--public MathContext(int setdigits,int setform,boolean setlostdigits){
        //-- this(setdigits,setform,setlostdigits,DEFAULT_ROUNDINGMODE);
        //-- return;}

        /**
         * Constructs a new <code>MathContext</code> with a specified
         * precision, form, lostDigits, and roundingMode setting.
         *
         * An <code>IllegalArgumentException</code> is thrown if the
         * <code>setdigits</code> parameter is out of range
         * (&lt;0 or &gt;999999999), or if the value given for the
         * <code>setform</code> or <code>setroundingmode</code> parameters is
         * not one of the appropriate constants.
         *
         * @param setdigits       The <code>int</code> digits setting
         *                        for this <code>MathContext</code>.
         * @param setform         The <code>int</code> form setting
         *                        for this <code>MathContext</code>.
         * @param setlostdigits   The <code>boolean</code> lostDigits
         *                        setting for this <code>MathContext</code>.
         * @param setroundingmode The <code>int</code> roundingMode setting
         *                        for this <code>MathContext</code>.
         * @throws IllegalArgumentException parameter out of range.
         * @stable ICU 2.0
         */

        //--public MathContext(int setdigits,int setform,boolean setlostdigits,int setroundingmode){super();
        function MathContext() {
            //-- members
            this.digits = 0;
            this.form = 0; // values for this must fit in a byte
            this.lostDigits = false;
            this.roundingMode = 0;

            //-- overloaded ctor
            var setform = this.DEFAULT_FORM;
            var setlostdigits = this.DEFAULT_LOSTDIGITS;
            var setroundingmode = this.DEFAULT_ROUNDINGMODE;
            if (MathContext.arguments.length == 4) {
                setform = MathContext.arguments[1];
                setlostdigits = MathContext.arguments[2];
                setroundingmode = MathContext.arguments[3];
            } else if (MathContext.arguments.length == 3) {
                setform = MathContext.arguments[1];
                setlostdigits = MathContext.arguments[2];
            } else if (MathContext.arguments.length == 2) {
                setform = MathContext.arguments[1];
            } else if (MathContext.arguments.length != 1) {
                throw "MathContext(): " + MathContext.arguments.length + " arguments given; expected 1 to 4";
            }
            var setdigits = MathContext.arguments[0];

            // set values, after checking
            if (setdigits != this.DEFAULT_DIGITS) {
                if (setdigits < this.MIN_DIGITS) throw "MathContext(): Digits too small: " + setdigits;
                if (setdigits > this.MAX_DIGITS) throw "MathContext(): Digits too large: " + setdigits;
            }
            {
                /*select*/
                if (setform == this.SCIENTIFIC) {} // [most common]
                else if (setform == this.ENGINEERING) {} else if (setform == this.PLAIN) {} else {
                        throw "MathContext() Bad form value: " + setform;
                    }
            }
            if (!this.isValidRound(setroundingmode)) throw "MathContext(): Bad roundingMode value: " + setroundingmode;
            this.digits = setdigits;
            this.form = setform;
            this.lostDigits = setlostdigits; // [no bad value possible]
            this.roundingMode = setroundingmode;
            return;
        }

        /**
         * Returns the digits setting.
         * This value is always non-negative.
         *
         * @return an <code>int</code> which is the value of the digits
         *         setting
         * @stable ICU 2.0
         */

        //--public int getDigits(){
        function getDigits() {
            return this.digits;
        }

        /**
         * Returns the form setting.
         * This will be one of
         * {@link #ENGINEERING},
         * {@link #PLAIN}, or
         * {@link #SCIENTIFIC}.
         *
         * @return an <code>int</code> which is the value of the form setting
         * @stable ICU 2.0
         */

        //--public int getForm(){
        function getForm() {
            return this.form;
        }

        /**
         * Returns the lostDigits setting.
         * This will be either <code>true</code> (enabled) or
         * <code>false</code> (disabled).
         *
         * @return a <code>boolean</code> which is the value of the lostDigits
         *           setting
         * @stable ICU 2.0
         */

        //--public boolean getLostDigits(){
        function getLostDigits() {
            return this.lostDigits;
        }

        /**
         * Returns the roundingMode setting.
         * This will be one of
         * {@link  #ROUND_CEILING},
         * {@link  #ROUND_DOWN},
         * {@link  #ROUND_FLOOR},
         * {@link  #ROUND_HALF_DOWN},
         * {@link  #ROUND_HALF_EVEN},
         * {@link  #ROUND_HALF_UP},
         * {@link  #ROUND_UNNECESSARY}, or
         * {@link  #ROUND_UP}.
         *
         * @return an <code>int</code> which is the value of the roundingMode
         *         setting
         * @stable ICU 2.0
         */

        //--public int getRoundingMode(){
        function getRoundingMode() {
            return this.roundingMode;
        }

        /** Returns the <code>MathContext</code> as a readable string.
         * The <code>String</code> returned represents the settings of the
         * <code>MathContext</code> object as four blank-delimited words
         * separated by a single blank and with no leading or trailing blanks,
         * as follows:
         * <ol>
         * <li>
         * <code>digits=</code>, immediately followed by
         * the value of the digits setting as a numeric word.
         * <li>
         * <code>form=</code>, immediately followed by
         * the value of the form setting as an uppercase word
         * (one of <code>SCIENTIFIC</code>, <code>PLAIN</code>, or
         * <code>ENGINEERING</code>).
         * <li>
         * <code>lostDigits=</code>, immediately followed by
         * the value of the lostDigits setting
         * (<code>1</code> if enabled, <code>0</code> if disabled).
         * <li>
         * <code>roundingMode=</code>, immediately followed by
         * the value of the roundingMode setting as a word.
         * This word will be the same as the name of the corresponding public
         * constant.
         * </ol>
         * <p>
         * For example:
         * <br><code>
         * digits=9 form=SCIENTIFIC lostDigits=0 roundingMode=ROUND_HALF_UP
         * </code>
         * <p>
         * Additional words may be appended to the result of
         * <code>toString</code> in the future if more properties are added
         * to the class.
         *
         * @return a <code>String</code> representing the context settings.
         * @stable ICU 2.0
         */

        //--public java.lang.String toString(){
        function toString() {
            //--java.lang.String formstr=null;
            var formstr = null;
            //--int r=0;
            var r = 0;
            //--java.lang.String roundword=null;
            var roundword = null;
            {
                /*select*/
                if (this.form == this.SCIENTIFIC) formstr = "SCIENTIFIC";else if (this.form == this.ENGINEERING) formstr = "ENGINEERING";else {
                    formstr = "PLAIN";
                    /* form=PLAIN */
                }
            }
            {
                var $1 = this.ROUNDS.length;
                r = 0;
                r: for (; $1 > 0; $1--, r++) {
                    if (this.roundingMode == this.ROUNDS[r]) {
                        roundword = this.ROUNDWORDS[r];
                        break r;
                    }
                }
            }
            /*r*/
            return "digits=" + this.digits + " " + "form=" + formstr + " " + "lostDigits=" + (this.lostDigits ? "1" : "0") + " " + "roundingMode=" + roundword;
        }

        /* <sgml> Test whether round is valid. </sgml> */
        // This could be made shared for use by BigDecimal for setScale.

        //--private static boolean isValidRound(int testround){
        function isValidRound(testround) {
            //--int r=0;
            var r = 0;
            {
                var $2 = this.ROUNDS.length;
                r = 0;
                r: for (; $2 > 0; $2--, r++) {
                    if (testround == this.ROUNDS[r]) return true;
                }
            }
            /*r*/
            return false;
        }

        return MathContext;
    }();

    var BigDecimal = function (MathContext) {
        /* Generated from 'BigDecimal.nrx' 8 Sep 2000 11:10:50 [v2.00] */
        /* Options: Binary Comments Crossref Format Java Logo Strictargs Strictcase Trace2 Verbose3 */
        //--package com.ibm.icu.math;
        //--import java.math.BigInteger;
        //--import com.ibm.icu.impl.Utility;

        /* ------------------------------------------------------------------ */
        /* BigDecimal -- Decimal arithmetic for Java                          */
        /* ------------------------------------------------------------------ */
        /* Copyright IBM Corporation, 1996, 2000.  All Rights Reserved.       */
        /*                                                                    */
        /* The BigDecimal class provides immutable arbitrary-precision        */
        /* floating point (including integer) decimal numbers.                */
        /*                                                                    */
        /* As the numbers are decimal, there is an exact correspondence       */
        /* between an instance of a BigDecimal object and its String          */
        /* representation; the BigDecimal class provides direct conversions   */
        /* to and from String and character array objects, and well as        */
        /* conversions to and from the Java primitive types (which may not    */
        /* be exact).                                                         */
        /* ------------------------------------------------------------------ */
        /* Notes:                                                             */
        /*                                                                    */
        /* 1. A BigDecimal object is never changed in value once constructed; */
        /*    this avoids the need for locking.  Note in particular that the  */
        /*    mantissa array may be shared between many BigDecimal objects,   */
        /*    so that once exposed it must not be altered.                    */
        /*                                                                    */
        /* 2. This class looks at MathContext class fields directly (for      */
        /*    performance).  It must not and does not change them.            */
        /*                                                                    */
        /* 3. Exponent checking is delayed until finish(), as we know         */
        /*    intermediate calculations cannot cause 31-bit overflow.         */
        /*    [This assertion depends on MAX_DIGITS in MathContext.]          */
        /*                                                                    */
        /* 4. Comments for the public API now follow the javadoc conventions. */
        /*    The NetRexx -comments option is used to pass these comments     */
        /*    through to the generated Java code (with -format, if desired).  */
        /*                                                                    */
        /* 5. System.arraycopy is faster than explicit loop as follows        */
        /*      Mean length 4:  equal                                         */
        /*      Mean length 8:  x2                                            */
        /*      Mean length 16: x3                                            */
        /*      Mean length 24: x4                                            */
        /*    From prior experience, we expect mean length a little below 8,  */
        /*    but arraycopy is still the one to use, in general, until later  */
        /*    measurements suggest otherwise.                                 */
        /*                                                                    */
        /* 6. 'DMSRCN' referred to below is the original (1981) IBM S/370     */
        /*    assembler code implementation of the algorithms below; it is    */
        /*    now called IXXRCN and is available with the OS/390 and VM/ESA   */
        /*    operating systems.                                              */
        /* ------------------------------------------------------------------ */
        /* Change History:                                                    */
        /* 1997.09.02 Initial version (derived from netrexx.lang classes)     */
        /* 1997.09.12 Add lostDigits checking                                 */
        /* 1997.10.06 Change mantissa to a byte array                         */
        /* 1997.11.22 Rework power [did not prepare arguments, etc.]          */
        /* 1997.12.13 multiply did not prepare arguments                      */
        /* 1997.12.14 add did not prepare and align arguments correctly       */
        /* 1998.05.02 0.07 packaging changes suggested by Sun and Oracle      */
        /* 1998.05.21 adjust remainder operator finalization                  */
        /* 1998.06.04 rework to pass MathContext to finish() and round()      */
        /* 1998.06.06 change format to use round(); support rounding modes    */
        /* 1998.06.25 rename to BigDecimal and begin merge                    */
        /*            zero can now have trailing zeros (i.e., exp\=0)         */
        /* 1998.06.28 new methods: movePointXxxx, scale, toBigInteger         */
        /*                         unscaledValue, valueof                     */
        /* 1998.07.01 improve byteaddsub to allow array reuse, etc.           */
        /* 1998.07.01 make null testing explicit to avoid JIT bug [Win32]     */
        /* 1998.07.07 scaled division  [divide(BigDecimal, int, int)]         */
        /* 1998.07.08 setScale, faster equals                                 */
        /* 1998.07.11 allow 1E6 (no sign) <sigh>; new double/float conversion */
        /* 1998.10.12 change package to com.ibm.icu.math                          */
        /* 1998.12.14 power operator no longer rounds RHS [to match ANSI]     */
        /*            add toBigDecimal() and BigDecimal(java.math.BigDecimal) */
        /* 1998.12.29 improve byteaddsub by using table lookup                */
        /* 1999.02.04 lostdigits=0 behaviour rounds instead of digits+1 guard */
        /* 1999.02.05 cleaner code for BigDecimal(char[])                     */
        /* 1999.02.06 add javadoc comments                                    */
        /* 1999.02.11 format() changed from 7 to 2 method form                */
        /* 1999.03.05 null pointer checking is no longer explicit             */
        /* 1999.03.05 simplify; changes from discussion with J. Bloch:        */
        /*            null no longer permitted for MathContext; drop boolean, */
        /*            byte, char, float, short constructor, deprecate double  */
        /*            constructor, no blanks in string constructor, add       */
        /*            offset and length version of char[] constructor;        */
        /*            add valueOf(double); drop booleanValue, charValue;      */
        /*            add ...Exact versions of remaining convertors           */
        /* 1999.03.13 add toBigIntegerExact                                   */
        /* 1999.03.13 1.00 release to IBM Centre for Java Technology          */
        /* 1999.05.27 1.01 correct 0-0.2 bug under scaled arithmetic          */
        /* 1999.06.29 1.02 constructors should not allow exponent > 9 digits  */
        /* 1999.07.03 1.03 lost digits should not be checked if digits=0      */
        /* 1999.07.06      lost digits Exception message changed              */
        /* 1999.07.10 1.04 more work on 0-0.2 (scaled arithmetic)             */
        /* 1999.07.17      improve messages from pow method                   */
        /* 1999.08.08      performance tweaks                                 */
        /* 1999.08.15      fastpath in multiply                               */
        /* 1999.11.05 1.05 fix problem in intValueExact [e.g., 5555555555]    */
        /* 1999.12.22 1.06 remove multiply fastpath, and improve performance  */
        /* 2000.01.01      copyright update [Y2K has arrived]                 */
        /* 2000.06.18 1.08 no longer deprecate BigDecimal(double)             */
        /* ------------------------------------------------------------------ */

        /* JavaScript conversion (c) 2003 STZ-IDA and PTV AG, Karlsruhe, Germany */

        function div(a, b) {
            return (a - a % b) / b;
        }

        BigDecimal.prototype.div = div;

        function arraycopy(src, srcindex, dest, destindex, length) {
            var i;
            if (destindex > srcindex) {
                // in case src and dest are equals, but also doesn't hurt
                // if they are different
                for (i = length - 1; i >= 0; --i) {
                    dest[i + destindex] = src[i + srcindex];
                }
            } else {
                for (i = 0; i < length; ++i) {
                    dest[i + destindex] = src[i + srcindex];
                }
            }
        }

        BigDecimal.prototype.arraycopy = arraycopy;

        function createArrayWithZeros(length) {
            var retVal = new Array(length);
            var i;
            for (i = 0; i < length; ++i) {
                retVal[i] = 0;
            }
            return retVal;
        }

        BigDecimal.prototype.createArrayWithZeros = createArrayWithZeros;

        /**
         * The <code>BigDecimal</code> class implements immutable
         * arbitrary-precision decimal numbers.  The methods of the
         * <code>BigDecimal</code> class provide operations for fixed and
         * floating point arithmetic, comparison, format conversions, and
         * hashing.
         * <p>
         * As the numbers are decimal, there is an exact correspondence between
         * an instance of a <code>BigDecimal</code> object and its
         * <code>String</code> representation; the <code>BigDecimal</code> class
         * provides direct conversions to and from <code>String</code> and
         * character array (<code>char[]</code>) objects, as well as conversions
         * to and from the Java primitive types (which may not be exact) and
         * <code>BigInteger</code>.
         * <p>
         * In the descriptions of constructors and methods in this documentation,
         * the value of a <code>BigDecimal</code> number object is shown as the
         * result of invoking the <code>toString()</code> method on the object.
         * The internal representation of a decimal number is neither defined
         * nor exposed, and is not permitted to affect the result of any
         * operation.
         * <p>
         * The floating point arithmetic provided by this class is defined by
         * the ANSI X3.274-1996 standard, and is also documented at
         * <code>http://www2.hursley.ibm.com/decimal</code>
         * <br><i>[This URL will change.]</i>
         *
         * <h3>Operator methods</h3>
         * <p>
         * Operations on <code>BigDecimal</code> numbers are controlled by a
         * {@link MathContext} object, which provides the context (precision and
         * other information) for the operation. Methods that can take a
         * <code>MathContext</code> parameter implement the standard arithmetic
         * operators for <code>BigDecimal</code> objects and are known as
         * <i>operator methods</i>.  The default settings provided by the
         * constant {@link MathContext#DEFAULT} (<code>digits=9,
         * form=SCIENTIFIC, lostDigits=false, roundingMode=ROUND_HALF_UP</code>)
         * perform general-purpose floating point arithmetic to nine digits of
         * precision.  The <code>MathContext</code> parameter must not be
         * <code>null</code>.
         * <p>
         * Each operator method also has a version provided which does
         * not take a <code>MathContext</code> parameter.  For this version of
         * each method, the context settings used are <code>digits=0,
         * form=PLAIN, lostDigits=false, roundingMode=ROUND_HALF_UP</code>;
         * these settings perform fixed point arithmetic with unlimited
         * precision, as defined for the original BigDecimal class in Java 1.1
         * and Java 1.2.
         * <p>
         * For monadic operators, only the optional <code>MathContext</code>
         * parameter is present; the operation acts upon the current object.
         * <p>
         * For dyadic operators, a <code>BigDecimal</code> parameter is always
         * present; it must not be <code>null</code>.
         * The operation acts with the current object being the left-hand operand
         * and the <code>BigDecimal</code> parameter being the right-hand operand.
         * <p>
         * For example, adding two <code>BigDecimal</code> objects referred to
         * by the names <code>award</code> and <code>extra</code> could be
         * written as any of:
         * <p><code>
         *     award.add(extra)
         * <br>award.add(extra, MathContext.DEFAULT)
         * <br>award.add(extra, acontext)
         * </code>
         * <p>
         * (where <code>acontext</code> is a <code>MathContext</code> object),
         * which would return a <code>BigDecimal</code> object whose value is
         * the result of adding <code>award</code> and <code>extra</code> under
         * the appropriate context settings.
         * <p>
         * When a <code>BigDecimal</code> operator method is used, a set of
         * rules define what the result will be (and, by implication, how the
         * result would be represented as a character string).
         * These rules are defined in the BigDecimal arithmetic documentation
         * (see the URL above), but in summary:
         * <ul>
         * <li>Results are normally calculated with up to some maximum number of
         * significant digits.
         * For example, if the <code>MathContext</code> parameter for an operation
         * were <code>MathContext.DEFAULT</code> then the result would be
         * rounded to 9 digits; the division of 2 by 3 would then result in
         * 0.666666667.
         * <br>
         * You can change the default of 9 significant digits by providing the
         * method with a suitable <code>MathContext</code> object. This lets you
         * calculate using as many digits as you need -- thousands, if necessary.
         * Fixed point (scaled) arithmetic is indicated by using a
         * <code>digits</code> setting of 0 (or omitting the
         * <code>MathContext</code> parameter).
         * <br>
         * Similarly, you can change the algorithm used for rounding from the
         * default "classic" algorithm.
         * <li>
         * In standard arithmetic (that is, when the <code>form</code> setting
         * is not <code>PLAIN</code>), a zero result is always expressed as the
         * single digit <code>'0'</code> (that is, with no sign, decimal point,
         * or exponent part).
         * <li>
         * Except for the division and power operators in standard arithmetic,
         * trailing zeros are preserved (this is in contrast to binary floating
         * point operations and most electronic calculators, which lose the
         * information about trailing zeros in the fractional part of results).
         * <br>
         * So, for example:
         * <p><code>
         *     new BigDecimal("2.40").add(     new BigDecimal("2"))      =&gt; "4.40"
         * <br>new BigDecimal("2.40").subtract(new BigDecimal("2"))      =&gt; "0.40"
         * <br>new BigDecimal("2.40").multiply(new BigDecimal("2"))      =&gt; "4.80"
         * <br>new BigDecimal("2.40").divide(  new BigDecimal("2"), def) =&gt; "1.2"
         * </code>
         * <p>where the value on the right of the <code>=&gt;</code> would be the
         * result of the operation, expressed as a <code>String</code>, and
         * <code>def</code> (in this and following examples) refers to
         * <code>MathContext.DEFAULT</code>).
         * This preservation of trailing zeros is desirable for most
         * calculations (including financial calculations).
         * If necessary, trailing zeros may be easily removed using division by 1.
         * <li>
         * In standard arithmetic, exponential form is used for a result
         * depending on its value and the current setting of <code>digits</code>
         * (the default is 9 digits).
         * If the number of places needed before the decimal point exceeds the
         * <code>digits</code> setting, or the absolute value of the number is
         * less than <code>0.000001</code>, then the number will be expressed in
         * exponential notation; thus
         * <p><code>
         *   new BigDecimal("1e+6").multiply(new BigDecimal("1e+6"), def)
         * </code>
         * <p>results in <code>1E+12</code> instead of
         * <code>1000000000000</code>, and
         * <p><code>
         *   new BigDecimal("1").divide(new BigDecimal("3E+10"), def)
         * </code>
         * <p>results in <code>3.33333333E-11</code> instead of
         * <code>0.0000000000333333333</code>.
         * <p>
         * The form of the exponential notation (scientific or engineering) is
         * determined by the <code>form</code> setting.
         * <eul>
         * <p>
         * The names of methods in this class follow the conventions established
         * by <code>java.lang.Number</code>, <code>java.math.BigInteger</code>,
         * and <code>java.math.BigDecimal</code> in Java 1.1 and Java 1.2.
         *
         * @see     MathContext
         * @author  Mike Cowlishaw
         * @stable ICU 2.0
         */

        //--public class BigDecimal extends java.lang.Number implements java.io.Serializable,java.lang.Comparable{
        //-- private static final java.lang.String $0="BigDecimal.nrx";

        //-- methods
        BigDecimal.prototype.abs = abs;
        BigDecimal.prototype.add = add;
        BigDecimal.prototype.compareTo = compareTo;
        BigDecimal.prototype.divide = divide;
        BigDecimal.prototype.divideInteger = divideInteger;
        BigDecimal.prototype.max = max;
        BigDecimal.prototype.min = min;
        BigDecimal.prototype.multiply = multiply;
        BigDecimal.prototype.negate = negate;
        BigDecimal.prototype.plus = plus;
        BigDecimal.prototype.pow = pow;
        BigDecimal.prototype.remainder = remainder;
        BigDecimal.prototype.subtract = subtract;
        BigDecimal.prototype.equals = equals;
        BigDecimal.prototype.format = format;
        BigDecimal.prototype.intValueExact = intValueExact;
        BigDecimal.prototype.movePointLeft = movePointLeft;
        BigDecimal.prototype.movePointRight = movePointRight;
        BigDecimal.prototype.scale = scale;
        BigDecimal.prototype.setScale = setScale;
        BigDecimal.prototype.signum = signum;
        BigDecimal.prototype.toString = toString;
        BigDecimal.prototype.layout = layout;
        BigDecimal.prototype.intcheck = intcheck;
        BigDecimal.prototype.dodivide = dodivide;
        BigDecimal.prototype.bad = bad;
        BigDecimal.prototype.badarg = badarg;
        BigDecimal.prototype.extend = extend;
        BigDecimal.prototype.byteaddsub = byteaddsub;
        BigDecimal.prototype.diginit = diginit;
        BigDecimal.prototype.clone = clone;
        BigDecimal.prototype.checkdigits = checkdigits;
        BigDecimal.prototype.round = round;
        BigDecimal.prototype.allzero = allzero;
        BigDecimal.prototype.finish = finish;

        // Convenience methods
        BigDecimal.prototype.isGreaterThan = isGreaterThan;
        BigDecimal.prototype.isLessThan = isLessThan;
        BigDecimal.prototype.isGreaterThanOrEqualTo = isGreaterThanOrEqualTo;
        BigDecimal.prototype.isLessThanOrEqualTo = isLessThanOrEqualTo;
        BigDecimal.prototype.isPositive = isPositive;
        BigDecimal.prototype.isNegative = isNegative;
        BigDecimal.prototype.isZero = isZero;

        /* ----- Constants ----- */
        /* properties constant public */ // useful to others
        // the rounding modes (copied here for upwards compatibility)
        /**
         * Rounding mode to round to a more positive number.
         * @see MathContext#ROUND_CEILING
         * @stable ICU 2.0
         */
        //--public static final int ROUND_CEILING=com.ibm.icu.math.MathContext.ROUND_CEILING;
        BigDecimal.ROUND_CEILING = BigDecimal.prototype.ROUND_CEILING = MathContext.prototype.ROUND_CEILING;

        /**
         * Rounding mode to round towards zero.
         * @see MathContext#ROUND_DOWN
         * @stable ICU 2.0
         */
        //--public static final int ROUND_DOWN=com.ibm.icu.math.MathContext.ROUND_DOWN;
        BigDecimal.ROUND_DOWN = BigDecimal.prototype.ROUND_DOWN = MathContext.prototype.ROUND_DOWN;

        /**
         * Rounding mode to round to a more negative number.
         * @see MathContext#ROUND_FLOOR
         * @stable ICU 2.0
         */
        //--public static final int ROUND_FLOOR=com.ibm.icu.math.MathContext.ROUND_FLOOR;
        BigDecimal.ROUND_FLOOR = BigDecimal.prototype.ROUND_FLOOR = MathContext.prototype.ROUND_FLOOR;

        /**
         * Rounding mode to round to nearest neighbor, where an equidistant
         * value is rounded down.
         * @see MathContext#ROUND_HALF_DOWN
         * @stable ICU 2.0
         */
        //--public static final int ROUND_HALF_DOWN=com.ibm.icu.math.MathContext.ROUND_HALF_DOWN;
        BigDecimal.ROUND_HALF_DOWN = BigDecimal.prototype.ROUND_HALF_DOWN = MathContext.prototype.ROUND_HALF_DOWN;

        /**
         * Rounding mode to round to nearest neighbor, where an equidistant
         * value is rounded to the nearest even neighbor.
         * @see MathContext#ROUND_HALF_EVEN
         * @stable ICU 2.0
         */
        //--public static final int ROUND_HALF_EVEN=com.ibm.icu.math.MathContext.ROUND_HALF_EVEN;
        BigDecimal.ROUND_HALF_EVEN = BigDecimal.prototype.ROUND_HALF_EVEN = MathContext.prototype.ROUND_HALF_EVEN;

        /**
         * Rounding mode to round to nearest neighbor, where an equidistant
         * value is rounded up.
         * @see MathContext#ROUND_HALF_UP
         * @stable ICU 2.0
         */
        //--public static final int ROUND_HALF_UP=com.ibm.icu.math.MathContext.ROUND_HALF_UP;
        BigDecimal.ROUND_HALF_UP = BigDecimal.prototype.ROUND_HALF_UP = MathContext.prototype.ROUND_HALF_UP;

        /**
         * Rounding mode to assert that no rounding is necessary.
         * @see MathContext#ROUND_UNNECESSARY
         * @stable ICU 2.0
         */
        //--public static final int ROUND_UNNECESSARY=com.ibm.icu.math.MathContext.ROUND_UNNECESSARY;
        BigDecimal.ROUND_UNNECESSARY = BigDecimal.prototype.ROUND_UNNECESSARY = MathContext.prototype.ROUND_UNNECESSARY;

        /**
         * Rounding mode to round away from zero.
         * @see MathContext#ROUND_UP
         * @stable ICU 2.0
         */
        //--public static final int ROUND_UP=com.ibm.icu.math.MathContext.ROUND_UP;
        BigDecimal.ROUND_UP = BigDecimal.prototype.ROUND_UP = MathContext.prototype.ROUND_UP;

        /* properties constant private */ // locals
        //--private static final byte ispos=1; // ind: indicates positive (must be 1)
        //--private static final byte iszero=0; // ind: indicates zero     (must be 0)
        //--private static final byte isneg=-1; // ind: indicates negative (must be -1)
        BigDecimal.prototype.ispos = 1;
        BigDecimal.prototype.iszero = 0;
        BigDecimal.prototype.isneg = -1;
        // [later could add NaN, +/- infinity, here]

        //--private static final int MinExp=-999999999; // minimum exponent allowed
        //--private static final int MaxExp=999999999; // maximum exponent allowed
        //--private static final int MinArg=-999999999; // minimum argument integer
        //--private static final int MaxArg=999999999; // maximum argument integer
        BigDecimal.prototype.MinExp = -999999999; // minimum exponent allowed
        BigDecimal.prototype.MaxExp = 999999999; // maximum exponent allowed
        BigDecimal.prototype.MinArg = -999999999; // minimum argument integer
        BigDecimal.prototype.MaxArg = 999999999; // maximum argument integer

        //--private static final com.ibm.icu.math.MathContext plainMC=new com.ibm.icu.math.MathContext(0,com.ibm.icu.math.MathContext.PLAIN); // context for plain unlimited math
        BigDecimal.prototype.plainMC = new MathContext(0, MathContext.prototype.PLAIN);

        /* properties constant private unused */ // present but not referenced

        // Serialization version
        //--private static final long serialVersionUID=8245355804974198832L;

        //--private static final java.lang.String copyright=" Copyright (c) IBM Corporation 1996, 2000.  All rights reserved. ";

        /* properties static private */
        // Precalculated constant arrays (used by byteaddsub)
        //--private static byte bytecar[]=new byte[(90+99)+1]; // carry/borrow array
        //--private static byte bytedig[]=diginit(); // next digit array
        BigDecimal.prototype.bytecar = new Array(90 + 99 + 1);
        BigDecimal.prototype.bytedig = diginit();

        /**
         * The <code>BigDecimal</code> constant "0".
         *
         * @see #ONE
         * @see #TEN
         * @stable ICU 2.0
         */
        //--public static final com.ibm.icu.math.BigDecimal ZERO=new com.ibm.icu.math.BigDecimal((long)0); // use long as we want the int constructor
        // .. to be able to use this, for speed
        BigDecimal.ZERO = BigDecimal.prototype.ZERO = new BigDecimal("0");

        /**
         * The <code>BigDecimal</code> constant "1".
         *
         * @see #TEN
         * @see #ZERO
         * @stable ICU 2.0
         */
        //--public static final com.ibm.icu.math.BigDecimal ONE=new com.ibm.icu.math.BigDecimal((long)1); // use long as we want the int constructor
        // .. to be able to use this, for speed
        BigDecimal.ONE = BigDecimal.prototype.ONE = new BigDecimal("1");

        /**
         * The <code>BigDecimal</code> constant "10".
         *
         * @see #ONE
         * @see #ZERO
         * @stable ICU 2.0
         */
        //--public static final com.ibm.icu.math.BigDecimal TEN=new com.ibm.icu.math.BigDecimal(10);
        BigDecimal.TEN = BigDecimal.prototype.TEN = new BigDecimal("10");

        /* ----- Instance properties [all private and immutable] ----- */
        /* properties private */

        /**
         * The indicator. This may take the values:
         * <ul>
         * <li>ispos  -- the number is positive
         * <li>iszero -- the number is zero
         * <li>isneg  -- the number is negative
         * </ul>
         *
         * @serial
         */
        //--private byte ind; // assumed undefined
        // Note: some code below assumes IND = Sign [-1, 0, 1], at present.
        // We only need two bits for this, but use a byte [also permits
        // smooth future extension].

        /**
         * The formatting style. This may take the values:
         * <ul>
         * <li>MathContext.PLAIN        -- no exponent needed
         * <li>MathContext.SCIENTIFIC   -- scientific notation required
         * <li>MathContext.ENGINEERING  -- engineering notation required
         * </ul>
         * <p>
         * This property is an optimization; it allows us to defer number
         * layout until it is actually needed as a string, hence avoiding
         * unnecessary formatting.
         *
         * @serial
         */
        //--private byte form=(byte)com.ibm.icu.math.MathContext.PLAIN; // assumed PLAIN
        // We only need two bits for this, at present, but use a byte
        // [again, to allow for smooth future extension]

        /**
         * The value of the mantissa.
         * <p>
         * Once constructed, this may become shared between several BigDecimal
         * objects, so must not be altered.
         * <p>
         * For efficiency (speed), this is a byte array, with each byte
         * taking a value of 0 -> 9.
         * <p>
         * If the first byte is 0 then the value of the number is zero (and
         * mant.length=1, except when constructed from a plain number, for
         * example, 0.000).
         *
         * @serial
         */
        //--private byte mant[]; // assumed null

        /**
         * The exponent.
         * <p>
         * For fixed point arithmetic, scale is <code>-exp</code>, and can
         * apply to zero.
         *
         * Note that this property can have a value less than MinExp when
         * the mantissa has more than one digit.
         *
         * @serial
         */
        //--private int exp;
        // assumed 0

        /* ---------------------------------------------------------------- */
        /* Constructors                                                     */
        /* ---------------------------------------------------------------- */

        /**
         * Constructs a <code>BigDecimal</code> object from a
         * <code>java.math.BigDecimal</code>.
         * <p>
         * Constructs a <code>BigDecimal</code> as though the parameter had
         * been represented as a <code>String</code> (using its
         * <code>toString</code> method) and the
         * {@link #BigDecimal(java.lang.String)} constructor had then been
         * used.
         * The parameter must not be <code>null</code>.
         * <p>
         * <i>(Note: this constructor is provided only in the
         * <code>com.ibm.icu.math</code> version of the BigDecimal class.
         * It would not be present in a <code>java.math</code> version.)</i>
         *
         * @param bd The <code>BigDecimal</code> to be translated.
         * @stable ICU 2.0
         */

        //--public BigDecimal(java.math.BigDecimal bd){
        //-- this(bd.toString());
        //-- return;}

        /**
         * Constructs a <code>BigDecimal</code> object from a
         * <code>BigInteger</code>, with scale 0.
         * <p>
         * Constructs a <code>BigDecimal</code> which is the exact decimal
         * representation of the <code>BigInteger</code>, with a scale of
         * zero.
         * The value of the <code>BigDecimal</code> is identical to the value
         * of the <code>BigInteger</code>.
         * The parameter must not be <code>null</code>.
         * <p>
         * The <code>BigDecimal</code> will contain only decimal digits,
         * prefixed with a leading minus sign (hyphen) if the
         * <code>BigInteger</code> is negative.  A leading zero will be
         * present only if the <code>BigInteger</code> is zero.
         *
         * @param bi The <code>BigInteger</code> to be converted.
         * @stable ICU 2.0
         */

        //--public BigDecimal(java.math.BigInteger bi){
        //-- this(bi.toString(10));
        //-- return;}
        // exp remains 0

        /**
         * Constructs a <code>BigDecimal</code> object from a
         * <code>BigInteger</code> and a scale.
         * <p>
         * Constructs a <code>BigDecimal</code> which is the exact decimal
         * representation of the <code>BigInteger</code>, scaled by the
         * second parameter, which may not be negative.
         * The value of the <code>BigDecimal</code> is the
         * <code>BigInteger</code> divided by ten to the power of the scale.
         * The <code>BigInteger</code> parameter must not be
         * <code>null</code>.
         * <p>
         * The <code>BigDecimal</code> will contain only decimal digits, (with
         * an embedded decimal point followed by <code>scale</code> decimal
         * digits if the scale is positive), prefixed with a leading minus
         * sign (hyphen) if the <code>BigInteger</code> is negative.  A
         * leading zero will be present only if the <code>BigInteger</code> is
         * zero.
         *
         * @param  bi    The <code>BigInteger</code> to be converted.
         * @param  scale The <code>int</code> specifying the scale.
         * @throws NumberFormatException if the scale is negative.
         * @stable ICU 2.0
         */

        //--public BigDecimal(java.math.BigInteger bi,int scale){
        //-- this(bi.toString(10));
        //-- if (scale<0)
        //--  throw new java.lang.NumberFormatException("Negative scale:"+" "+scale);
        //-- exp=(int)-scale; // exponent is -scale
        //-- return;}

        /**
         * Constructs a <code>BigDecimal</code> object from an array of characters.
         * <p>
         * Constructs a <code>BigDecimal</code> as though a
         * <code>String</code> had been constructed from the character array
         * and the {@link #BigDecimal(java.lang.String)} constructor had then
         * been used. The parameter must not be <code>null</code>.
         * <p>
         * Using this constructor is faster than using the
         * <code>BigDecimal(String)</code> constructor if the string is
         * already available in character array form.
         *
         * @param inchars The <code>char[]</code> array containing the number
         *                to be converted.
         * @throws NumberFormatException if the parameter is not a valid
         *                number.
         * @stable ICU 2.0
         */

        //--public BigDecimal(char inchars[]){
        //-- this(inchars,0,inchars.length);
        //-- return;}

        /**
         * Constructs a <code>BigDecimal</code> object from an array of characters.
         * <p>
         * Constructs a <code>BigDecimal</code> as though a
         * <code>String</code> had been constructed from the character array
         * (or a subarray of that array) and the
         * {@link #BigDecimal(java.lang.String)} constructor had then been
         * used. The first parameter must not be <code>null</code>, and the
         * subarray must be wholly contained within it.
         * <p>
         * Using this constructor is faster than using the
         * <code>BigDecimal(String)</code> constructor if the string is
         * already available within a character array.
         *
         * @param inchars The <code>char[]</code> array containing the number
         *                to be converted.
         * @param offset  The <code>int</code> offset into the array of the
         *                start of the number to be converted.
         * @param length  The <code>int</code> length of the number.
         * @throws NumberFormatException if the parameter is not a valid
         *                number for any reason.
         * @stable ICU 2.0
         */

        //--public BigDecimal(char inchars[],int offset,int length){super();
        function BigDecimal() {
            //-- members
            this.ind = 0;
            this.form = MathContext.prototype.PLAIN;
            this.mant = null;
            this.exp = 0;

            //-- overloaded ctor
            if (BigDecimal.arguments.length == 0) return;
            var inchars;
            var offset;
            var length;
            if (BigDecimal.arguments.length == 1) {
                inchars = BigDecimal.arguments[0];
                offset = 0;
                length = inchars.length;
            } else {
                inchars = BigDecimal.arguments[0];
                offset = BigDecimal.arguments[1];
                length = BigDecimal.arguments[2];
            }
            if (typeof inchars == "string") {
                inchars = inchars.split("");
            }

            //--boolean exotic;
            var exotic;
            //--boolean hadexp;
            var hadexp;
            //--int d;
            var d;
            //--int dotoff;
            var dotoff;
            //--int last;
            var last;
            //--int i=0;
            var i = 0;
            //--char si=0;
            var si = 0;
            //--boolean eneg=false;
            var eneg = false;
            //--int k=0;
            var k = 0;
            //--int elen=0;
            var elen = 0;
            //--int j=0;
            var j = 0;
            //--char sj=0;
            var sj = 0;
            //--int dvalue=0;
            var dvalue = 0;
            //--int mag=0;
            var mag = 0;
            // This is the primary constructor; all incoming strings end up
            // here; it uses explicit (inline) parsing for speed and to avoid
            // generating intermediate (temporary) objects of any kind.
            // 1998.06.25: exponent form built only if E/e in string
            // 1998.06.25: trailing zeros not removed for zero
            // 1999.03.06: no embedded blanks; allow offset and length
            if (length <= 0) this.bad("BigDecimal(): ", inchars); // bad conversion (empty string)
            // [bad offset will raise array bounds exception]

            /* Handle and step past sign */
            this.ind = this.ispos; // assume positive
            if (inchars[0] == '-') {
                length--;
                if (length == 0) this.bad("BigDecimal(): ", inchars); // nothing after sign
                this.ind = this.isneg;
                offset++;
            } else if (inchars[0] == '+') {
                length--;
                if (length == 0) this.bad("BigDecimal(): ", inchars); // nothing after sign
                offset++;
            }

            /* We're at the start of the number */
            exotic = false; // have extra digits
            hadexp = false; // had explicit exponent
            d = 0; // count of digits found
            dotoff = -1; // offset where dot was found
            last = -1; // last character of mantissa
            {
                var $1 = length;
                i = offset;
                i: for (; $1 > 0; $1--, i++) {
                    si = inchars[i];
                    if (si >= '0') // test for Arabic digit
                        if (si <= '9') {
                            last = i;
                            d++; // still in mantissa
                            continue i;
                        }
                    if (si == '.') {
                        // record and ignore
                        if (dotoff >= 0) this.bad("BigDecimal(): ", inchars); // two dots
                        dotoff = i - offset; // offset into mantissa
                        continue i;
                    }
                    if (si != 'e') if (si != 'E') {
                        // expect an extra digit
                        if (si < '0' || si > '9') this.bad("BigDecimal(): ", inchars); // not a number
                        // defer the base 10 check until later to avoid extra method call
                        exotic = true; // will need conversion later
                        last = i;
                        d++; // still in mantissa
                        continue i;
                    }
                    /* Found 'e' or 'E' -- now process explicit exponent */
                    // 1998.07.11: sign no longer required
                    if (i - offset > length - 2) this.bad("BigDecimal(): ", inchars); // no room for even one digit
                    eneg = false;
                    if (inchars[i + 1] == '-') {
                        eneg = true;
                        k = i + 2;
                    } else if (inchars[i + 1] == '+') k = i + 2;else k = i + 1;
                    // k is offset of first expected digit
                    elen = length - (k - offset); // possible number of digits
                    if (elen == 0 || elen > 9) this.bad("BigDecimal(): ", inchars); // 0 or more than 9 digits
                    {
                        var $2 = elen;
                        j = k;
                        j: for (; $2 > 0; $2--, j++) {
                            sj = inchars[j];
                            if (sj < '0') this.bad("BigDecimal(): ", inchars); // always bad
                            if (sj > '9') {
                                // maybe an exotic digit
                                /*if (si<'0' || si>'9')
                                this.bad(inchars); // not a number
                                dvalue=java.lang.Character.digit(sj,10); // check base
                                if (dvalue<0)
                                bad(inchars); // not base 10*/
                                this.bad("BigDecimal(): ", inchars);
                            } else dvalue = sj - '0';
                            this.exp = this.exp * 10 + dvalue;
                        }
                    }
                    /*j*/
                    if (eneg) this.exp = -this.exp; // was negative
                    hadexp = true; // remember we had one
                    break i; // we are done
                }
            }
            /*i*/

            /* Here when all inspected */
            if (d == 0) this.bad("BigDecimal(): ", inchars); // no mantissa digits
            if (dotoff >= 0) this.exp = this.exp + dotoff - d; // adjust exponent if had dot

            /* strip leading zeros/dot (leave final if all 0's) */
            {
                var $3 = last - 1;
                i = offset;
                i: for (; i <= $3; i++) {
                    si = inchars[i];
                    if (si == '0') {
                        offset++;
                        dotoff--;
                        d--;
                    } else if (si == '.') {
                        offset++; // step past dot
                        dotoff--;
                    } else if (si <= '9') break i; /* non-0 */
                    else {
                            /* exotic */
                            //if ((java.lang.Character.digit(si,10))!=0)
                            break i; // non-0 or bad
                            // is 0 .. strip like '0'
                            //offset++;
                            //dotoff--;
                            //d--;
                        }
                }
            }
            /*i*/

            /* Create the mantissa array */
            this.mant = new Array(d); // we know the length
            j = offset; // input offset
            if (exotic) {
                exotica: do {
                    // slow: check for exotica
                    {
                        var $4 = d;
                        i = 0;
                        i: for (; $4 > 0; $4--, i++) {
                            if (i == dotoff) j++; // at dot
                            sj = inchars[j];
                            if (sj <= '9') this.mant[i] = sj - '0'; /* easy */
                            else {
                                    //dvalue=java.lang.Character.digit(sj,10);
                                    //if (dvalue<0)
                                    this.bad("BigDecimal(): ", inchars); // not a number after all
                                    //mant[i]=(byte)dvalue;
                                }
                            j++;
                        }
                    }
                    /*i*/
                } while (false);
            } /*exotica*/
            else {
                    simple: do {
                        {
                            var $5 = d;
                            i = 0;
                            i: for (; $5 > 0; $5--, i++) {
                                if (i == dotoff) j++;
                                this.mant[i] = inchars[j] - '0';
                                j++;
                            }
                        }
                        /*i*/
                    } while (false);
                }
            /*simple*/

            /* Looks good.  Set the sign indicator and form, as needed. */
            // Trailing zeros are preserved
            // The rule here for form is:
            //   If no E-notation, then request plain notation
            //   Otherwise act as though add(0,DEFAULT) and request scientific notation
            // [form is already PLAIN]
            if (this.mant[0] == 0) {
                this.ind = this.iszero; // force to show zero
                // negative exponent is significant (e.g., -3 for 0.000) if plain
                if (this.exp > 0) this.exp = 0; // positive exponent can be ignored
                if (hadexp) {
                    // zero becomes single digit from add
                    this.mant = this.ZERO.mant;
                    this.exp = 0;
                }
            } else {
                // non-zero
                // [ind was set earlier]
                // now determine form
                if (hadexp) {
                    this.form = MathContext.prototype.SCIENTIFIC;
                    // 1999.06.29 check for overflow
                    mag = this.exp + this.mant.length - 1; // true exponent in scientific notation
                    if (mag < this.MinExp || mag > this.MaxExp) this.bad("BigDecimal(): ", inchars);
                }
            }
            // say 'BD(c[]): mant[0] mantlen exp ind form:' mant[0] mant.length exp ind form
            return;
        }

        /**
         * Constructs a <code>BigDecimal</code> object directly from a
         * <code>double</code>.
         * <p>
         * Constructs a <code>BigDecimal</code> which is the exact decimal
         * representation of the 64-bit signed binary floating point
         * parameter.
         * <p>
         * Note that this constructor it an exact conversion; it does not give
         * the same result as converting <code>num</code> to a
         * <code>String</code> using the <code>Double.toString()</code> method
         * and then using the {@link #BigDecimal(java.lang.String)}
         * constructor.
         * To get that result, use the static {@link #valueOf(double)}
         * method to construct a <code>BigDecimal</code> from a
         * <code>double</code>.
         *
         * @param num The <code>double</code> to be converted.
         * @throws NumberFormatException if the parameter is infinite or
         *            not a number.
         * @stable ICU 2.0
         */

        //--public BigDecimal(double num){
        //-- // 1999.03.06: use exactly the old algorithm
        //-- // 2000.01.01: note that this constructor does give an exact result,
        //-- //             so perhaps it should not be deprecated
        //-- // 2000.06.18: no longer deprecated
        //-- this((new java.math.BigDecimal(num)).toString());
        //-- return;}

        /**
         * Constructs a <code>BigDecimal</code> object directly from a
         * <code>int</code>.
         * <p>
         * Constructs a <code>BigDecimal</code> which is the exact decimal
         * representation of the 32-bit signed binary integer parameter.
         * The <code>BigDecimal</code> will contain only decimal digits,
         * prefixed with a leading minus sign (hyphen) if the parameter is
         * negative.
         * A leading zero will be present only if the parameter is zero.
         *
         * @param num The <code>int</code> to be converted.
         * @stable ICU 2.0
         */

        //--public BigDecimal(int num){super();
        //-- int mun;
        //-- int i=0;
        //-- // We fastpath commoners
        //-- if (num<=9)
        //--  if (num>=(-9))
        //--   {singledigit:do{
        //--    // very common single digit case
        //--    {/*select*/
        //--    if (num==0)
        //--     {
        //--      mant=ZERO.mant;
        //--      ind=iszero;
        //--     }
        //--    else if (num==1)
        //--     {
        //--      mant=ONE.mant;
        //--      ind=ispos;
        //--     }
        //--    else if (num==(-1))
        //--     {
        //--      mant=ONE.mant;
        //--      ind=isneg;
        //--     }
        //--    else{
        //--     {
        //--      mant=new byte[1];
        //--      if (num>0)
        //--       {
        //--        mant[0]=(byte)num;
        //--        ind=ispos;
        //--       }
        //--      else
        //--       { // num<-1
        //--        mant[0]=(byte)((int)-num);
        //--        ind=isneg;
        //--       }
        //--     }
        //--    }
        //--    }
        //--    return;
        //--   }while(false);}/*singledigit*/
        //--
        //-- /* We work on negative numbers so we handle the most negative number */
        //-- if (num>0)
        //--  {
        //--   ind=ispos;
        //--   num=(int)-num;
        //--  }
        //-- else
        //--  ind=isneg;/* negative */ // [0 case already handled]
        //-- // [it is quicker, here, to pre-calculate the length with
        //-- // one loop, then allocate exactly the right length of byte array,
        //-- // then re-fill it with another loop]
        //-- mun=num; // working copy
        //-- {i=9;i:for(;;i--){
        //--  mun=mun/10;
        //--  if (mun==0)
        //--   break i;
        //--  }
        //-- }/*i*/
        //-- // i is the position of the leftmost digit placed
        //-- mant=new byte[10-i];
        //-- {i=(10-i)-1;i:for(;;i--){
        //--  mant[i]=(byte)-(((byte)(num%10)));
        //--  num=num/10;
        //--  if (num==0)
        //--   break i;
        //--  }
        //-- }/*i*/
        //-- return;
        //-- }

        /**
         * Constructs a <code>BigDecimal</code> object directly from a
         * <code>long</code>.
         * <p>
         * Constructs a <code>BigDecimal</code> which is the exact decimal
         * representation of the 64-bit signed binary integer parameter.
         * The <code>BigDecimal</code> will contain only decimal digits,
         * prefixed with a leading minus sign (hyphen) if the parameter is
         * negative.
         * A leading zero will be present only if the parameter is zero.
         *
         * @param num The <code>long</code> to be converted.
         * @stable ICU 2.0
         */

        //--public BigDecimal(long num){super();
        //-- long mun;
        //-- int i=0;
        //-- // Not really worth fastpathing commoners in this constructor [also,
        //-- // we use this to construct the static constants].
        //-- // This is much faster than: this(String.valueOf(num).toCharArray())
        //-- /* We work on negative num so we handle the most negative number */
        //-- if (num>0)
        //--  {
        //--   ind=ispos;
        //--   num=(long)-num;
        //--  }
        //-- else
        //--  if (num==0)
        //--   ind=iszero;
        //--  else
        //--   ind=isneg;/* negative */
        //-- mun=num;
        //-- {i=18;i:for(;;i--){
        //--  mun=mun/10;
        //--  if (mun==0)
        //--   break i;
        //--  }
        //-- }/*i*/
        //-- // i is the position of the leftmost digit placed
        //-- mant=new byte[19-i];
        //-- {i=(19-i)-1;i:for(;;i--){
        //--  mant[i]=(byte)-(((byte)(num%10)));
        //--  num=num/10;
        //--  if (num==0)
        //--   break i;
        //--  }
        //-- }/*i*/
        //-- return;
        //-- }

        /**
         * Constructs a <code>BigDecimal</code> object from a <code>String</code>.
         * <p>
         * Constructs a <code>BigDecimal</code> from the parameter, which must
         * not be <code>null</code> and must represent a valid <i>number</i>,
         * as described formally in the documentation referred to
         * {@link BigDecimal above}.
         * <p>
         * In summary, numbers in <code>String</code> form must have at least
         * one digit, may have a leading sign, may have a decimal point, and
         * exponential notation may be used.  They follow conventional syntax,
         * and may not contain blanks.
         * <p>
         * Some valid strings from which a <code>BigDecimal</code> might
         * be constructed are:
         * <pre>
         *       "0"         -- Zero
         *      "12"         -- A whole number
         *     "-76"         -- A signed whole number
         *      "12.70"      -- Some decimal places
         *     "+0.003"      -- Plus sign is allowed
         *      "17."        -- The same as 17
         *        ".5"       -- The same as 0.5
         *      "4E+9"       -- Exponential notation
         *       "0.73e-7"   -- Exponential notation
         * </pre>
         * <p>
         * (Exponential notation means that the number includes an optional
         * sign and a power of ten following an '</code>E</code>' that
         * indicates how the decimal point will be shifted.  Thus the
         * <code>"4E+9"</code> above is just a short way of writing
         * <code>4000000000</code>, and the <code>"0.73e-7"</code> is short
         * for <code>0.000000073</code>.)
         * <p>
         * The <code>BigDecimal</code> constructed from the String is in a
         * standard form, with no blanks, as though the
         * {@link #add(BigDecimal)} method had been used to add zero to the
         * number with unlimited precision.
         * If the string uses exponential notation (that is, includes an
         * <code>e</code> or an <code>E</code>), then the
         * <code>BigDecimal</code> number will be expressed in scientific
         * notation (where the power of ten is adjusted so there is a single
         * non-zero digit to the left of the decimal point); in this case if
         * the number is zero then it will be expressed as the single digit 0,
         * and if non-zero it will have an exponent unless that exponent would
         * be 0.  The exponent must fit in nine digits both before and after it
         * is expressed in scientific notation.
         * <p>
         * Any digits in the parameter must be decimal; that is,
         * <code>Character.digit(c, 10)</code> (where </code>c</code> is the
         * character in question) would not return -1.
         *
         * @param string The <code>String</code> to be converted.
         * @throws NumberFormatException if the parameter is not a valid
         * number.
         * @stable ICU 2.0
         */

        //--public BigDecimal(java.lang.String string){
        //-- this(string.toCharArray(),0,string.length());
        //-- return;}

        /* <sgml> Make a default BigDecimal object for local use. </sgml> */

        //--private BigDecimal(){super();
        //-- return;
        //-- }

        /* ---------------------------------------------------------------- */
        /* Operator methods [methods which take a context parameter]        */
        /* ---------------------------------------------------------------- */

        /**
         * Returns a plain <code>BigDecimal</code> whose value is the absolute
         * value of this <code>BigDecimal</code>.
         * <p>
         * The same as {@link #abs(MathContext)}, where the context is
         * <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will
         * be <code>this.scale()</code>
         *
         * @return A <code>BigDecimal</code> whose value is the absolute
         *         value of this <code>BigDecimal</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal abs(){
        //- return this.abs(plainMC);
        //- }

        /**
         * Returns a <code>BigDecimal</code> whose value is the absolute value
         * of this <code>BigDecimal</code>.
         * <p>
         * If the current object is zero or positive, then the same result as
         * invoking the {@link #plus(MathContext)} method with the same
         * parameter is returned.
         * Otherwise, the same result as invoking the
         * {@link #negate(MathContext)} method with the same parameter is
         * returned.
         *
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is the absolute
         *             value of this <code>BigDecimal</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal abs(com.ibm.icu.math.MathContext set){
        function abs() {
            var set;
            if (abs.arguments.length == 1) {
                set = abs.arguments[0];
            } else if (abs.arguments.length == 0) {
                set = this.plainMC;
            } else {
                throw "abs(): " + abs.arguments.length + " arguments given; expected 0 or 1";
            }
            if (this.ind == this.isneg) return this.negate(set);
            return this.plus(set);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this+rhs</code>, using fixed point arithmetic.
         * <p>
         * The same as {@link #add(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will be
         * the maximum of the scales of the two operands.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the addition.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this+rhs</code>, using fixed point arithmetic.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal add(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.add(rhs,plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is <code>this+rhs</code>.
         * <p>
         * Implements the addition (<b><code>+</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the addition.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this+rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal add(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function add() {
            var set;
            if (add.arguments.length == 2) {
                set = add.arguments[1];
            } else if (add.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "add(): " + add.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = add.arguments[0];
            //--com.ibm.icu.math.BigDecimal lhs;
            var lhs;
            //--int reqdig;
            var reqdig;
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            //--byte usel[];
            var usel;
            //--int usellen;
            var usellen;
            //--byte user[];
            var user;
            //--int userlen;
            var userlen;
            //--int newlen=0;
            var newlen = 0;
            //--int tlen=0;
            var tlen = 0;
            //--int mult=0;
            var mult = 0;
            //--byte t[]=null;
            var t = null;
            //--int ia=0;
            var ia = 0;
            //--int ib=0;
            var ib = 0;
            //--int ea=0;
            var ea = 0;
            //int eb=0;
            var eb = 0;
            //byte ca=0;
            var ca = 0;
            //--byte cb=0;
            var cb = 0;
            /* determine requested digits and form */
            if (set.lostDigits) this.checkdigits(rhs, set.digits);
            lhs = this; // name for clarity and proxy

            /* Quick exit for add floating 0 */
            // plus() will optimize to return same object if possible
            if (lhs.ind == 0) if (set.form != MathContext.prototype.PLAIN) return rhs.plus(set);
            if (rhs.ind == 0) if (set.form != MathContext.prototype.PLAIN) return lhs.plus(set);

            /* Prepare numbers (round, unless unlimited precision) */
            reqdig = set.digits; // local copy (heavily used)
            if (reqdig > 0) {
                if (lhs.mant.length > reqdig) lhs = this.clone(lhs).round(set);
                if (rhs.mant.length > reqdig) rhs = this.clone(rhs).round(set);
                // [we could reuse the new LHS for result in this case]
            }

            res = new BigDecimal(); // build result here

            /* Now see how much we have to pad or truncate lhs or rhs in order
            to align the numbers.  If one number is much larger than the
            other, then the smaller cannot affect the answer [but we may
            still need to pad with up to DIGITS trailing zeros]. */
            // Note sign may be 0 if digits (reqdig) is 0
            // usel and user will be the byte arrays passed to the adder; we'll
            // use them on all paths except quick exits
            usel = lhs.mant;
            usellen = lhs.mant.length;
            user = rhs.mant;
            userlen = rhs.mant.length;
            {
                padder: do {
                    /*select*/
                    if (lhs.exp == rhs.exp) {
                        /* no padding needed */
                        // This is the most common, and fastest, path
                        res.exp = lhs.exp;
                    } else if (lhs.exp > rhs.exp) {
                        // need to pad lhs and/or truncate rhs
                        newlen = usellen + lhs.exp - rhs.exp;
                        /* If, after pad, lhs would be longer than rhs by digits+1 or
                        more (and digits>0) then rhs cannot affect answer, so we only
                        need to pad up to a length of DIGITS+1. */
                        if (newlen >= userlen + reqdig + 1) if (reqdig > 0) {
                            // LHS is sufficient
                            res.mant = usel;
                            res.exp = lhs.exp;
                            res.ind = lhs.ind;
                            if (usellen < reqdig) {
                                // need 0 padding
                                res.mant = this.extend(lhs.mant, reqdig);
                                res.exp = res.exp - (reqdig - usellen);
                            }
                            return res.finish(set, false);
                        }
                        // RHS may affect result
                        res.exp = rhs.exp; // expected final exponent
                        if (newlen > reqdig + 1) if (reqdig > 0) {
                            // LHS will be max; RHS truncated
                            tlen = newlen - reqdig - 1; // truncation length
                            userlen = userlen - tlen;
                            res.exp = res.exp + tlen;
                            newlen = reqdig + 1;
                        }
                        if (newlen > usellen) usellen = newlen; // need to pad LHS
                    } else {
                        // need to pad rhs and/or truncate lhs
                        newlen = userlen + rhs.exp - lhs.exp;
                        if (newlen >= usellen + reqdig + 1) if (reqdig > 0) {
                            // RHS is sufficient
                            res.mant = user;
                            res.exp = rhs.exp;
                            res.ind = rhs.ind;
                            if (userlen < reqdig) {
                                // need 0 padding
                                res.mant = this.extend(rhs.mant, reqdig);
                                res.exp = res.exp - (reqdig - userlen);
                            }
                            return res.finish(set, false);
                        }
                        // LHS may affect result
                        res.exp = lhs.exp; // expected final exponent
                        if (newlen > reqdig + 1) if (reqdig > 0) {
                            // RHS will be max; LHS truncated
                            tlen = newlen - reqdig - 1; // truncation length
                            usellen = usellen - tlen;
                            res.exp = res.exp + tlen;
                            newlen = reqdig + 1;
                        }
                        if (newlen > userlen) userlen = newlen; // need to pad RHS
                    }
                } while (false);
            }
            /*padder*/

            /* OK, we have aligned mantissas.  Now add or subtract. */
            // 1998.06.27 Sign may now be 0 [e.g., 0.000] .. treat as positive
            // 1999.05.27 Allow for 00 on lhs [is not larger than 2 on rhs]
            // 1999.07.10 Allow for 00 on rhs [is not larger than 2 on rhs]
            if (lhs.ind == this.iszero) res.ind = this.ispos;else res.ind = lhs.ind; // likely sign, all paths
            if ((lhs.ind == this.isneg ? 1 : 0) == (rhs.ind == this.isneg ? 1 : 0)) // same sign, 0 non-negative
                mult = 1;else {
                signdiff: do {
                    // different signs, so subtraction is needed
                    mult = -1; // will cause subtract
                    /* Before we can subtract we must determine which is the larger,
                    as our add/subtract routine only handles non-negative results
                    so we may need to swap the operands. */
                    {
                        swaptest: do {
                            /*select*/
                            if (rhs.ind == this.iszero) {} // original A bigger
                            else if (usellen < userlen || lhs.ind == this.iszero) {
                                    // original B bigger
                                    t = usel;
                                    usel = user;
                                    user = t; // swap
                                    tlen = usellen;
                                    usellen = userlen;
                                    userlen = tlen; // ..
                                    res.ind = -res.ind; // and set sign
                                } else if (usellen > userlen) {} // original A bigger
                                else {
                                        {
                                            /* logical lengths the same */ // need compare
                                            /* may still need to swap: compare the strings */
                                            ia = 0;
                                            ib = 0;
                                            ea = usel.length - 1;
                                            eb = user.length - 1;
                                            {
                                                compare: for (;;) {
                                                    if (ia <= ea) ca = usel[ia];else {
                                                        if (ib > eb) {
                                                            /* identical */
                                                            if (set.form != MathContext.prototype.PLAIN) return this.ZERO;
                                                            // [if PLAIN we must do the subtract, in case of 0.000 results]
                                                            break compare;
                                                        }
                                                        ca = 0;
                                                    }
                                                    if (ib <= eb) cb = user[ib];else cb = 0;
                                                    if (ca != cb) {
                                                        if (ca < cb) {
                                                            /* swap needed */
                                                            t = usel;
                                                            usel = user;
                                                            user = t; // swap
                                                            tlen = usellen;
                                                            usellen = userlen;
                                                            userlen = tlen; // ..
                                                            res.ind = -res.ind;
                                                        }
                                                        break compare;
                                                    }
                                                    /* mantissas the same, so far */
                                                    ia++;
                                                    ib++;
                                                }
                                            }
                                            /*compare*/
                                        } // lengths the same
                                    }
                        } while (false);
                    }
                    /*swaptest*/
                } while (false);
            }
            /*signdiff*/

            /* here, A is > B if subtracting */
            // add [A+B*1] or subtract [A+(B*-1)]
            res.mant = this.byteaddsub(usel, usellen, user, userlen, mult, false);
            // [reuse possible only after chop; accounting makes not worthwhile]

            // Finish() rounds before stripping leading 0's, then sets form, etc.
            return res.finish(set, false);
        }

        /**
         * Compares this <code>BigDecimal</code> to another, using unlimited
         * precision.
         * <p>
         * The same as {@link #compareTo(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the comparison.
         * @return     An <code>int</code> whose value is -1, 0, or 1 as
         *             <code>this</code> is numerically less than, equal to,
         *             or greater than <code>rhs</code>.
         * @see    #compareTo(Object)
         * @stable ICU 2.0
         */

        //--public int compareTo(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.compareTo(rhs,plainMC);
        //-- }

        /**
         * Compares this <code>BigDecimal</code> to another.
         * <p>
         * Implements numeric comparison,
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns a result of type <code>int</code>.
         * <p>
         * The result will be:
         * <table cellpadding=2><tr>
         * <td align=right><b>-1</b></td>
         * <td>if the current object is less than the first parameter</td>
         * </tr><tr>
         * <td align=right><b>0</b></td>
         * <td>if the current object is equal to the first parameter</td>
         * </tr><tr>
         * <td align=right><b>1</b></td>
         * <td>if the current object is greater than the first parameter.</td>
         * </tr></table>
         * <p>
         * A {@link #compareTo(Object)} method is also provided.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the comparison.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     An <code>int</code> whose value is -1, 0, or 1 as
         *             <code>this</code> is numerically less than, equal to,
         *             or greater than <code>rhs</code>.
         * @see    #compareTo(Object)
         * @stable ICU 2.0
         */

        //public int compareTo(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function compareTo() {
            var set;
            if (compareTo.arguments.length == 2) {
                set = compareTo.arguments[1];
            } else if (compareTo.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "compareTo(): " + compareTo.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = compareTo.arguments[0];
            //--int thislength=0;
            var thislength = 0;
            //--int i=0;
            var i = 0;
            //--com.ibm.icu.math.BigDecimal newrhs;
            var newrhs;
            // rhs=null will raise NullPointerException, as per Comparable interface
            if (set.lostDigits) this.checkdigits(rhs, set.digits);
            // [add will recheck in slowpath cases .. but would report -rhs]
            if (this.ind == rhs.ind && this.exp == rhs.exp) {
                /* sign & exponent the same [very common] */
                thislength = this.mant.length;
                if (thislength < rhs.mant.length) return -this.ind;
                if (thislength > rhs.mant.length) return this.ind;
                /* lengths are the same; we can do a straight mantissa compare
                unless maybe rounding [rounding is very unusual] */
                if (thislength <= set.digits || set.digits == 0) {
                    {
                        var $6 = thislength;
                        i = 0;
                        i: for (; $6 > 0; $6--, i++) {
                            if (this.mant[i] < rhs.mant[i]) return -this.ind;
                            if (this.mant[i] > rhs.mant[i]) return this.ind;
                        }
                    }
                    /*i*/
                    return 0; // identical
                }
                /* drop through for full comparison */
            } else {
                /* More fastpaths possible */
                if (this.ind < rhs.ind) return -1;
                if (this.ind > rhs.ind) return 1;
            }
            /* carry out a subtract to make the comparison */
            newrhs = this.clone(rhs); // safe copy
            newrhs.ind = -newrhs.ind; // prepare to subtract
            return this.add(newrhs, set).ind; // add, and return sign of result
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this/rhs</code>, using fixed point arithmetic.
         * <p>
         * The same as {@link #divide(BigDecimal, int)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the rounding mode is {@link MathContext#ROUND_HALF_UP}.
         *
         * The length of the decimal part (the scale) of the result will be
         * the same as the scale of the current object, if the latter were
         * formatted without exponential notation.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the division.
         * @return     A plain <code>BigDecimal</code> whose value is
         *             <code>this/rhs</code>, using fixed point arithmetic.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal divide(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.dodivide('D',rhs,plainMC,-1);
        //-- }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this/rhs</code>, using fixed point arithmetic and a
         * rounding mode.
         * <p>
         * The same as {@link #divide(BigDecimal, int, int)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the second parameter is <code>this.scale()</code>, and
         * the third is <code>round</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will
         * therefore be the same as the scale of the current object, if the
         * latter were formatted without exponential notation.
         * <p>
         * @param  rhs   The <code>BigDecimal</code> for the right hand side of
         *               the division.
         * @param  round The <code>int</code> rounding mode to be used for
         *               the division (see the {@link MathContext} class).
         * @return       A plain <code>BigDecimal</code> whose value is
         *               <code>this/rhs</code>, using fixed point arithmetic
         *               and the specified rounding mode.
         * @throws IllegalArgumentException if <code>round</code> is not a
         *               valid rounding mode.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @throws ArithmeticException if <code>round</code> is {@link
            *               MathContext#ROUND_UNNECESSARY} and
         *               <code>this.scale()</code> is insufficient to
         *               represent the result exactly.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal divide(com.ibm.icu.math.BigDecimal rhs,int round){
        //-- com.ibm.icu.math.MathContext set;
        //-- set=new com.ibm.icu.math.MathContext(0,com.ibm.icu.math.MathContext.PLAIN,false,round); // [checks round, too]
        //-- return this.dodivide('D',rhs,set,-1); // take scale from LHS
        //-- }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this/rhs</code>, using fixed point arithmetic and a
         * given scale and rounding mode.
         * <p>
         * The same as {@link #divide(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * <code>new MathContext(0, MathContext.PLAIN, false, round)</code>,
         * except that the length of the decimal part (the scale) to be used
         * for the result is explicit rather than being taken from
         * <code>this</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will be
         * the same as the scale of the current object, if the latter were
         * formatted without exponential notation.
         * <p>
         * @param  rhs   The <code>BigDecimal</code> for the right hand side of
         *               the division.
         * @param  scale The <code>int</code> scale to be used for the result.
         * @param  round The <code>int</code> rounding mode to be used for
         *               the division (see the {@link MathContext} class).
         * @return       A plain <code>BigDecimal</code> whose value is
         *               <code>this/rhs</code>, using fixed point arithmetic
         *               and the specified rounding mode.
         * @throws IllegalArgumentException if <code>round</code> is not a
         *               valid rounding mode.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @throws ArithmeticException if <code>scale</code> is negative.
         * @throws ArithmeticException if <code>round</code> is {@link
            *               MathContext#ROUND_UNNECESSARY} and <code>scale</code>
         *               is insufficient to represent the result exactly.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal divide(com.ibm.icu.math.BigDecimal rhs,int scale,int round){
        //-- com.ibm.icu.math.MathContext set;
        //-- if (scale<0)
        //--  throw new java.lang.ArithmeticException("Negative scale:"+" "+scale);
        //-- set=new com.ibm.icu.math.MathContext(0,com.ibm.icu.math.MathContext.PLAIN,false,round); // [checks round]
        //-- return this.dodivide('D',rhs,set,scale);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is <code>this/rhs</code>.
         * <p>
         * Implements the division (<b><code>/</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the division.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this/rhs</code>.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal divide(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function divide() {
            var set;
            var scale = -1;
            if (divide.arguments.length == 2) {
                if (typeof divide.arguments[1] == 'number') {
                    set = new MathContext(0, MathContext.prototype.PLAIN, false, divide.arguments[1]); // [checks round, too]
                } else {
                    set = divide.arguments[1];
                }
            } else if (divide.arguments.length == 3) {
                scale = divide.arguments[1];
                if (scale < 0) throw "divide(): Negative scale: " + scale;
                set = new MathContext(0, MathContext.prototype.PLAIN, false, divide.arguments[2]); // [checks round]
            } else if (divide.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "divide(): " + divide.arguments.length + " arguments given; expected between 1 and 3";
            }
            var rhs = divide.arguments[0];
            return this.dodivide('D', rhs, set, scale);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is the integer
         * part of <code>this/rhs</code>.
         * <p>
         * The same as {@link #divideInteger(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the integer division.
         * @return     A <code>BigDecimal</code> whose value is the integer
         *             part of <code>this/rhs</code>.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal divideInteger(com.ibm.icu.math.BigDecimal rhs){
        //-- // scale 0 to drop .000 when plain
        //-- return this.dodivide('I',rhs,plainMC,0);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is the integer
         * part of <code>this/rhs</code>.
         * <p>
         * Implements the integer division operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the integer division.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is the integer
         *             part of <code>this/rhs</code>.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @throws ArithmeticException if the result will not fit in the
         *             number of digits specified for the context.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal divideInteger(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function divideInteger() {
            var set;
            if (divideInteger.arguments.length == 2) {
                set = divideInteger.arguments[1];
            } else if (divideInteger.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "divideInteger(): " + divideInteger.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = divideInteger.arguments[0];
            // scale 0 to drop .000 when plain
            return this.dodivide('I', rhs, set, 0);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * the maximum of <code>this</code> and <code>rhs</code>.
         * <p>
         * The same as {@link #max(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the comparison.
         * @return     A <code>BigDecimal</code> whose value is
         *             the maximum of <code>this</code> and <code>rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal max(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.max(rhs,plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is
         * the maximum of <code>this</code> and <code>rhs</code>.
         * <p>
         * Returns the larger of the current object and the first parameter.
         * <p>
         * If calling the {@link #compareTo(BigDecimal, MathContext)} method
         * with the same parameters would return <code>1</code> or
         * <code>0</code>, then the result of calling the
         * {@link #plus(MathContext)} method on the current object (using the
         * same <code>MathContext</code> parameter) is returned.
         * Otherwise, the result of calling the {@link #plus(MathContext)}
         * method on the first parameter object (using the same
         * <code>MathContext</code> parameter) is returned.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the comparison.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             the maximum of <code>this</code> and <code>rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal max(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function max() {
            var set;
            if (max.arguments.length == 2) {
                set = max.arguments[1];
            } else if (max.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "max(): " + max.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = max.arguments[0];
            if (this.compareTo(rhs, set) >= 0) return this.plus(set);else return rhs.plus(set);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * the minimum of <code>this</code> and <code>rhs</code>.
         * <p>
         * The same as {@link #min(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the comparison.
         * @return     A <code>BigDecimal</code> whose value is
         *             the minimum of <code>this</code> and <code>rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal min(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.min(rhs,plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is
         * the minimum of <code>this</code> and <code>rhs</code>.
         * <p>
         * Returns the smaller of the current object and the first parameter.
         * <p>
         * If calling the {@link #compareTo(BigDecimal, MathContext)} method
         * with the same parameters would return <code>-1</code> or
         * <code>0</code>, then the result of calling the
         * {@link #plus(MathContext)} method on the current object (using the
         * same <code>MathContext</code> parameter) is returned.
         * Otherwise, the result of calling the {@link #plus(MathContext)}
         * method on the first parameter object (using the same
         * <code>MathContext</code> parameter) is returned.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the comparison.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             the minimum of <code>this</code> and <code>rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal min(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function min() {
            var set;
            if (min.arguments.length == 2) {
                set = min.arguments[1];
            } else if (min.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "min(): " + min.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = min.arguments[0];
            if (this.compareTo(rhs, set) <= 0) return this.plus(set);else return rhs.plus(set);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this*rhs</code>, using fixed point arithmetic.
         * <p>
         * The same as {@link #add(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will be
         * the sum of the scales of the operands, if they were formatted
         * without exponential notation.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the multiplication.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this*rhs</code>, using fixed point arithmetic.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal multiply(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.multiply(rhs,plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is <code>this*rhs</code>.
         * <p>
         * Implements the multiplication (<b><code>*</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the multiplication.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this*rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal multiply(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function multiply() {
            var set;
            if (multiply.arguments.length == 2) {
                set = multiply.arguments[1];
            } else if (multiply.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "multiply(): " + multiply.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = multiply.arguments[0];
            //--com.ibm.icu.math.BigDecimal lhs;
            var lhs;
            //--int padding;
            var padding;
            //--int reqdig;
            var reqdig;
            //--byte multer[]=null;
            var multer = null;
            //--byte multand[]=null;
            var multand = null;
            //--int multandlen;
            var multandlen;
            //--int acclen=0;
            var acclen = 0;
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            //--byte acc[];
            var acc;
            //--int n=0;
            var n = 0;
            //--byte mult=0;
            var mult = 0;
            if (set.lostDigits) this.checkdigits(rhs, set.digits);
            lhs = this; // name for clarity and proxy

            /* Prepare numbers (truncate, unless unlimited precision) */
            padding = 0; // trailing 0's to add
            reqdig = set.digits; // local copy
            if (reqdig > 0) {
                if (lhs.mant.length > reqdig) lhs = this.clone(lhs).round(set);
                if (rhs.mant.length > reqdig) rhs = this.clone(rhs).round(set);
                // [we could reuse the new LHS for result in this case]
            } else {
                /* unlimited */
                // fixed point arithmetic will want every trailing 0; we add these
                // after the calculation rather than before, for speed.
                if (lhs.exp > 0) padding = padding + lhs.exp;
                if (rhs.exp > 0) padding = padding + rhs.exp;
            }

            // For best speed, as in DMSRCN, we use the shorter number as the
            // multiplier and the longer as the multiplicand.
            // 1999.12.22: We used to special case when the result would fit in
            //             a long, but with Java 1.3 this gave no advantage.
            if (lhs.mant.length < rhs.mant.length) {
                multer = lhs.mant;
                multand = rhs.mant;
            } else {
                multer = rhs.mant;
                multand = lhs.mant;
            }

            /* Calculate how long result byte array will be */
            multandlen = multer.length + multand.length - 1; // effective length
            // optimize for 75% of the cases where a carry is expected...
            if (multer[0] * multand[0] > 9) acclen = multandlen + 1;else acclen = multandlen;

            /* Now the main long multiplication loop */
            res = new BigDecimal(); // where we'll build result
            acc = this.createArrayWithZeros(acclen); // accumulator, all zeros
            // 1998.07.01: calculate from left to right so that accumulator goes
            // to likely final length on first addition; this avoids a one-digit
            // extension (and object allocation) each time around the loop.
            // Initial number therefore has virtual zeros added to right.
            {
                var $7 = multer.length;
                n = 0;
                n: for (; $7 > 0; $7--, n++) {
                    mult = multer[n];
                    if (mult != 0) {
                        // [optimization]
                        // accumulate [accumulator is reusable array]
                        acc = this.byteaddsub(acc, acc.length, multand, multandlen, mult, true);
                    }
                    // divide multiplicand by 10 for next digit to right
                    multandlen--; // 'virtual length'
                }
            }
            /*n*/

            res.ind = lhs.ind * rhs.ind; // final sign
            res.exp = lhs.exp + rhs.exp - padding; // final exponent
            // [overflow is checked by finish]

            /* add trailing zeros to the result, if necessary */
            if (padding == 0) res.mant = acc;else res.mant = this.extend(acc, acc.length + padding); // add trailing 0s
            return res.finish(set, false);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>-this</code>.
         * <p>
         * The same as {@link #negate(MathContext)}, where the context is
         * <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will be
         * be <code>this.scale()</code>
         *
         *
         * @return A <code>BigDecimal</code> whose value is
         *         <code>-this</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal negate(){
        //-- return this.negate(plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is <code>-this</code>.
         * <p>
         * Implements the negation (Prefix <b><code>-</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         *
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return A <code>BigDecimal</code> whose value is
         *         <code>-this</code>.
         * @stable ICU 2.0
         */

        //public com.ibm.icu.math.BigDecimal negate(com.ibm.icu.math.MathContext set){
        function negate() {
            var set;
            if (negate.arguments.length == 1) {
                set = negate.arguments[0];
            } else if (negate.arguments.length == 0) {
                set = this.plainMC;
            } else {
                throw "negate(): " + negate.arguments.length + " arguments given; expected 0 or 1";
            }
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            // Originally called minus(), changed to matched Java precedents
            // This simply clones, flips the sign, and possibly rounds
            if (set.lostDigits) this.checkdigits(null, set.digits);
            res = this.clone(this); // safe copy
            res.ind = -res.ind;
            return res.finish(set, false);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>+this</code>.
         * Note that <code>this</code> is not necessarily a
         * plain <code>BigDecimal</code>, but the result will always be.
         * <p>
         * The same as {@link #plus(MathContext)}, where the context is
         * <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will be
         * be <code>this.scale()</code>
         *
         * @return A <code>BigDecimal</code> whose value is
         *         <code>+this</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal plus(){
        //-- return this.plus(plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is
         * <code>+this</code>.
         * <p>
         * Implements the plus (Prefix <b><code>+</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         * <p>
         * This method is useful for rounding or otherwise applying a context
         * to a decimal value.
         *
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return A <code>BigDecimal</code> whose value is
         *         <code>+this</code>.
         * @stable ICU 2.0
         */

        //public com.ibm.icu.math.BigDecimal plus(com.ibm.icu.math.MathContext set){
        function plus() {
            var set;
            if (plus.arguments.length == 1) {
                set = plus.arguments[0];
            } else if (plus.arguments.length == 0) {
                set = this.plainMC;
            } else {
                throw "plus(): " + plus.arguments.length + " arguments given; expected 0 or 1";
            }
            // This clones and forces the result to the new settings
            // May return same object
            if (set.lostDigits) this.checkdigits(null, set.digits);
            // Optimization: returns same object for some common cases
            if (set.form == MathContext.prototype.PLAIN) if (this.form == MathContext.prototype.PLAIN) {
                if (this.mant.length <= set.digits) return this;
                if (set.digits == 0) return this;
            }
            return this.clone(this).finish(set, false);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this**rhs</code>, using fixed point arithmetic.
         * <p>
         * The same as {@link #pow(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The parameter is the power to which the <code>this</code> will be
         * raised; it must be in the range 0 through 999999999, and must
         * have a decimal part of zero.  Note that these restrictions may be
         * removed in the future, so they should not be used as a test for a
         * whole number.
         * <p>
         * In addition, the power must not be negative, as no
         * <code>MathContext</code> is used and so the result would then
         * always be 0.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the operation (the power).
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this**rhs</code>, using fixed point arithmetic.
         * @throws ArithmeticException if <code>rhs</code> is out of range or
         *             is not a whole number.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal pow(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.pow(rhs,plainMC);
        //-- }
        // The name for this method is inherited from the precedent set by the
        // BigInteger and Math classes.

        /**
         * Returns a <code>BigDecimal</code> whose value is <code>this**rhs</code>.
         * <p>
         * Implements the power (<b><code>**</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         * <p>
         * The first parameter is the power to which the <code>this</code>
         * will be raised; it must be in the range -999999999 through
         * 999999999, and must have a decimal part of zero.  Note that these
         * restrictions may be removed in the future, so they should not be
         * used as a test for a whole number.
         * <p>
         * If the <code>digits</code> setting of the <code>MathContext</code>
         * parameter is 0, the power must be zero or positive.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the operation (the power).
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this**rhs</code>.
         * @throws ArithmeticException if <code>rhs</code> is out of range or
         *             is not a whole number.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal pow(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function pow() {
            var set;
            if (pow.arguments.length == 2) {
                set = pow.arguments[1];
            } else if (pow.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "pow(): " + pow.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = pow.arguments[0];
            //--int n;
            var n;
            //--com.ibm.icu.math.BigDecimal lhs;
            var lhs;
            //--int reqdig;
            var reqdig;
            //-- int workdigits=0;
            var workdigits = 0;
            //--int L=0;
            var L = 0;
            //--com.ibm.icu.math.MathContext workset;
            var workset;
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            //--boolean seenbit;
            var seenbit;
            //--int i=0;
            var i = 0;
            if (set.lostDigits) this.checkdigits(rhs, set.digits);
            n = rhs.intcheck(this.MinArg, this.MaxArg); // check RHS by the rules
            lhs = this; // clarified name

            reqdig = set.digits; // local copy (heavily used)
            if (reqdig == 0) {
                if (rhs.ind == this.isneg)
                    //--throw new java.lang.ArithmeticException("Negative power:"+" "+rhs.toString());
                    throw "pow(): Negative power: " + rhs.toString();
                workdigits = 0;
            } else {
                /* non-0 digits */
                if (rhs.mant.length + rhs.exp > reqdig)
                    //--throw new java.lang.ArithmeticException("Too many digits:"+" "+rhs.toString());
                    throw "pow(): Too many digits: " + rhs.toString();

                /* Round the lhs to DIGITS if need be */
                if (lhs.mant.length > reqdig) lhs = this.clone(lhs).round(set);

                /* L for precision calculation [see ANSI X3.274-1996] */
                L = rhs.mant.length + rhs.exp; // length without decimal zeros/exp
                workdigits = reqdig + L + 1; // calculate the working DIGITS
            }

            /* Create a copy of set for working settings */
            // Note: no need to check for lostDigits again.
            // 1999.07.17 Note: this construction must follow RHS check
            workset = new MathContext(workdigits, set.form, false, set.roundingMode);

            res = this.ONE; // accumulator
            if (n == 0) return res; // x**0 == 1
            if (n < 0) n = -n; // [rhs.ind records the sign]
            seenbit = false; // set once we've seen a 1-bit
            {
                i = 1;
                i: for (;; i++) {
                    // for each bit [top bit ignored]
                    //n=n+n; // shift left 1 bit
                    n <<= 1;
                    if (n < 0) {
                        // top bit is set
                        seenbit = true; // OK, we're off
                        res = res.multiply(lhs, workset); // acc=acc*x
                    }
                    if (i == 31) break i; // that was the last bit
                    if (!seenbit) continue i; // we don't have to square 1
                    res = res.multiply(res, workset); // acc=acc*acc [square]
                }
            }
            /*i*/ // 32 bits
            if (rhs.ind < 0) // was a **-n [hence digits>0]
                res = this.ONE.divide(res, workset); // .. so acc=1/acc
            return res.finish(set, true); // round and strip [original digits]
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * the remainder of <code>this/rhs</code>, using fixed point arithmetic.
         * <p>
         * The same as {@link #remainder(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * This is not the modulo operator -- the result may be negative.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the remainder operation.
         * @return     A <code>BigDecimal</code> whose value is the remainder
         *             of <code>this/rhs</code>, using fixed point arithmetic.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal remainder(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.dodivide('R',rhs,plainMC,-1);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is the remainder of
         * <code>this/rhs</code>.
         * <p>
         * Implements the remainder operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         * <p>
         * This is not the modulo operator -- the result may be negative.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the remainder operation.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is the remainder
         *             of <code>this+rhs</code>.
         * @throws ArithmeticException if <code>rhs</code> is zero.
         * @throws ArithmeticException if the integer part of the result will
         *             not fit in the number of digits specified for the
         *             context.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal remainder(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function remainder() {
            var set;
            if (remainder.arguments.length == 2) {
                set = remainder.arguments[1];
            } else if (remainder.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "remainder(): " + remainder.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = remainder.arguments[0];
            return this.dodivide('R', rhs, set, -1);
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose value is
         * <code>this-rhs</code>, using fixed point arithmetic.
         * <p>
         * The same as {@link #subtract(BigDecimal, MathContext)},
         * where the <code>BigDecimal</code> is <code>rhs</code>,
         * and the context is <code>new MathContext(0, MathContext.PLAIN)</code>.
         * <p>
         * The length of the decimal part (the scale) of the result will be
         * the maximum of the scales of the two operands.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the subtraction.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this-rhs</code>, using fixed point arithmetic.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal subtract(com.ibm.icu.math.BigDecimal rhs){
        //-- return this.subtract(rhs,plainMC);
        //-- }

        /**
         * Returns a <code>BigDecimal</code> whose value is <code>this-rhs</code>.
         * <p>
         * Implements the subtraction (<b><code>-</code></b>) operator
         * (as defined in the decimal documentation, see {@link BigDecimal
        * class header}),
         * and returns the result as a <code>BigDecimal</code> object.
         *
         * @param  rhs The <code>BigDecimal</code> for the right hand side of
         *             the subtraction.
         * @param  set The <code>MathContext</code> arithmetic settings.
         * @return     A <code>BigDecimal</code> whose value is
         *             <code>this-rhs</code>.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal subtract(com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set){
        function subtract() {
            var set;
            if (subtract.arguments.length == 2) {
                set = subtract.arguments[1];
            } else if (subtract.arguments.length == 1) {
                set = this.plainMC;
            } else {
                throw "subtract(): " + subtract.arguments.length + " arguments given; expected 1 or 2";
            }
            var rhs = subtract.arguments[0];
            //--com.ibm.icu.math.BigDecimal newrhs;
            var newrhs;
            if (set.lostDigits) this.checkdigits(rhs, set.digits);
            // [add will recheck .. but would report -rhs]
            /* carry out the subtraction */
            // we could fastpath -0, but it is too rare.
            newrhs = this.clone(rhs); // safe copy
            newrhs.ind = -newrhs.ind; // prepare to subtract
            return this.add(newrhs, set); // arithmetic
        }

        /* ---------------------------------------------------------------- */
        /* Other methods                                                    */
        /* ---------------------------------------------------------------- */

        /**
         * Converts this <code>BigDecimal</code> to a <code>byte</code>.
         * If the <code>BigDecimal</code> has a non-zero decimal part or is
         * out of the possible range for a <code>byte</code> (8-bit signed
         * integer) result then an <code>ArithmeticException</code> is thrown.
         *
         * @return A <code>byte</code> equal in value to <code>this</code>.
         * @throws ArithmeticException if <code>this</code> has a non-zero
         *                 decimal part, or will not fit in a <code>byte</code>.
         * @stable ICU 2.0
         */

        //--public byte byteValueExact(){
        //-- int num;
        //-- num=this.intValueExact(); // will check decimal part too
        //-- if ((num>127)|(num<(-128)))
        //--  throw new java.lang.ArithmeticException("Conversion overflow:"+" "+this.toString());
        //-- return (byte)num;
        //-- }

        /**
         * Compares this <code>BigDecimal</code> with the value of the parameter.
         * <p>
         * If the parameter is <code>null</code>, or is not an instance of the
         * <code>BigDecimal</code> type, an exception is thrown.
         * Otherwise, the parameter is cast to type <code>BigDecimal</code>
         * and the result of the {@link #compareTo(BigDecimal)} method,
         * using the cast parameter, is returned.
         * <p>
         * The {@link #compareTo(BigDecimal, MathContext)} method should be
         * used when a <code>MathContext</code> is needed for the comparison.
         *
         * @param  rhs The <code>Object</code> for the right hand side of
         *             the comparison.
         * @return     An <code>int</code> whose value is -1, 0, or 1 as
         *             <code>this</code> is numerically less than, equal to,
         *             or greater than <code>rhs</code>.
         * @throws ClassCastException if <code>rhs</code> cannot be cast to
         *                 a <code>BigDecimal</code> object.
         * @see    #compareTo(BigDecimal)
         * @stable ICU 2.0
         */

        //--public int compareTo(java.lang.Object rhsobj){
        //-- // the cast in the next line will raise ClassCastException if necessary
        //-- return compareTo((com.ibm.icu.math.BigDecimal)rhsobj,plainMC);
        //-- }

        /**
         * Converts this <code>BigDecimal</code> to a <code>double</code>.
         * If the <code>BigDecimal</code> is out of the possible range for a
         * <code>double</code> (64-bit signed floating point) result then an
         * <code>ArithmeticException</code> is thrown.
         * <p>
         * The double produced is identical to result of expressing the
         * <code>BigDecimal</code> as a <code>String</code> and then
         * converting it using the <code>Double(String)</code> constructor;
         * this can result in values of <code>Double.NEGATIVE_INFINITY</code>
         * or <code>Double.POSITIVE_INFINITY</code>.
         *
         * @return A <code>double</code> corresponding to <code>this</code>.
         * @stable ICU 2.0
         */

        //--public double doubleValue(){
        //-- // We go via a String [as does BigDecimal in JDK 1.2]
        //-- // Next line could possibly raise NumberFormatException
        //-- return java.lang.Double.valueOf(this.toString()).doubleValue();
        //-- }

        /**
         * Compares this <code>BigDecimal</code> with <code>rhs</code> for
         * equality.
         * <p>
         * If the parameter is <code>null</code>, or is not an instance of the
         * BigDecimal type, or is not exactly equal to the current
         * <code>BigDecimal</code> object, then <i>false</i> is returned.
         * Otherwise, <i>true</i> is returned.
         * <p>
         * "Exactly equal", here, means that the <code>String</code>
         * representations of the <code>BigDecimal</code> numbers are
         * identical (they have the same characters in the same sequence).
         * <p>
         * The {@link #compareTo(BigDecimal, MathContext)} method should be
         * used for more general comparisons.
         * @param  rhs The <code>Object</code> for the right hand side of
         *             the comparison.
         * @return     A <code>boolean</code> whose value <i>true</i> if and
         *             only if the operands have identical string representations.
         * @throws ClassCastException if <code>rhs</code> cannot be cast to
         *                 a <code>BigDecimal</code> object.
         * @stable ICU 2.0
         * @see    #compareTo(Object)
         * @see    #compareTo(BigDecimal)
         * @see    #compareTo(BigDecimal, MathContext)
         */

        //--public boolean equals(java.lang.Object obj){
        function equals(obj) {
            //--com.ibm.icu.math.BigDecimal rhs;
            var rhs;
            //--int i=0;
            var i = 0;
            //--char lca[]=null;
            var lca = null;
            //--char rca[]=null;
            var rca = null;
            // We are equal iff toString of both are exactly the same
            if (obj == null) return false; // not equal
            if (!(obj instanceof BigDecimal)) return false; // not a decimal
            rhs = obj; // cast; we know it will work
            if (this.ind != rhs.ind) return false; // different signs never match
            if (this.mant.length == rhs.mant.length && this.exp == rhs.exp && this.form == rhs.form) {
                // mantissas say all
                // here with equal-length byte arrays to compare
                {
                    var $8 = this.mant.length;
                    i = 0;
                    i: for (; $8 > 0; $8--, i++) {
                        if (this.mant[i] != rhs.mant[i]) return false;
                    }
                }
                /*i*/
            } else {
                // need proper layout
                lca = this.layout(); // layout to character array
                rca = rhs.layout();
                if (lca.length != rca.length) return false; // mismatch
                // here with equal-length character arrays to compare
                {
                    var $9 = lca.length;
                    i = 0;
                    i: for (; $9 > 0; $9--, i++) {
                        if (lca[i] != rca[i]) return false;
                    }
                }
                /*i*/
            }
            return true; // arrays have identical content
        }

        /**
         * Converts this <code>BigDecimal</code> to a <code>float</code>.
         * If the <code>BigDecimal</code> is out of the possible range for a
         * <code>float</code> (32-bit signed floating point) result then an
         * <code>ArithmeticException</code> is thrown.
         * <p>
         * The float produced is identical to result of expressing the
         * <code>BigDecimal</code> as a <code>String</code> and then
         * converting it using the <code>Float(String)</code> constructor;
         * this can result in values of <code>Float.NEGATIVE_INFINITY</code>
         * or <code>Float.POSITIVE_INFINITY</code>.
         *
         * @return A <code>float</code> corresponding to <code>this</code>.
         * @stable ICU 2.0
         */

        //--public float floatValue(){
        //-- return java.lang.Float.valueOf(this.toString()).floatValue();
        //-- }

        /**
         * Returns the <code>String</code> representation of this
         * <code>BigDecimal</code>, modified by layout parameters.
         * <p>
         * <i>This method is provided as a primitive for use by more
         * sophisticated classes, such as <code>DecimalFormat</code>, that
         * can apply locale-sensitive editing of the result.  The level of
         * formatting that it provides is a necessary part of the BigDecimal
         * class as it is sensitive to and must follow the calculation and
         * rounding rules for BigDecimal arithmetic.
         * However, if the function is provided elsewhere, it may be removed
         * from this class. </i>
         * <p>
         * The parameters, for both forms of the <code>format</code> method
         * are all of type <code>int</code>.
         * A value of -1 for any parameter indicates that the default action
         * or value for that parameter should be used.
         * <p>
         * The parameters, <code>before</code> and <code>after</code>,
         * specify the number of characters to be used for the integer part
         * and decimal part of the result respectively.  Exponential notation
         * is not used. If either parameter is -1 (which indicates the default
         * action), the number of characters used will be exactly as many as
         * are needed for that part.
         * <p>
         * <code>before</code> must be a positive number; if it is larger than
         * is needed to contain the integer part, that part is padded on the
         * left with blanks to the requested length. If <code>before</code> is
         * not large enough to contain the integer part of the number
         * (including the sign, for negative numbers) an exception is thrown.
         * <p>
         * <code>after</code> must be a non-negative number; if it is not the
         * same size as the decimal part of the number, the number will be
         * rounded (or extended with zeros) to fit.  Specifying 0 for
         * <code>after</code> will cause the number to be rounded to an
         * integer (that is, it will have no decimal part or decimal point).
         * The rounding method will be the default,
         * <code>MathContext.ROUND_HALF_UP</code>.
         * <p>
         * Other rounding methods, and the use of exponential notation, can
         * be selected by using {@link #format(int,int,int,int,int,int)}.
         * Using the two-parameter form of the method has exactly the same
         * effect as using the six-parameter form with the final four
         * parameters all being -1.
         *
         * @param  before The <code>int</code> specifying the number of places
         *                before the decimal point.  Use -1 for 'as many as
         *                are needed'.
         * @param  after  The <code>int</code> specifying the number of places
         *                after the decimal point.  Use -1 for 'as many as are
         *                needed'.
         * @return        A <code>String</code> representing this
         *                <code>BigDecimal</code>, laid out according to the
         *                specified parameters
         * @throws ArithmeticException if the number cannot be laid out as
         *                requested.
         * @throws IllegalArgumentException if a parameter is out of range.
         * @stable ICU 2.0
         * @see    #toString
         * @see    #toCharArray
         */

        //--public java.lang.String format(int before,int after){
        //-- return format(before,after,-1,-1,com.ibm.icu.math.MathContext.SCIENTIFIC,ROUND_HALF_UP);
        //-- }

        /**
         * Returns the <code>String</code> representation of this
         * <code>BigDecimal</code>, modified by layout parameters and allowing
         * exponential notation.
         * <p>
         * <i>This method is provided as a primitive for use by more
         * sophisticated classes, such as <code>DecimalFormat</code>, that
         * can apply locale-sensitive editing of the result.  The level of
         * formatting that it provides is a necessary part of the BigDecimal
         * class as it is sensitive to and must follow the calculation and
         * rounding rules for BigDecimal arithmetic.
         * However, if the function is provided elsewhere, it may be removed
         * from this class. </i>
         * <p>
         * The parameters are all of type <code>int</code>.
         * A value of -1 for any parameter indicates that the default action
         * or value for that parameter should be used.
         * <p>
         * The first two parameters (<code>before</code> and
         * <code>after</code>) specify the number of characters to be used for
         * the integer part and decimal part of the result respectively, as
         * defined for {@link #format(int,int)}.
         * If either of these is -1 (which indicates the default action), the
         * number of characters used will be exactly as many as are needed for
         * that part.
         * <p>
         * The remaining parameters control the use of exponential notation
         * and rounding.  Three (<code>explaces</code>, <code>exdigits</code>,
         * and <code>exform</code>) control the exponent part of the result.
         * As before, the default action for any of these parameters may be
         * selected by using the value -1.
         * <p>
         * <code>explaces</code> must be a positive number; it sets the number
         * of places (digits after the sign of the exponent) to be used for
         * any exponent part, the default (when <code>explaces</code> is -1)
         * being to use as many as are needed.
         * If <code>explaces</code> is not -1, space is always reserved for
         * an exponent; if one is not needed (for example, if the exponent
         * will be 0) then <code>explaces</code>+2 blanks are appended to the
         * result.
         * <!-- (This preserves vertical alignment of similarly formatted
         *       numbers in a monospace font.) -->
         * If <code>explaces</code> is not -1 and is not large enough to
         * contain the exponent, an exception is thrown.
         * <p>
         * <code>exdigits</code> sets the trigger point for use of exponential
         * notation. If, before any rounding, the number of places needed
         * before the decimal point exceeds <code>exdigits</code>, or if the
         * absolute value of the result is less than <code>0.000001</code>,
         * then exponential form will be used, provided that
         * <code>exdigits</code> was specified.
         * When <code>exdigits</code> is -1, exponential notation will never
         * be used. If 0 is specified for <code>exdigits</code>, exponential
         * notation is always used unless the exponent would be 0.
         * <p>
         * <code>exform</code> sets the form for exponential notation (if
         * needed).
         * It  may be either {@link MathContext#SCIENTIFIC} or
         * {@link MathContext#ENGINEERING}.
         * If the latter, engineering, form is requested, up to three digits
         * (plus sign, if negative) may be needed for the integer part of the
         * result (<code>before</code>).  Otherwise, only one digit (plus
         * sign, if negative) is needed.
         * <p>
         * Finally, the sixth argument, <code>exround</code>, selects the
         * rounding algorithm to be used, and must be one of the values
         * indicated by a public constant in the {@link MathContext} class
         * whose name starts with <code>ROUND_</code>.
         * The default (<code>ROUND_HALF_UP</code>) may also be selected by
         * using the value -1, as before.
         * <p>
         * The special value <code>MathContext.ROUND_UNNECESSARY</code> may be
         * used to detect whether non-zero digits are discarded -- if
         * <code>exround</code> has this value than if non-zero digits would
         * be discarded (rounded) during formatting then an
         * <code>ArithmeticException</code> is thrown.
         *
         * @param  before   The <code>int</code> specifying the number of places
         *                  before the decimal point.
         *                  Use -1 for 'as many as are needed'.
         * @param  after    The <code>int</code> specifying the number of places
         *                  after the decimal point.
         *                  Use -1 for 'as many as are needed'.
         * @param  explaces The <code>int</code> specifying the number of places
         *                  to be used for any exponent.
         *                  Use -1 for 'as many as are needed'.
         * @param  exdigits The <code>int</code> specifying the trigger
         *                  (digits before the decimal point) which if
         *                  exceeded causes exponential notation to be used.
         *                  Use 0 to force exponential notation.
         *                  Use -1 to force plain notation (no exponential
         *                  notation).
         * @param  exform   The <code>int</code> specifying the form of
         *                  exponential notation to be used
         *                  ({@link MathContext#SCIENTIFIC} or
         *                  {@link MathContext#ENGINEERING}).
         * @param  exround  The <code>int</code> specifying the rounding mode
         *                  to use.
         *                  Use -1 for the default, {@link MathContext#ROUND_HALF_UP}.
         * @return          A <code>String</code> representing this
         *                  <code>BigDecimal</code>, laid out according to the
         *                  specified parameters
         * @throws ArithmeticException if the number cannot be laid out as
         *                  requested.
         * @throws IllegalArgumentException if a parameter is out of range.
         * @see    #toString
         * @see    #toCharArray
         * @stable ICU 2.0
         */

        //--public java.lang.String format(int before,int after,int explaces,int exdigits,int exformint,int exround){
        function format() {
            var explaces;
            var exdigits;
            var exformint;
            var exround;
            if (format.arguments.length == 6) {
                explaces = format.arguments[2];
                exdigits = format.arguments[3];
                exformint = format.arguments[4];
                exround = format.arguments[5];
            } else if (format.arguments.length == 2) {
                explaces = -1;
                exdigits = -1;
                exformint = MathContext.prototype.SCIENTIFIC;
                exround = this.ROUND_HALF_UP;
            } else {
                throw "format(): " + format.arguments.length + " arguments given; expected 2 or 6";
            }
            var before = format.arguments[0];
            var after = format.arguments[1];
            //--com.ibm.icu.math.BigDecimal num;
            var num;
            //--int mag=0;
            var mag = 0;
            //--int thisafter=0;
            var thisafter = 0;
            //--int lead=0;
            var lead = 0;
            //--byte newmant[]=null;
            var newmant = null;
            //--int chop=0;
            var chop = 0;
            //--int need=0;
            var need = 0;
            //--int oldexp=0;
            var oldexp = 0;
            //--char a[];
            var a;
            //--int p=0;
            var p = 0;
            //--char newa[]=null;
            var newa = null;
            //--int i=0;
            var i = 0;
            //--int places=0;
            var places = 0;

            /* Check arguments */
            if (before < -1 || before == 0) this.badarg("format", 1, before);
            if (after < -1) this.badarg("format", 2, after);
            if (explaces < -1 || explaces == 0) this.badarg("format", 3, explaces);
            if (exdigits < -1) this.badarg("format", 4, exdigits);
            {
                /*select*/
                if (exformint == MathContext.prototype.SCIENTIFIC) {} else if (exformint == MathContext.prototype.ENGINEERING) {} else if (exformint == -1) exformint = MathContext.prototype.SCIENTIFIC;
                // note PLAIN isn't allowed
                else {
                        this.badarg("format", 5, exformint);
                    }
            }
            // checking the rounding mode is done by trying to construct a
            // MathContext object with that mode; it will fail if bad
            if (exround != this.ROUND_HALF_UP) {
                try {
                    // if non-default...
                    if (exround == -1) exround = this.ROUND_HALF_UP;else new MathContext(9, MathContext.prototype.SCIENTIFIC, false, exround);
                } catch ($10) {
                    this.badarg("format", 6, exround);
                }
            }

            num = this.clone(this); // make private copy

            /* Here:
            num       is BigDecimal to format
            before    is places before point [>0]
            after     is places after point  [>=0]
            explaces  is exponent places     [>0]
            exdigits  is exponent digits     [>=0]
            exformint is exponent form       [one of two]
            exround   is rounding mode       [one of eight]
            'before' through 'exdigits' are -1 if not specified
            */

            /* determine form */
            {
                setform: do {
                    /*select*/
                    if (exdigits == -1) num.form = MathContext.prototype.PLAIN;else if (num.ind == this.iszero) num.form = MathContext.prototype.PLAIN;else {
                        // determine whether triggers
                        mag = num.exp + num.mant.length;
                        if (mag > exdigits) num.form = exformint;else if (mag < -5) num.form = exformint;else num.form = MathContext.prototype.PLAIN;
                    }
                } while (false);
            }
            /*setform*/

            /* If 'after' was specified then we may need to adjust the
            mantissa.  This is a little tricky, as we must conform to the
            rules of exponential layout if necessary (e.g., we cannot end up
            with 10.0 if scientific). */
            if (after >= 0) {
                setafter: for (;;) {
                    // calculate the current after-length
                    {
                        /*select*/
                        if (num.form == MathContext.prototype.PLAIN) thisafter = -num.exp; // has decimal part
                        else if (num.form == MathContext.prototype.SCIENTIFIC) thisafter = num.mant.length - 1;else {
                                // engineering
                                lead = (num.exp + num.mant.length - 1) % 3; // exponent to use
                                if (lead < 0) lead = 3 + lead; // negative exponent case
                                lead++; // number of leading digits
                                if (lead >= num.mant.length) thisafter = 0;else thisafter = num.mant.length - lead;
                            }
                    }
                    if (thisafter == after) break setafter; // we're in luck
                    if (thisafter < after) {
                        // need added trailing zeros
                        // [thisafter can be negative]
                        newmant = this.extend(num.mant, num.mant.length + after - thisafter);
                        num.mant = newmant;
                        num.exp = num.exp - (after - thisafter); // adjust exponent
                        if (num.exp < this.MinExp) throw "format(): Exponent Overflow: " + num.exp;
                        break setafter;
                    }
                    // We have too many digits after the decimal point; this could
                    // cause a carry, which could change the mantissa...
                    // Watch out for implied leading zeros in PLAIN case
                    chop = thisafter - after; // digits to lop [is >0]
                    if (chop > num.mant.length) {
                        // all digits go, no chance of carry
                        // carry on with zero
                        num.mant = this.ZERO.mant;
                        num.ind = this.iszero;
                        num.exp = 0;
                        continue setafter; // recheck: we may need trailing zeros
                    }
                    // we have a digit to inspect from existing mantissa
                    // round the number as required
                    need = num.mant.length - chop; // digits to end up with [may be 0]
                    oldexp = num.exp; // save old exponent
                    num.round(need, exround);
                    // if the exponent grew by more than the digits we chopped, then
                    // we must have had a carry, so will need to recheck the layout
                    if (num.exp - oldexp == chop) break setafter; // number did not have carry
                    // mantissa got extended .. so go around and check again
                }
            }
            /*setafter*/

            a = num.layout(); // lay out, with exponent if required, etc.

            /* Here we have laid-out number in 'a' */
            // now apply 'before' and 'explaces' as needed
            if (before > 0) {
                // look for '.' or 'E'
                {
                    var $11 = a.length;
                    p = 0;
                    p: for (; $11 > 0; $11--, p++) {
                        if (a[p] == '.') break p;
                        if (a[p] == 'E') break p;
                    }
                }
                /*p*/
                // p is now offset of '.', 'E', or character after end of array
                // that is, the current length of before part
                if (p > before) this.badarg("format", 1, before); // won't fit
                if (p < before) {
                    // need leading blanks
                    newa = new Array(a.length + before - p);
                    {
                        var $12 = before - p;
                        i = 0;
                        i: for (; $12 > 0; $12--, i++) {
                            newa[i] = ' ';
                        }
                    }
                    /*i*/
                    //--java.lang.System.arraycopy((java.lang.Object)a,0,(java.lang.Object)newa,i,a.length);
                    this.arraycopy(a, 0, newa, i, a.length);
                    a = newa;
                }
                // [if p=before then it's just the right length]
            }

            if (explaces > 0) {
                // look for 'E' [cannot be at offset 0]
                {
                    var $13 = a.length - 1;
                    p = a.length - 1;
                    p: for (; $13 > 0; $13--, p--) {
                        if (a[p] == 'E') break p;
                    }
                }
                /*p*/
                // p is now offset of 'E', or 0
                if (p == 0) {
                    // no E part; add trailing blanks
                    newa = new Array(a.length + explaces + 2);
                    //--java.lang.System.arraycopy((java.lang.Object)a,0,(java.lang.Object)newa,0,a.length);
                    this.arraycopy(a, 0, newa, 0, a.length);
                    {
                        var $14 = explaces + 2;
                        i = a.length;
                        i: for (; $14 > 0; $14--, i++) {
                            newa[i] = ' ';
                        }
                    }
                    /*i*/
                    a = newa;
                } else {
                    /* found E */ // may need to insert zeros
                    places = a.length - p - 2; // number so far
                    if (places > explaces) this.badarg("format", 3, explaces);
                    if (places < explaces) {
                        // need to insert zeros
                        newa = new Array(a.length + explaces - places);
                        //--java.lang.System.arraycopy((java.lang.Object)a,0,(java.lang.Object)newa,0,p+2); // through E and sign
                        this.arraycopy(a, 0, newa, 0, p + 2);
                        {
                            var $15 = explaces - places;
                            i = p + 2;
                            i: for (; $15 > 0; $15--, i++) {
                                newa[i] = '0';
                            }
                        }
                        /*i*/
                        //--java.lang.System.arraycopy((java.lang.Object)a,p+2,(java.lang.Object)newa,i,places); // remainder of exponent
                        this.arraycopy(a, p + 2, newa, i, places);
                        a = newa;
                    }
                    // [if places=explaces then it's just the right length]
                }
            }
            return a.join("");
        }

        /**
         * Returns the hashcode for this <code>BigDecimal</code>.
         * This hashcode is suitable for use by the
         * <code>java.util.Hashtable</code> class.
         * <p>
         * Note that two <code>BigDecimal</code> objects are only guaranteed
         * to produce the same hashcode if they are exactly equal (that is,
         * the <code>String</code> representations of the
         * <code>BigDecimal</code> numbers are identical -- they have the same
         * characters in the same sequence).
         *
         * @return An <code>int</code> that is the hashcode for <code>this</code>.
         * @stable ICU 2.0
         */

        //--public int hashCode(){
        //-- // Maybe calculate ourselves, later.  If so, note that there can be
        //-- // more than one internal representation for a given toString() result.
        //-- return this.toString().hashCode();
        //-- }

        /**
         * Converts this <code>BigDecimal</code> to an <code>int</code>.
         * If the <code>BigDecimal</code> has a non-zero decimal part it is
         * discarded. If the <code>BigDecimal</code> is out of the possible
         * range for an <code>int</code> (32-bit signed integer) result then
         * only the low-order 32 bits are used. (That is, the number may be
         * <i>decapitated</i>.)  To avoid unexpected errors when these
         * conditions occur, use the {@link #intValueExact} method.
         *
         * @return An <code>int</code> converted from <code>this</code>,
         *         truncated and decapitated if necessary.
         * @stable ICU 2.0
         */

        //--public int intValue(){
        //-- return toBigInteger().intValue();
        //-- }

        /**
         * Converts this <code>BigDecimal</code> to an <code>int</code>.
         * If the <code>BigDecimal</code> has a non-zero decimal part or is
         * out of the possible range for an <code>int</code> (32-bit signed
         * integer) result then an <code>ArithmeticException</code> is thrown.
         *
         * @return An <code>int</code> equal in value to <code>this</code>.
         * @throws ArithmeticException if <code>this</code> has a non-zero
         *                 decimal part, or will not fit in an
         *                 <code>int</code>.
         * @stable ICU 2.0
         */

        //--public int intValueExact(){
        function intValueExact() {
            //--int lodigit;
            var lodigit;
            //--int useexp=0;
            var useexp = 0;
            //--int result;
            var result;
            //--int i=0;
            var i = 0;
            //--int topdig=0;
            var topdig = 0;
            // This does not use longValueExact() as the latter can be much
            // slower.
            // intcheck (from pow) relies on this to check decimal part
            if (this.ind == this.iszero) return 0; // easy, and quite common
            /* test and drop any trailing decimal part */
            lodigit = this.mant.length - 1;
            if (this.exp < 0) {
                lodigit = lodigit + this.exp; // reduces by -(-exp)
                /* all decimal places must be 0 */
                if (!this.allzero(this.mant, lodigit + 1)) throw "intValueExact(): Decimal part non-zero: " + this.toString();
                if (lodigit < 0) return 0; // -1<this<1
                useexp = 0;
            } else {
                /* >=0 */
                if (this.exp + lodigit > 9) // early exit
                    throw "intValueExact(): Conversion overflow: " + this.toString();
                useexp = this.exp;
            }
            /* convert the mantissa to binary, inline for speed */
            result = 0;
            {
                var $16 = lodigit + useexp;
                i = 0;
                i: for (; i <= $16; i++) {
                    result = result * 10;
                    if (i <= lodigit) result = result + this.mant[i];
                }
            }
            /*i*/

            /* Now, if the risky length, check for overflow */
            if (lodigit + useexp == 9) {
                // note we cannot just test for -ve result, as overflow can move a
                // zero into the top bit [consider 5555555555]
                topdig = div(result, 1000000000); // get top digit, preserving sign
                if (topdig != this.mant[0]) {
                    // digit must match and be positive
                    // except in the special case ...
                    if (result == -2147483648) // looks like the special
                        if (this.ind == this.isneg) // really was negative
                            if (this.mant[0] == 2) return result; // really had top digit 2
                    throw "intValueExact(): Conversion overflow: " + this.toString();
                }
            }

            /* Looks good */
            if (this.ind == this.ispos) return result;
            return -result;
        }

        /**
         * Converts this <code>BigDecimal</code> to a <code>long</code>.
         * If the <code>BigDecimal</code> has a non-zero decimal part it is
         * discarded. If the <code>BigDecimal</code> is out of the possible
         * range for a <code>long</code> (64-bit signed integer) result then
         * only the low-order 64 bits are used. (That is, the number may be
         * <i>decapitated</i>.)  To avoid unexpected errors when these
         * conditions occur, use the {@link #longValueExact} method.
         *
         * @return A <code>long</code> converted from <code>this</code>,
         *         truncated and decapitated if necessary.
         * @stable ICU 2.0
         */

        //--public long longValue(){
        //-- return toBigInteger().longValue();
        //-- }

        /**
         * Converts this <code>BigDecimal</code> to a <code>long</code>.
         * If the <code>BigDecimal</code> has a non-zero decimal part or is
         * out of the possible range for a <code>long</code> (64-bit signed
         * integer) result then an <code>ArithmeticException</code> is thrown.
         *
         * @return A <code>long</code> equal in value to <code>this</code>.
         * @throws ArithmeticException if <code>this</code> has a non-zero
         *                 decimal part, or will not fit in a
         *                 <code>long</code>.
         * @stable ICU 2.0
         */

        //--public long longValueExact(){
        //-- int lodigit;
        //-- int cstart=0;
        //-- int useexp=0;
        //-- long result;
        //-- int i=0;
        //-- long topdig=0;
        //-- // Identical to intValueExact except for result=long, and exp>=20 test
        //-- if (ind==0)
        //--  return 0; // easy, and quite common
        //-- lodigit=mant.length-1; // last included digit
        //-- if (exp<0)
        //--  {
        //--   lodigit=lodigit+exp; // -(-exp)
        //--   /* all decimal places must be 0 */
        //--   if (lodigit<0)
        //--    cstart=0;
        //--   else
        //--    cstart=lodigit+1;
        //--   if ((!(allzero(mant,cstart))))
        //--    throw new java.lang.ArithmeticException("Decimal part non-zero:"+" "+this.toString());
        //--   if (lodigit<0)
        //--    return 0; // -1<this<1
        //--   useexp=0;
        //--  }
        //-- else
        //--  {/* >=0 */
        //--   if ((exp+mant.length)>18)  // early exit
        //--    throw new java.lang.ArithmeticException("Conversion overflow:"+" "+this.toString());
        //--   useexp=exp;
        //--  }
        //--
        //-- /* convert the mantissa to binary, inline for speed */
        //-- // note that we could safely use the 'test for wrap to negative'
        //-- // algorithm here, but instead we parallel the intValueExact
        //-- // algorithm for ease of checking and maintenance.
        //-- result=(long)0;
        //-- {int $17=lodigit+useexp;i=0;i:for(;i<=$17;i++){
        //--  result=result*10;
        //--  if (i<=lodigit)
        //--   result=result+mant[i];
        //--  }
        //-- }/*i*/
        //--
        //-- /* Now, if the risky length, check for overflow */
        //-- if ((lodigit+useexp)==18)
        //--  {
        //--   topdig=result/1000000000000000000L; // get top digit, preserving sign
        //--   if (topdig!=mant[0])
        //--    { // digit must match and be positive
        //--     // except in the special case ...
        //--     if (result==java.lang.Long.MIN_VALUE)  // looks like the special
        //--      if (ind==isneg)  // really was negative
        //--       if (mant[0]==9)
        //--        return result; // really had top digit 9
        //--     throw new java.lang.ArithmeticException("Conversion overflow:"+" "+this.toString());
        //--    }
        //--  }
        //--
        //-- /* Looks good */
        //-- if (ind==ispos)
        //--  return result;
        //-- return (long)-result;
        //-- }

        /**
         * Returns a plain <code>BigDecimal</code> whose decimal point has
         * been moved to the left by a specified number of positions.
         * The parameter, <code>n</code>, specifies the number of positions to
         * move the decimal point.
         * That is, if <code>n</code> is 0 or positive, the number returned is
         * given by:
         * <p><code>
         * this.multiply(TEN.pow(new BigDecimal(-n)))
         * </code>
         * <p>
         * <code>n</code> may be negative, in which case the method returns
         * the same result as <code>movePointRight(-n)</code>.
         *
         * @param  n The <code>int</code> specifying the number of places to
         *           move the decimal point leftwards.
         * @return   A <code>BigDecimal</code> derived from
         *           <code>this</code>, with the decimal point moved
         *           <code>n</code> places to the left.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal movePointLeft(int n){
        function movePointLeft(n) {
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            // very little point in optimizing for shift of 0
            res = this.clone(this);
            res.exp = res.exp - n;
            return res.finish(this.plainMC, false); // finish sets form and checks exponent
        }

        /**
         * Returns a plain <code>BigDecimal</code> whose decimal point has
         * been moved to the right by a specified number of positions.
         * The parameter, <code>n</code>, specifies the number of positions to
         * move the decimal point.
         * That is, if <code>n</code> is 0 or positive, the number returned is
         * given by:
         * <p><code>
         * this.multiply(TEN.pow(new BigDecimal(n)))
         * </code>
         * <p>
         * <code>n</code> may be negative, in which case the method returns
         * the same result as <code>movePointLeft(-n)</code>.
         *
         * @param  n The <code>int</code> specifying the number of places to
         *           move the decimal point rightwards.
         * @return   A <code>BigDecimal</code> derived from
         *           <code>this</code>, with the decimal point moved
         *           <code>n</code> places to the right.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal movePointRight(int n){
        function movePointRight(n) {
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            res = this.clone(this);
            res.exp = res.exp + n;
            return res.finish(this.plainMC, false);
        }

        /**
         * Returns the scale of this <code>BigDecimal</code>.
         * Returns a non-negative <code>int</code> which is the scale of the
         * number. The scale is the number of digits in the decimal part of
         * the number if the number were formatted without exponential
         * notation.
         *
         * @return An <code>int</code> whose value is the scale of this
         *         <code>BigDecimal</code>.
         * @stable ICU 2.0
         */

        //--public int scale(){
        function scale() {
            if (this.exp >= 0) return 0; // scale can never be negative
            return -this.exp;
        }

        /**
         * Returns a plain <code>BigDecimal</code> with a given scale.
         * <p>
         * If the given scale (which must be zero or positive) is the same as
         * or greater than the length of the decimal part (the scale) of this
         * <code>BigDecimal</code> then trailing zeros will be added to the
         * decimal part as necessary.
         * <p>
         * If the given scale is less than the length of the decimal part (the
         * scale) of this <code>BigDecimal</code> then trailing digits
         * will be removed, and in this case an
         * <code>ArithmeticException</code> is thrown if any discarded digits
         * are non-zero.
         * <p>
         * The same as {@link #setScale(int, int)}, where the first parameter
         * is the scale, and the second is
         * <code>MathContext.ROUND_UNNECESSARY</code>.
         *
         * @param  scale The <code>int</code> specifying the scale of the
         *               resulting <code>BigDecimal</code>.
         * @return       A plain <code>BigDecimal</code> with the given scale.
         * @throws ArithmeticException if <code>scale</code> is negative.
         * @throws ArithmeticException if reducing scale would discard
         *               non-zero digits.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal setScale(int scale){
        //-- return setScale(scale,ROUND_UNNECESSARY);
        //-- }

        /**
         * Returns a plain <code>BigDecimal</code> with a given scale.
         * <p>
         * If the given scale (which must be zero or positive) is the same as
         * or greater than the length of the decimal part (the scale) of this
         * <code>BigDecimal</code> then trailing zeros will be added to the
         * decimal part as necessary.
         * <p>
         * If the given scale is less than the length of the decimal part (the
         * scale) of this <code>BigDecimal</code> then trailing digits
         * will be removed, and the rounding mode given by the second
         * parameter is used to determine if the remaining digits are
         * affected by a carry.
         * In this case, an <code>IllegalArgumentException</code> is thrown if
         * <code>round</code> is not a valid rounding mode.
         * <p>
         * If <code>round</code> is <code>MathContext.ROUND_UNNECESSARY</code>,
         * an <code>ArithmeticException</code> is thrown if any discarded
         * digits are non-zero.
         *
         * @param  scale The <code>int</code> specifying the scale of the
         *               resulting <code>BigDecimal</code>.
         * @param  round The <code>int</code> rounding mode to be used for
         *               the division (see the {@link MathContext} class).
         * @return       A plain <code>BigDecimal</code> with the given scale.
         * @throws IllegalArgumentException if <code>round</code> is not a
         *               valid rounding mode.
         * @throws ArithmeticException if <code>scale</code> is negative.
         * @throws ArithmeticException if <code>round</code> is
         *               <code>MathContext.ROUND_UNNECESSARY</code>, and
         *               reducing scale would discard non-zero digits.
         * @stable ICU 2.0
         */

        //--public com.ibm.icu.math.BigDecimal setScale(int scale,int round){
        function setScale() {
            var round;
            if (setScale.arguments.length == 2) {
                round = setScale.arguments[1];
            } else if (setScale.arguments.length == 1) {
                round = this.ROUND_UNNECESSARY;
            } else {
                throw "setScale(): " + setScale.arguments.length + " given; expected 1 or 2";
            }
            var scale = setScale.arguments[0];
            //--int ourscale;
            var ourscale;
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            //--int padding=0;
            var padding = 0;
            //--int newlen=0;
            var newlen = 0;
            // at present this naughtily only checks the round value if it is
            // needed (used), for speed
            ourscale = this.scale();
            if (ourscale == scale) // already correct scale
                if (this.form == MathContext.prototype.PLAIN) // .. and form
                    return this;
            res = this.clone(this); // need copy
            if (ourscale <= scale) {
                // simply zero-padding/changing form
                // if ourscale is 0 we may have lots of 0s to add
                if (ourscale == 0) padding = res.exp + scale;else padding = scale - ourscale;
                res.mant = this.extend(res.mant, res.mant.length + padding);
                res.exp = -scale; // as requested
            } else {
                /* ourscale>scale: shortening, probably */
                if (scale < 0)
                    //--throw new java.lang.ArithmeticException("Negative scale:"+" "+scale);
                    throw "setScale(): Negative scale: " + scale;
                // [round() will raise exception if invalid round]
                newlen = res.mant.length - (ourscale - scale); // [<=0 is OK]
                res = res.round(newlen, round); // round to required length
                // This could have shifted left if round (say) 0.9->1[.0]
                // Repair if so by adding a zero and reducing exponent
                if (res.exp != -scale) {
                    res.mant = this.extend(res.mant, res.mant.length + 1);
                    res.exp = res.exp - 1;
                }
            }
            res.form = MathContext.prototype.PLAIN; // by definition
            return res;
        }

        /**
         * Converts this <code>BigDecimal</code> to a <code>short</code>.
         * If the <code>BigDecimal</code> has a non-zero decimal part or is
         * out of the possible range for a <code>short</code> (16-bit signed
         * integer) result then an <code>ArithmeticException</code> is thrown.
         *
         * @return A <code>short</code> equal in value to <code>this</code>.
         * @throws ArithmeticException if <code>this</code> has a non-zero
         *                 decimal part, or will not fit in a
         *                 <code>short</code>.
         * @stable ICU 2.0
         */

        //--public short shortValueExact(){
        //-- int num;
        //-- num=this.intValueExact(); // will check decimal part too
        //-- if ((num>32767)|(num<(-32768)))
        //--  throw new java.lang.ArithmeticException("Conversion overflow:"+" "+this.toString());
        //-- return (short)num;
        //-- }

        /**
         * Returns the sign of this <code>BigDecimal</code>, as an
         * <code>int</code>.
         * This returns the <i>signum</i> function value that represents the
         * sign of this <code>BigDecimal</code>.
         * That is, -1 if the <code>BigDecimal</code> is negative, 0 if it is
         * numerically equal to zero, or 1 if it is positive.
         *
         * @return An <code>int</code> which is -1 if the
         *         <code>BigDecimal</code> is negative, 0 if it is
         *         numerically equal to zero, or 1 if it is positive.
         * @stable ICU 2.0
         */

        //--public int signum(){
        function signum() {
            return this.ind; // [note this assumes values for ind.]
        }

        /**
         * Converts this <code>BigDecimal</code> to a
         * <code>java.math.BigDecimal</code>.
         * <p>
         * This is an exact conversion; the result is the same as if the
         * <code>BigDecimal</code> were formatted as a plain number without
         * any rounding or exponent and then the
         * <code>java.math.BigDecimal(java.lang.String)</code> constructor
         * were used to construct the result.
         * <p>
         * <i>(Note: this method is provided only in the
         * <code>com.ibm.icu.math</code> version of the BigDecimal class.
         * It would not be present in a <code>java.math</code> version.)</i>
         *
         * @return The <code>java.math.BigDecimal</code> equal in value
         *         to this <code>BigDecimal</code>.
         * @stable ICU 2.0
         */

        //--public java.math.BigDecimal toBigDecimal(){
        //-- return new java.math.BigDecimal(this.unscaledValue(),this.scale());
        //-- }

        /**
         * Converts this <code>BigDecimal</code> to a
         * <code>java.math.BigInteger</code>.
         * <p>
         * Any decimal part is truncated (discarded).
         * If an exception is desired should the decimal part be non-zero,
         * use {@link #toBigIntegerExact()}.
         *
         * @return The <code>java.math.BigInteger</code> equal in value
         *         to the integer part of this <code>BigDecimal</code>.
         * @stable ICU 2.0
         */

        //--public java.math.BigInteger toBigInteger(){
        //-- com.ibm.icu.math.BigDecimal res=null;
        //-- int newlen=0;
        //-- byte newmant[]=null;
        //-- {/*select*/
        //-- if ((exp>=0)&(form==com.ibm.icu.math.MathContext.PLAIN))
        //--  res=this; // can layout simply
        //-- else if (exp>=0)
        //--  {
        //--   res=clone(this); // safe copy
        //--   res.form=(byte)com.ibm.icu.math.MathContext.PLAIN; // .. and request PLAIN
        //--  }
        //-- else{
        //--  { // exp<0; scale to be truncated
        //--   // we could use divideInteger, but we may as well be quicker
        //--   if (((int)-this.exp)>=this.mant.length)
        //--    res=ZERO; // all blows away
        //--   else
        //--    {
        //--     res=clone(this); // safe copy
        //--     newlen=res.mant.length+res.exp;
        //--     newmant=new byte[newlen]; // [shorter]
        //--     java.lang.System.arraycopy((java.lang.Object)res.mant,0,(java.lang.Object)newmant,0,newlen);
        //--     res.mant=newmant;
        //--     res.form=(byte)com.ibm.icu.math.MathContext.PLAIN;
        //--     res.exp=0;
        //--    }
        //--  }
        //-- }
        //-- }
        //-- return new BigInteger(new java.lang.String(res.layout()));
        //-- }

        /**
         * Converts this <code>BigDecimal</code> to a
         * <code>java.math.BigInteger</code>.
         * <p>
         * An exception is thrown if the decimal part (if any) is non-zero.
         *
         * @return The <code>java.math.BigInteger</code> equal in value
         *         to the integer part of this <code>BigDecimal</code>.
         * @throws ArithmeticException if <code>this</code> has a non-zero
         *         decimal part.
         * @stable ICU 2.0
         */

        //--public java.math.BigInteger toBigIntegerExact(){
        //-- /* test any trailing decimal part */
        //-- if (exp<0)
        //--  { // possible decimal part
        //--   /* all decimal places must be 0; note exp<0 */
        //--   if ((!(allzero(mant,mant.length+exp))))
        //--    throw new java.lang.ArithmeticException("Decimal part non-zero:"+" "+this.toString());
        //--  }
        //-- return toBigInteger();
        //-- }

        /**
         * Returns the <code>BigDecimal</code> as a character array.
         * The result of this method is the same as using the
         * sequence <code>toString().toCharArray()</code>, but avoids creating
         * the intermediate <code>String</code> and <code>char[]</code>
         * objects.
         *
         * @return The <code>char[]</code> array corresponding to this
         *         <code>BigDecimal</code>.
         * @stable ICU 2.0
         */

        //--public char[] toCharArray(){
        //-- return layout();
        //-- }

        /**
         * Returns the <code>BigDecimal</code> as a <code>String</code>.
         * This returns a <code>String</code> that exactly represents this
         * <code>BigDecimal</code>, as defined in the decimal documentation
         * (see {@link BigDecimal class header}).
         * <p>
         * By definition, using the {@link #BigDecimal(String)} constructor
         * on the result <code>String</code> will create a
         * <code>BigDecimal</code> that is exactly equal to the original
         * <code>BigDecimal</code>.
         *
         * @return The <code>String</code> exactly corresponding to this
         *         <code>BigDecimal</code>.
         * @see    #format(int, int)
         * @see    #format(int, int, int, int, int, int)
         * @see    #toCharArray()
         * @stable ICU 2.0
         */

        //--public java.lang.String toString(){
        function toString() {
            return this.layout().join("");
        }

        /**
         * Returns the number as a <code>BigInteger</code> after removing the
         * scale.
         * That is, the number is expressed as a plain number, any decimal
         * point is then removed (retaining the digits of any decimal part),
         * and the result is then converted to a <code>BigInteger</code>.
         *
         * @return The <code>java.math.BigInteger</code> equal in value to
         *         this <code>BigDecimal</code> multiplied by ten to the
         *         power of <code>this.scale()</code>.
         * @stable ICU 2.0
         */

        //--public java.math.BigInteger unscaledValue(){
        //-- com.ibm.icu.math.BigDecimal res=null;
        //-- if (exp>=0)
        //--  res=this;
        //-- else
        //--  {
        //--   res=clone(this); // safe copy
        //--   res.exp=0; // drop scale
        //--  }
        //-- return res.toBigInteger();
        //-- }

        /**
         * Translates a <code>double</code> to a <code>BigDecimal</code>.
         * <p>
         * Returns a <code>BigDecimal</code> which is the decimal
         * representation of the 64-bit signed binary floating point
         * parameter. If the parameter is infinite, or is not a number (NaN),
         * a <code>NumberFormatException</code> is thrown.
         * <p>
         * The number is constructed as though <code>num</code> had been
         * converted to a <code>String</code> using the
         * <code>Double.toString()</code> method and the
         * {@link #BigDecimal(java.lang.String)} constructor had then been used.
         * This is typically not an exact conversion.
         *
         * @param  dub The <code>double</code> to be translated.
         * @return     The <code>BigDecimal</code> equal in value to
         *             <code>dub</code>.
         * @throws NumberFormatException if the parameter is infinite or
         *             not a number.
         * @stable ICU 2.0
         */

        //--public static com.ibm.icu.math.BigDecimal valueOf(double dub){
        //-- // Reminder: a zero double returns '0.0', so we cannot fastpath to
        //-- // use the constant ZERO.  This might be important enough to justify
        //-- // a factory approach, a cache, or a few private constants, later.
        //-- return new com.ibm.icu.math.BigDecimal((new java.lang.Double(dub)).toString());
        //-- }

        /**
         * Translates a <code>long</code> to a <code>BigDecimal</code>.
         * That is, returns a plain <code>BigDecimal</code> whose value is
         * equal to the given <code>long</code>.
         *
         * @param  lint The <code>long</code> to be translated.
         * @return      The <code>BigDecimal</code> equal in value to
         *              <code>lint</code>.
         * @stable ICU 2.0
         */

        //--public static com.ibm.icu.math.BigDecimal valueOf(long lint){
        //-- return valueOf(lint,0);
        //-- }

        /**
         * Translates a <code>long</code> to a <code>BigDecimal</code> with a
         * given scale.
         * That is, returns a plain <code>BigDecimal</code> whose unscaled
         * value is equal to the given <code>long</code>, adjusted by the
         * second parameter, <code>scale</code>.
         * <p>
         * The result is given by:
         * <p><code>
         * (new BigDecimal(lint)).divide(TEN.pow(new BigDecimal(scale)))
         * </code>
         * <p>
         * A <code>NumberFormatException</code> is thrown if <code>scale</code>
         * is negative.
         *
         * @param  lint  The <code>long</code> to be translated.
         * @param  scale The <code>int</code> scale to be applied.
         * @return       The <code>BigDecimal</code> equal in value to
         *               <code>lint</code>.
         * @throws NumberFormatException if the scale is negative.
         * @stable ICU 2.0
         */

        //--public static com.ibm.icu.math.BigDecimal valueOf(long lint,int scale){
        //-- com.ibm.icu.math.BigDecimal res=null;
        //-- {/*select*/
        //-- if (lint==0)
        //--  res=ZERO;
        //-- else if (lint==1)
        //--  res=ONE;
        //-- else if (lint==10)
        //--  res=TEN;
        //-- else{
        //--  res=new com.ibm.icu.math.BigDecimal(lint);
        //-- }
        //-- }
        //-- if (scale==0)
        //--  return res;
        //-- if (scale<0)
        //--  throw new java.lang.NumberFormatException("Negative scale:"+" "+scale);
        //-- res=clone(res); // safe copy [do not mutate]
        //-- res.exp=(int)-scale; // exponent is -scale
        //-- return res;
        //-- }

        /* ---------------------------------------------------------------- */
        /* Private methods                                                  */
        /* ---------------------------------------------------------------- */

        /* <sgml> Return char array value of a BigDecimal (conversion from
        BigDecimal to laid-out canonical char array).
        <p>The mantissa will either already have been rounded (following an
        operation) or will be of length appropriate (in the case of
        construction from an int, for example).
        <p>We must not alter the mantissa, here.
        <p>'form' describes whether we are to use exponential notation (and
        if so, which), or if we are to lay out as a plain/pure numeric.
        </sgml> */

        //--private char[] layout(){
        function layout() {
            //--char cmant[];
            var cmant;
            //--int i=0;
            var i = 0;
            //--java.lang.StringBuffer sb=null;
            var sb = null;
            //--int euse=0;
            var euse = 0;
            //--int sig=0;
            var sig = 0;
            //--char csign=0;
            var csign = 0;
            //--char rec[]=null;
            var rec = null;
            //--int needsign;
            var needsign;
            //--int mag;
            var mag;
            //--int len=0;
            var len = 0;
            cmant = new Array(this.mant.length); // copy byte[] to a char[]
            {
                var $18 = this.mant.length;
                i = 0;
                i: for (; $18 > 0; $18--, i++) {
                    cmant[i] = this.mant[i] + '';
                }
            }
            /*i*/

            if (this.form != MathContext.prototype.PLAIN) {
                /* exponential notation needed */
                //--sb=new java.lang.StringBuffer(cmant.length+15); // -x.xxxE+999999999
                sb = "";
                if (this.ind == this.isneg) sb += '-';
                euse = this.exp + cmant.length - 1; // exponent to use
                /* setup sig=significant digits and copy to result */
                if (this.form == MathContext.prototype.SCIENTIFIC) {
                    // [default]
                    sb += cmant[0]; // significant character
                    if (cmant.length > 1) // have decimal part
                        //--sb.append('.').append(cmant,1,cmant.length-1);
                        sb += '.';
                    sb += cmant.slice(1).join("");
                } else {
                    engineering: do {
                        sig = euse % 3; // common
                        if (sig < 0) sig = 3 + sig; // negative exponent
                        euse = euse - sig;
                        sig++;
                        if (sig >= cmant.length) {
                            // zero padding may be needed
                            //--sb.append(cmant,0,cmant.length);
                            sb += cmant.join("");
                            {
                                var $19 = sig - cmant.length;
                                for (; $19 > 0; $19--) {
                                    sb += '0';
                                }
                            }
                        } else {
                            // decimal point needed
                            //--sb.append(cmant,0,sig).append('.').append(cmant,sig,cmant.length-sig);
                            sb += cmant.slice(0, sig).join("");
                            sb += '.';
                            sb += cmant.slice(sig).join("");
                        }
                    } while (false);
                }
                /*engineering*/
                if (euse != 0) {
                    if (euse < 0) {
                        csign = '-';
                        euse = -euse;
                    } else csign = '+';
                    //--sb.append('E').append(csign).append(euse);
                    sb += 'E';
                    sb += csign;
                    sb += euse;
                }
                //--rec=new Array(sb.length);
                //--Utility.getChars(sb, 0,sb.length(),rec,0);
                //--return rec;
                return sb.split("");
            }

            /* Here for non-exponential (plain) notation */
            if (this.exp == 0) {
                /* easy */
                if (this.ind >= 0) return cmant; // non-negative integer
                rec = new Array(cmant.length + 1);
                rec[0] = '-';
                //--java.lang.System.arraycopy((java.lang.Object)cmant,0,(java.lang.Object)rec,1,cmant.length);
                this.arraycopy(cmant, 0, rec, 1, cmant.length);
                return rec;
            }

            /* Need a '.' and/or some zeros */
            needsign = this.ind == this.isneg ? 1 : 0; // space for sign?  0 or 1

            /* MAG is the position of the point in the mantissa (index of the
            character it follows) */
            mag = this.exp + cmant.length;

            if (mag < 1) {
                /* 0.00xxxx form */
                len = needsign + 2 - this.exp; // needsign+2+(-mag)+cmant.length
                rec = new Array(len);
                if (needsign != 0) rec[0] = '-';
                rec[needsign] = '0';
                rec[needsign + 1] = '.';
                {
                    var $20 = -mag;
                    i = needsign + 2;
                    i: for (; $20 > 0; $20--, i++) {
                        // maybe none
                        rec[i] = '0';
                    }
                }
                /*i*/
                //--java.lang.System.arraycopy((java.lang.Object)cmant,0,(java.lang.Object)rec,(needsign+2)-mag,cmant.length);
                this.arraycopy(cmant, 0, rec, needsign + 2 - mag, cmant.length);
                return rec;
            }

            if (mag > cmant.length) {
                /* xxxx0000 form */
                len = needsign + mag;
                rec = new Array(len);
                if (needsign != 0) rec[0] = '-';
                //--java.lang.System.arraycopy((java.lang.Object)cmant,0,(java.lang.Object)rec,needsign,cmant.length);
                this.arraycopy(cmant, 0, rec, needsign, cmant.length);
                {
                    var $21 = mag - cmant.length;
                    i = needsign + cmant.length;
                    i: for (; $21 > 0; $21--, i++) {
                        // never 0
                        rec[i] = '0';
                    }
                }
                /*i*/
                return rec;
            }

            /* decimal point is in the middle of the mantissa */
            len = needsign + 1 + cmant.length;
            rec = new Array(len);
            if (needsign != 0) rec[0] = '-';
            //--java.lang.System.arraycopy((java.lang.Object)cmant,0,(java.lang.Object)rec,needsign,mag);
            this.arraycopy(cmant, 0, rec, needsign, mag);
            rec[needsign + mag] = '.';
            //--java.lang.System.arraycopy((java.lang.Object)cmant,mag,(java.lang.Object)rec,(needsign+mag)+1,cmant.length-mag);
            this.arraycopy(cmant, mag, rec, needsign + mag + 1, cmant.length - mag);
            return rec;
        }

        /* <sgml> Checks a BigDecimal argument to ensure it's a true integer
        in a given range.
        <p>If OK, returns it as an int. </sgml> */
        // [currently only used by pow]

        //--private int intcheck(int min,int max){
        function intcheck(min, max) {
            //--int i;
            var i;
            i = this.intValueExact(); // [checks for non-0 decimal part]
            // Use same message as though intValueExact failed due to size
            if (i < min || i > max) throw "intcheck(): Conversion overflow: " + i;
            return i;
        }

        /* <sgml> Carry out division operations. </sgml> */
        /*
        Arg1 is operation code: D=divide, I=integer divide, R=remainder
        Arg2 is the rhs.
        Arg3 is the context.
        Arg4 is explicit scale iff code='D' or 'I' (-1 if none).
        Underlying algorithm (complications for Remainder function and
        scaled division are omitted for clarity):
        Test for x/0 and then 0/x
        Exp =Exp1 - Exp2
        Exp =Exp +len(var1) -len(var2)
        Sign=Sign1 * Sign2
        Pad accumulator (Var1) to double-length with 0's (pad1)
        Pad Var2 to same length as Var1
        B2B=1st two digits of var2, +1 to allow for roundup
        have=0
        Do until (have=digits+1 OR residue=0)
        if exp<0 then if integer divide/residue then leave
        this_digit=0
        Do forever
           compare numbers
           if <0 then leave inner_loop
           if =0 then (- quick exit without subtract -) do
              this_digit=this_digit+1; output this_digit
              leave outer_loop; end
           Compare lengths of numbers (mantissae):
           If same then CA=first_digit_of_Var1
                   else CA=first_two_digits_of_Var1
           mult=ca*10/b2b   -- Good and safe guess at divisor
           if mult=0 then mult=1
           this_digit=this_digit+mult
           subtract
           end inner_loop
         if have\=0 | this_digit\=0 then do
           output this_digit
           have=have+1; end
         var2=var2/10
         exp=exp-1
         end outer_loop
        exp=exp+1   -- set the proper exponent
        if have=0 then generate answer=0
        Return to FINISHED
        Result defined by MATHV1
        For extended commentary, see DMSRCN.
        */

        //--private com.ibm.icu.math.BigDecimal dodivide(char code,com.ibm.icu.math.BigDecimal rhs,com.ibm.icu.math.MathContext set,int scale){
        function dodivide(code, rhs, set, scale) {
            //--com.ibm.icu.math.BigDecimal lhs;
            var lhs;
            //--int reqdig;
            var reqdig;
            //--int newexp;
            var newexp;
            //--com.ibm.icu.math.BigDecimal res;
            var res;
            //--int newlen;
            var newlen;
            //--byte var1[];
            var var1;
            //--int var1len;
            var var1len;
            //--byte var2[];
            var var2;
            //--int var2len;
            var var2len;
            //--int b2b;
            var b2b;
            //--int have;
            var have;
            //--int thisdigit=0;
            var thisdigit = 0;
            //--int i=0;
            var i = 0;
            //--byte v2=0;
            var v2 = 0;
            //--int ba=0;
            var ba = 0;
            //--int mult=0;
            var mult = 0;
            //--int start=0;
            var start = 0;
            //--int padding=0;
            var padding = 0;
            //--int d=0;
            var d = 0;
            //--byte newvar1[]=null;
            var newvar1 = null;
            //--byte lasthave=0;
            var lasthave = 0;
            //--int actdig=0;
            var actdig = 0;
            //--byte newmant[]=null;
            var newmant = null;

            if (set.lostDigits) this.checkdigits(rhs, set.digits);
            lhs = this; // name for clarity

            // [note we must have checked lostDigits before the following checks]
            if (rhs.ind == 0) throw "dodivide(): Divide by 0"; // includes 0/0
            if (lhs.ind == 0) {
                // 0/x => 0 [possibly with .0s]
                if (set.form != MathContext.prototype.PLAIN) return this.ZERO;
                if (scale == -1) return lhs;
                return lhs.setScale(scale);
            }

            /* Prepare numbers according to BigDecimal rules */
            reqdig = set.digits; // local copy (heavily used)
            if (reqdig > 0) {
                if (lhs.mant.length > reqdig) lhs = this.clone(lhs).round(set);
                if (rhs.mant.length > reqdig) rhs = this.clone(rhs).round(set);
            } else {
                /* scaled divide */
                if (scale == -1) scale = lhs.scale();
                // set reqdig to be at least large enough for the computation
                reqdig = lhs.mant.length; // base length
                // next line handles both positive lhs.exp and also scale mismatch
                if (scale != -lhs.exp) reqdig = reqdig + scale + lhs.exp;
                reqdig = reqdig - (rhs.mant.length - 1) - rhs.exp; // reduce by RHS effect
                if (reqdig < lhs.mant.length) reqdig = lhs.mant.length; // clamp
                if (reqdig < rhs.mant.length) reqdig = rhs.mant.length; // ..
            }

            /* precalculate exponent */
            newexp = lhs.exp - rhs.exp + lhs.mant.length - rhs.mant.length;
            /* If new exponent -ve, then some quick exits are possible */
            if (newexp < 0) if (code != 'D') {
                if (code == 'I') return this.ZERO; // easy - no integer part
                /* Must be 'R'; remainder is [finished clone of] input value */
                return this.clone(lhs).finish(set, false);
            }

            /* We need slow division */
            res = new BigDecimal(); // where we'll build result
            res.ind = lhs.ind * rhs.ind; // final sign (for D/I)
            res.exp = newexp; // initial exponent (for D/I)
            res.mant = this.createArrayWithZeros(reqdig + 1); // where build the result

            /* Now [virtually pad the mantissae with trailing zeros */
            // Also copy the LHS, which will be our working array
            newlen = reqdig + reqdig + 1;
            var1 = this.extend(lhs.mant, newlen); // always makes longer, so new safe array
            var1len = newlen; // [remaining digits are 0]

            var2 = rhs.mant;
            var2len = newlen;

            /* Calculate first two digits of rhs (var2), +1 for later estimations */
            b2b = var2[0] * 10 + 1;
            if (var2.length > 1) b2b = b2b + var2[1];

            /* start the long-division loops */
            have = 0;
            {
                outer: for (;;) {
                    thisdigit = 0;
                    /* find the next digit */
                    {
                        inner: for (;;) {
                            if (var1len < var2len) break inner; // V1 too low
                            if (var1len == var2len) {
                                // compare needed
                                {
                                    compare: do {
                                        // comparison
                                        {
                                            var $22 = var1len;
                                            i = 0;
                                            i: for (; $22 > 0; $22--, i++) {
                                                // var1len is always <= var1.length
                                                if (i < var2.length) v2 = var2[i];else v2 = 0;
                                                if (var1[i] < v2) break inner; // V1 too low
                                                if (var1[i] > v2) break compare; // OK to subtract
                                            }
                                        }
                                        /*i*/
                                        /* reach here if lhs and rhs are identical; subtraction will
                                        increase digit by one, and the residue will be 0 so we
                                        are done; leave the loop with residue set to 0 (in case
                                        code is 'R' or ROUND_UNNECESSARY or a ROUND_HALF_xxxx is
                                        being checked) */
                                        thisdigit++;
                                        res.mant[have] = thisdigit;
                                        have++;
                                        var1[0] = 0; // residue to 0 [this is all we'll test]
                                        // var1len=1      -- [optimized out]
                                        break outer;
                                    } while (false);
                                }
                                /*compare*/
                                /* prepare for subtraction.  Estimate BA (lengths the same) */
                                ba = var1[0]; // use only first digit
                            } // lengths the same
                            else {
                                    /* lhs longer than rhs */
                                    /* use first two digits for estimate */
                                    ba = var1[0] * 10;
                                    if (var1len > 1) ba = ba + var1[1];
                                }
                            /* subtraction needed; V1>=V2 */
                            mult = div(ba * 10, b2b);
                            if (mult == 0) mult = 1;
                            thisdigit = thisdigit + mult;
                            // subtract; var1 reusable
                            var1 = this.byteaddsub(var1, var1len, var2, var2len, -mult, true);
                            if (var1[0] != 0) continue inner; // maybe another subtract needed
                            /* V1 now probably has leading zeros, remove leading 0's and try
                            again. (It could be longer than V2) */
                            {
                                var $23 = var1len - 2;
                                start = 0;
                                start: for (; start <= $23; start++) {
                                    if (var1[start] != 0) break start;
                                    var1len--;
                                }
                            }
                            /*start*/
                            if (start == 0) continue inner;
                            // shift left
                            //--java.lang.System.arraycopy((java.lang.Object)var1,start,(java.lang.Object)var1,0,var1len);
                            this.arraycopy(var1, start, var1, 0, var1len);
                        }
                    }
                    /*inner*/

                    /* We have the next digit */
                    if (have != 0 || thisdigit != 0) {
                        // put the digit we got
                        res.mant[have] = thisdigit;
                        have++;
                        if (have == reqdig + 1) break outer; // we have all we need
                        if (var1[0] == 0) break outer; // residue now 0
                    }
                    /* can leave now if a scaled divide and exponent is small enough */
                    if (scale >= 0) if (-res.exp > scale) break outer;
                    /* can leave now if not Divide and no integer part left  */
                    if (code != 'D') if (res.exp <= 0) break outer;
                    res.exp = res.exp - 1; // reduce the exponent
                    /* to get here, V1 is less than V2, so divide V2 by 10 and go for
                    the next digit */
                    var2len--;
                }
            }
            /*outer*/

            /* here when we have finished dividing, for some reason */
            // have is the number of digits we collected in res.mant
            if (have == 0) have = 1; // res.mant[0] is 0; we always want a digit

            if (code == 'I' || code == 'R') {
                /* check for integer overflow needed */
                if (have + res.exp > reqdig) throw "dodivide(): Integer overflow";

                if (code == 'R') {
                    remainder: do {
                        /* We were doing Remainder -- return the residue */
                        if (res.mant[0] == 0) // no integer part was found
                            return this.clone(lhs).finish(set, false); // .. so return lhs, canonical
                        if (var1[0] == 0) return this.ZERO; // simple 0 residue
                        res.ind = lhs.ind; // sign is always as LHS
                        /* Calculate the exponent by subtracting the number of padding zeros
                        we added and adding the original exponent */
                        padding = reqdig + reqdig + 1 - lhs.mant.length;
                        res.exp = res.exp - padding + lhs.exp;

                        /* strip insignificant padding zeros from residue, and create/copy
                        the resulting mantissa if need be */
                        d = var1len;
                        {
                            i = d - 1;
                            i: for (; i >= 1; i--) {
                                if (!(res.exp < lhs.exp && res.exp < rhs.exp)) break;
                                if (var1[i] != 0) break i;
                                d--;
                                res.exp = res.exp + 1;
                            }
                        }
                        /*i*/
                        if (d < var1.length) {
                            /* need to reduce */
                            newvar1 = new Array(d);
                            //--java.lang.System.arraycopy((java.lang.Object)var1,0,(java.lang.Object)newvar1,0,d); // shorten
                            this.arraycopy(var1, 0, newvar1, 0, d);
                            var1 = newvar1;
                        }
                        res.mant = var1;
                        return res.finish(set, false);
                    } while (false);
                }
                /*remainder*/
            } else {
                /* 'D' -- no overflow check needed */
                // If there was a residue then bump the final digit (iff 0 or 5)
                // so that the residue is visible for ROUND_UP, ROUND_HALF_xxx and
                // ROUND_UNNECESSARY checks (etc.) later.
                // [if we finished early, the residue will be 0]
                if (var1[0] != 0) {
                    // residue not 0
                    lasthave = res.mant[have - 1];
                    if (lasthave % 5 == 0) res.mant[have - 1] = lasthave + 1;
                }
            }

            /* Here for Divide or Integer Divide */
            // handle scaled results first ['I' always scale 0, optional for 'D']
            if (scale >= 0) {
                scaled: do {
                    // say 'scale have res.exp len' scale have res.exp res.mant.length
                    if (have != res.mant.length)
                        // already padded with 0's, so just adjust exponent
                        res.exp = res.exp - (res.mant.length - have);
                    // calculate number of digits we really want [may be 0]
                    actdig = res.mant.length - (-res.exp - scale);
                    res.round(actdig, set.roundingMode); // round to desired length
                    // This could have shifted left if round (say) 0.9->1[.0]
                    // Repair if so by adding a zero and reducing exponent
                    if (res.exp != -scale) {
                        res.mant = this.extend(res.mant, res.mant.length + 1);
                        res.exp = res.exp - 1;
                    }
                    return res.finish(set, true); // [strip if not PLAIN]
                } while (false);
            }
            /*scaled*/

            // reach here only if a non-scaled
            if (have == res.mant.length) {
                // got digits+1 digits
                res.round(set);
                have = reqdig;
            } else {
                /* have<=reqdig */
                if (res.mant[0] == 0) return this.ZERO; // fastpath
                // make the mantissa truly just 'have' long
                // [we could let finish do this, during strip, if we adjusted
                // the exponent; however, truncation avoids the strip loop]
                newmant = new Array(have); // shorten
                //--java.lang.System.arraycopy((java.lang.Object)res.mant,0,(java.lang.Object)newmant,0,have);
                this.arraycopy(res.mant, 0, newmant, 0, have);
                res.mant = newmant;
            }
            return res.finish(set, true);
        }

        /* <sgml> Report a conversion exception. </sgml> */

        //--private void bad(char s[]){
        function bad(prefix, s) {
            throw prefix + "Not a number: " + s;
        }

        /* <sgml> Report a bad argument to a method. </sgml>
        Arg1 is method name
        Arg2 is argument position
        Arg3 is what was found */

        //--private void badarg(java.lang.String name,int pos,java.lang.String value){
        function badarg(name, pos, value) {
            throw "Bad argument " + pos + " to " + name + ": " + value;
        }

        /* <sgml> Extend byte array to given length, padding with 0s.  If no
        extension is required then return the same array. </sgml>
        Arg1 is the source byte array
        Arg2 is the new length (longer)
        */

        //--private static final byte[] extend(byte inarr[],int newlen){
        function extend(inarr, newlen) {
            //--byte newarr[];
            var newarr;
            if (inarr.length == newlen) return inarr;
            newarr = createArrayWithZeros(newlen);
            //--java.lang.System.arraycopy((java.lang.Object)inarr,0,(java.lang.Object)newarr,0,inarr.length);
            this.arraycopy(inarr, 0, newarr, 0, inarr.length);
            // 0 padding is carried out by the JVM on allocation initialization
            return newarr;
        }

        /* <sgml> Add or subtract two >=0 integers in byte arrays
        <p>This routine performs the calculation:
        <pre>
        C=A+(B*M)
        </pre>
        Where M is in the range -9 through +9
        <p>
        If M<0 then A>=B must be true, so the result is always
        non-negative.
        Leading zeros are not removed after a subtraction.  The result is
        either the same length as the longer of A and B, or 1 longer than
        that (if a carry occurred).
        A is not altered unless Arg6 is 1.
        B is never altered.
        Arg1 is A
        Arg2 is A length to use (if longer than A, pad with 0's)
        Arg3 is B
        Arg4 is B length to use (if longer than B, pad with 0's)
        Arg5 is M, the multiplier
        Arg6 is 1 if A can be used to build the result (if it fits)
        This routine is severely performance-critical; *any* change here
        must be measured (timed) to assure no performance degradation.
        */
        // 1996.02.20 -- enhanced version of DMSRCN algorithm (1981)
        // 1997.10.05 -- changed to byte arrays (from char arrays)
        // 1998.07.01 -- changed to allow destructive reuse of LHS
        // 1998.07.01 -- changed to allow virtual lengths for the arrays
        // 1998.12.29 -- use lookaside for digit/carry calculation
        // 1999.08.07 -- avoid multiply when mult=1, and make db an int
        // 1999.12.22 -- special case m=-1, also drop 0 special case

        //--private static final byte[] byteaddsub(byte a[],int avlen,byte b[],int bvlen,int m,boolean reuse){
        function byteaddsub(a, avlen, b, bvlen, m, reuse) {
            //--int alength;
            var alength;
            //--int blength;
            var blength;
            //--int ap;
            var ap;
            //--int bp;
            var bp;
            //--int maxarr;
            var maxarr;
            //--byte reb[];
            var reb;
            //--boolean quickm;
            var quickm;
            //--int digit;
            var digit;
            //--int op=0;
            var op = 0;
            //--int dp90=0;
            var dp90 = 0;
            //--byte newarr[];
            var newarr;
            //--int i=0;
            var i = 0;

            // We'll usually be right if we assume no carry
            alength = a.length; // physical lengths
            blength = b.length; // ..
            ap = avlen - 1; // -> final (rightmost) digit
            bp = bvlen - 1; // ..
            maxarr = bp;
            if (maxarr < ap) maxarr = ap;
            reb = null; // result byte array
            if (reuse) if (maxarr + 1 == alength) reb = a; // OK to reuse A
            if (reb == null) {
                reb = this.createArrayWithZeros(maxarr + 1); // need new array
            }

            quickm = false; // 1 if no multiply needed
            if (m == 1) quickm = true; // most common
            else if (m == -1) quickm = true; // also common

            digit = 0; // digit, with carry or borrow
            {
                op = maxarr;
                op: for (; op >= 0; op--) {
                    if (ap >= 0) {
                        if (ap < alength) digit = digit + a[ap]; // within A
                        ap--;
                    }
                    if (bp >= 0) {
                        if (bp < blength) {
                            // within B
                            if (quickm) {
                                if (m > 0) digit = digit + b[bp]; // most common
                                else digit = digit - b[bp]; // also common
                            } else digit = digit + b[bp] * m;
                        }
                        bp--;
                    }
                    /* result so far (digit) could be -90 through 99 */
                    if (digit < 10) if (digit >= 0) {
                        quick: do {
                            // 0-9
                            reb[op] = digit;
                            digit = 0; // no carry
                            continue op;
                        } while (false);
                    }
                    /*quick*/
                    dp90 = digit + 90;
                    reb[op] = this.bytedig[dp90]; // this digit
                    digit = this.bytecar[dp90]; // carry or borrow
                }
            }
            /*op*/

            if (digit == 0) return reb; // no carry
            // following line will become an Assert, later
            // if digit<0 then signal ArithmeticException("internal.error ["digit"]")

            /* We have carry -- need to make space for the extra digit */
            newarr = null;
            if (reuse) if (maxarr + 2 == a.length) newarr = a; // OK to reuse A
            if (newarr == null) newarr = new Array(maxarr + 2);
            newarr[0] = digit; // the carried digit ..
            // .. and all the rest [use local loop for short numbers]
            //--if (maxarr<10)
            {
                var $24 = maxarr + 1;
                i = 0;
                i: for (; $24 > 0; $24--, i++) {
                    newarr[i + 1] = reb[i];
                }
            }
            /*i*/
            //--else
            //--java.lang.System.arraycopy((java.lang.Object)reb,0,(java.lang.Object)newarr,1,maxarr+1);
            return newarr;
        }

        /* <sgml> Initializer for digit array properties (lookaside). </sgml>
        Returns the digit array, and initializes the carry array. */

        //--private static final byte[] diginit(){
        function diginit() {
            //--byte work[];
            var work;
            //--int op=0;
            var op = 0;
            //--int digit=0;
            var digit = 0;
            work = new Array(90 + 99 + 1);
            {
                op = 0;
                op: for (; op <= 90 + 99; op++) {
                    digit = op - 90;
                    if (digit >= 0) {
                        work[op] = digit % 10;
                        BigDecimal.prototype.bytecar[op] = div(digit, 10); // calculate carry
                        continue op;
                    }
                    // borrowing...
                    digit = digit + 100; // yes, this is right [consider -50]
                    work[op] = digit % 10;
                    BigDecimal.prototype.bytecar[op] = div(digit, 10) - 10; // calculate borrow [NB: - after %]
                }
            }
            /*op*/
            return work;
        }

        /* <sgml> Create a copy of BigDecimal object for local use.
        <p>This does NOT make a copy of the mantissa array.
        </sgml>
        Arg1 is the BigDecimal to clone (non-null)
        */

        //--private static final com.ibm.icu.math.BigDecimal clone(com.ibm.icu.math.BigDecimal dec){
        function clone(dec) {
            //--com.ibm.icu.math.BigDecimal copy;
            var copy;
            copy = new BigDecimal();
            copy.ind = dec.ind;
            copy.exp = dec.exp;
            copy.form = dec.form;
            copy.mant = dec.mant;
            return copy;
        }

        /* <sgml> Check one or two numbers for lost digits. </sgml>
        Arg1 is RHS (or null, if none)
        Arg2 is current DIGITS setting
        returns quietly or throws an exception */

        //--private void checkdigits(com.ibm.icu.math.BigDecimal rhs,int dig){
        function checkdigits(rhs, dig) {
            if (dig == 0) return; // don't check if digits=0
            // first check lhs...
            if (this.mant.length > dig) if (!this.allzero(this.mant, dig)) throw "Too many digits: " + this.toString();
            if (rhs == null) return; // monadic
            if (rhs.mant.length > dig) if (!this.allzero(rhs.mant, dig)) throw "Too many digits: " + rhs.toString();
            return;
        }

        /* <sgml> Round to specified digits, if necessary. </sgml>
        Arg1 is requested MathContext [with length and rounding mode]
        returns this, for convenience */

        //--private com.ibm.icu.math.BigDecimal round(com.ibm.icu.math.MathContext set){
        //-- return round(set.digits,set.roundingMode);
        //-- }

        /* <sgml> Round to specified digits, if necessary.
        Arg1 is requested length (digits to round to)
            [may be <=0 when called from format, dodivide, etc.]
        Arg2 is rounding mode
        returns this, for convenience
        ind and exp are adjusted, but not cleared for a mantissa of zero
        The length of the mantissa returned will be Arg1, except when Arg1
        is 0, in which case the returned mantissa length will be 1.
        </sgml>
        */

        //private com.ibm.icu.math.BigDecimal round(int len,int mode){
        function round() {
            var len;
            var mode;
            if (round.arguments.length == 2) {
                len = round.arguments[0];
                mode = round.arguments[1];
            } else if (round.arguments.length == 1) {
                var set = round.arguments[0];
                len = set.digits;
                mode = set.roundingMode;
            } else {
                throw "round(): " + round.arguments.length + " arguments given; expected 1 or 2";
            }
            //int adjust;
            var adjust;
            //int sign;
            var sign;
            //byte oldmant[];
            var oldmant;
            //boolean reuse=false;
            var reuse = false;
            //--byte first=0;
            var first = 0;
            //--int increment;
            var increment;
            //--byte newmant[]=null;
            var newmant = null;
            adjust = this.mant.length - len;
            if (adjust <= 0) return this; // nowt to do

            this.exp = this.exp + adjust; // exponent of result
            sign = this.ind; // save [assumes -1, 0, 1]
            oldmant = this.mant; // save
            if (len > 0) {
                // remove the unwanted digits
                this.mant = new Array(len);
                //--java.lang.System.arraycopy((java.lang.Object)oldmant,0,(java.lang.Object)mant,0,len);
                this.arraycopy(oldmant, 0, this.mant, 0, len);
                reuse = true; // can reuse mantissa
                first = oldmant[len]; // first of discarded digits
            } else {
                /* len<=0 */
                this.mant = this.ZERO.mant;
                this.ind = this.iszero;
                reuse = false; // cannot reuse mantissa
                if (len == 0) first = oldmant[0];else first = 0; // [virtual digit]
            }

            // decide rounding adjustment depending on mode, sign, and discarded digits
            increment = 0; // bumper
            {
                modes: do {
                    /*select*/
                    if (mode == this.ROUND_HALF_UP) {
                        // default first [most common]
                        if (first >= 5) increment = sign;
                    } else if (mode == this.ROUND_UNNECESSARY) {
                        // default for setScale()
                        // discarding any non-zero digits is an error
                        if (!this.allzero(oldmant, len)) throw "round(): Rounding necessary";
                    } else if (mode == this.ROUND_HALF_DOWN) {
                        // 0.5000 goes down
                        if (first > 5) increment = sign;else if (first == 5) if (!this.allzero(oldmant, len + 1)) increment = sign;
                    } else if (mode == this.ROUND_HALF_EVEN) {
                        // 0.5000 goes down if left digit even
                        if (first > 5) increment = sign;else if (first == 5) {
                            if (!this.allzero(oldmant, len + 1)) increment = sign;else /* 0.5000 */
                                if (this.mant[this.mant.length - 1] % 2 == 1) increment = sign;
                        }
                    } else if (mode == this.ROUND_DOWN) {} // never increment
                    else if (mode == this.ROUND_UP) {
                            // increment if discarded non-zero
                            if (!this.allzero(oldmant, len)) increment = sign;
                        } else if (mode == this.ROUND_CEILING) {
                            // more positive
                            if (sign > 0) if (!this.allzero(oldmant, len)) increment = sign;
                        } else if (mode == this.ROUND_FLOOR) {
                            // more negative
                            if (sign < 0) if (!this.allzero(oldmant, len)) increment = sign;
                        } else {
                            throw "round(): Bad round value: " + mode;
                        }
                } while (false);
            }
            /*modes*/

            if (increment != 0) {
                bump: do {
                    if (this.ind == this.iszero) {
                        // we must not subtract from 0, but result is trivial anyway
                        this.mant = this.ONE.mant;
                        this.ind = increment;
                    } else {
                        // mantissa is non-0; we can safely add or subtract 1
                        if (this.ind == this.isneg) increment = -increment;
                        newmant = this.byteaddsub(this.mant, this.mant.length, this.ONE.mant, 1, increment, reuse);
                        if (newmant.length > this.mant.length) {
                            // had a carry
                            // drop rightmost digit and raise exponent
                            this.exp++;
                            // mant is already the correct length
                            //java.lang.System.arraycopy((java.lang.Object)newmant,0,(java.lang.Object)mant,0,mant.length);
                            this.arraycopy(newmant, 0, this.mant, 0, this.mant.length);
                        } else this.mant = newmant;
                    }
                } while (false);
            }
            /*bump*/
            // rounding can increase exponent significantly
            if (this.exp > this.MaxExp) throw "round(): Exponent Overflow: " + this.exp;
            return this;
        }

        /* <sgml> Test if rightmost digits are all 0.
        Arg1 is a mantissa array to test
        Arg2 is the offset of first digit to check
            [may be negative; if so, digits to left are 0's]
        returns 1 if all the digits starting at Arg2 are 0
        Arg2 may be beyond array bounds, in which case 1 is returned
        </sgml> */

        //--private static final boolean allzero(byte array[],int start){
        function allzero(array, start) {
            //--int i=0;
            var i = 0;
            if (start < 0) start = 0;
            {
                var $25 = array.length - 1;
                i = start;
                i: for (; i <= $25; i++) {
                    if (array[i] != 0) return false;
                }
            }
            /*i*/
            return true;
        }

        /* <sgml> Carry out final checks and canonicalization
        <p>
        This finishes off the current number by:
        1. Rounding if necessary (NB: length includes leading zeros)
        2. Stripping trailing zeros (if requested and \PLAIN)
        3. Stripping leading zeros (always)
        4. Selecting exponential notation (if required)
        5. Converting a zero result to just '0' (if \PLAIN)
        In practice, these operations overlap and share code.
        It always sets form.
        </sgml>
        Arg1 is requested MathContext (length to round to, trigger, and FORM)
        Arg2 is 1 if trailing insignificant zeros should be removed after
         round (for division, etc.), provided that set.form isn't PLAIN.
        returns this, for convenience
        */

        //--private com.ibm.icu.math.BigDecimal finish(com.ibm.icu.math.MathContext set,boolean strip){
        function finish(set, strip) {
            //--int d=0;
            var d = 0;
            //--int i=0;
            var i = 0;
            //--byte newmant[]=null;
            var newmant = null;
            //--int mag=0;
            var mag = 0;
            //--int sig=0;
            var sig = 0;
            /* Round if mantissa too long and digits requested */
            if (set.digits != 0) if (this.mant.length > set.digits) this.round(set);

            /* If strip requested (and standard formatting), remove
            insignificant trailing zeros. */
            if (strip) if (set.form != MathContext.prototype.PLAIN) {
                d = this.mant.length;
                /* see if we need to drop any trailing zeros */
                {
                    i = d - 1;
                    i: for (; i >= 1; i--) {
                        if (this.mant[i] != 0) break i;
                        d--;
                        this.exp++;
                    }
                }
                /*i*/
                if (d < this.mant.length) {
                    /* need to reduce */
                    newmant = new Array(d);
                    //--java.lang.System.arraycopy((java.lang.Object)this.mant,0,(java.lang.Object)newmant,0,d);
                    this.arraycopy(this.mant, 0, newmant, 0, d);
                    this.mant = newmant;
                }
            }

            this.form = MathContext.prototype.PLAIN; // preset

            /* Now check for leading- and all- zeros in mantissa */
            {
                var $26 = this.mant.length;
                i = 0;
                i: for (; $26 > 0; $26--, i++) {
                    if (this.mant[i] != 0) {
                        // non-0 result; ind will be correct
                        // remove leading zeros [e.g., after subtract]
                        if (i > 0) {
                            delead: do {
                                newmant = new Array(this.mant.length - i);
                                //--java.lang.System.arraycopy((java.lang.Object)this.mant,i,(java.lang.Object)newmant,0,this.mant.length-i);
                                this.arraycopy(this.mant, i, newmant, 0, this.mant.length - i);
                                this.mant = newmant;
                            } while (false);
                        }
                        /*delead*/
                        // now determine form if not PLAIN
                        mag = this.exp + this.mant.length;
                        if (mag > 0) {
                            // most common path
                            if (mag > set.digits) if (set.digits != 0) this.form = set.form;
                            if (mag - 1 <= this.MaxExp) return this; // no overflow; quick return
                        } else if (mag < -5) this.form = set.form;
                        /* check for overflow */
                        mag--;
                        if (mag < this.MinExp || mag > this.MaxExp) {
                            overflow: do {
                                // possible reprieve if form is engineering
                                if (this.form == MathContext.prototype.ENGINEERING) {
                                    sig = mag % 3; // leftover
                                    if (sig < 0) sig = 3 + sig; // negative exponent
                                    mag = mag - sig; // exponent to use
                                    // 1999.06.29: second test here must be MaxExp
                                    if (mag >= this.MinExp) if (mag <= this.MaxExp) break overflow;
                                }
                                throw "finish(): Exponent Overflow: " + mag;
                            } while (false);
                        }
                        /*overflow*/
                        return this;
                    }
                }
            }
            /*i*/

            // Drop through to here only if mantissa is all zeros
            this.ind = this.iszero;
            {
                /*select*/
                if (set.form != MathContext.prototype.PLAIN) this.exp = 0; // standard result; go to '0'
                else if (this.exp > 0) this.exp = 0; // +ve exponent also goes to '0'
                    else {
                            // a plain number with -ve exponent; preserve and check exponent
                            if (this.exp < this.MinExp) throw "finish(): Exponent Overflow: " + this.exp;
                        }
            }
            this.mant = this.ZERO.mant; // canonical mantissa
            return this;
        }

        function isGreaterThan(other) {
            return this.compareTo(other) > 0;
        };

        function isLessThan(other) {
            return this.compareTo(other) < 0;
        };

        function isGreaterThanOrEqualTo(other) {
            return this.compareTo(other) >= 0;
        };

        function isLessThanOrEqualTo(other) {
            return this.compareTo(other) <= 0;
        };

        function isPositive() {
            return this.compareTo(BigDecimal.prototype.ZERO) > 0;
        };

        function isNegative() {
            return this.compareTo(BigDecimal.prototype.ZERO) < 0;
        };

        function isZero() {
            return this.compareTo(BigDecimal.prototype.ZERO) === 0;
        };
        return BigDecimal;
    }(MathContext); // BigDecimal depends on MathContext
    this.BigDecimal = BigDecimal;
    this.MathContext = MathContext;
}).call(window); // in browser 'this' will be 'window' or simulated window object in AMD-loading scenarios.

/***/ }),

/***/ "q6NO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancel"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("用户取消时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.cancelTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("用户下单时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qhpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_publicNote_vue__ = __webpack_require__("i9Lx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197ac3a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_publicNote_vue__ = __webpack_require__("74jZ");
function injectStyle (ssrContext) {
  __webpack_require__("4FzC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-197ac3a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_publicNote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197ac3a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_publicNote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r6TT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_vue__ = __webpack_require__("c2uW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eab19f9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_vue__ = __webpack_require__("tic7");
function injectStyle (ssrContext) {
  __webpack_require__("XJ4x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7eab19f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eab19f9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rJFL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rM4U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_zh_CN__ = __webpack_require__("+8+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("hhm8");






var lang = localStorage.getItem("lang");
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].localize(lang === 'en' ? 'en-US' : 'zh_CN', {
  messages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_zh_CN___default.a.messages, {
    required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('不能为空'),
    regex: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('格式错误'),
    numeric: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('只能包含数字'),
    min: function min(n, e) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('不能少于') + e[0] + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('位');
    },
    max: function max(n, e) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('不能多于') + e[0] + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('位');
    },
    email: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('邮箱格式错误')
  })
});

// 整数验证
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('intNumber', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('请输入整数值');
  },
  validate: function validate(value) {
    var IntNumber = /^[1-9]\d*$/;
    return IntNumber.test(value);
  }
});

// 数字验证
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('floatNumber', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('请输入数字');
  },
  validate: function validate(value) {
    var IntNumber = /^\d+(\.\d+)?$/;
    return IntNumber.test(value);
  }
});

// 银行卡格式校验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('idCard', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('格式错误');
  },
  validate: function validate(value) {
    var isIDCard1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/; // (15位)
    var isIDCard2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/; // (18位)
    return isIDCard1.test(value) || isIDCard2.test(value);
  }
});

// 短信验证码
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('capt', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('格式错误');
  },
  validate: function validate(value) {
    var isIDCard1 = /^\d{4}$/;
    return isIDCard1.test(value);
  }
});

// 手机号检验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('phone', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('手机号格式错误');
  },
  validate: function validate(value) {
    var isIDCard1 = /^1[3|4|5|6|7|8]\d{9}$/;
    return isIDCard1.test(value);
  }
});

// 邮箱账号检验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('email', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('邮箱格式错误');
  },
  validate: function validate(value) {
    var isIDCard1 = /^[a-z0-9._%-]+@([a-z0-9-]+\.)+[a-z]{2,4}$/;
    return isIDCard1.test(value);
  }
});

// 邮箱号手机号账号检验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('emailPhone', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('邮箱或手机号格式错误');
  },
  validate: function validate(value) {
    var isIDCard1 = /^[a-z0-9._%-]+@([a-z0-9-]+\.)+[a-z]{2,4}$|^1[3|4|5|6|7|8|9]\d{9}$/;
    return isIDCard1.test(value);
  }
});

// 登录密码校验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('password', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('字母数字组合6-16位');
  },
  validate: function validate(value) {
    var isIDCard1 = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
    return isIDCard1.test(value) && 5 < value.length && value.length < 16;
  }
});

// 昵称校验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('nickname', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('昵称2-20位');
  },
  validate: function validate(value) {
    return 1 < value.length && value.length < 21;
  }
});

// 支付密码校验
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('trade', {
  getMessage: function getMessage(field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getTranslateText */])('密码长度为6位且为数字');
  },
  validate: function validate(value) {
    var isIDCard1 = /[0-9]\d*$/;
    return isIDCard1.test(value) && value.length == 6;
  }
});

// 校验第二次密码是否和第一次相同
// Validator.extend('trade', {
//   getMessage: field => '两次密码不一致',
//   validate: value => {
//     return value.length < 6;
//   }
// });

var config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'zh_CN',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'blur',
  inject: true,
  validity: false,
  aria: true
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "sNP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__ = __webpack_require__("u7L+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0_base_tab_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "sUnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accomplish"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("用户下单时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("申请结算时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.applyTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("确认结算时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.settleTime))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("完成时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.accomplishTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "subR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tic7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order"},[(_vm.isLoadingState)?_c('loading'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-one mui-bar-nav",attrs:{"id":"searchBar"}},[_c('p',{staticClass:"order-one-p"},[_vm._v("账目")]),_vm._v(" "),_c('div',{staticClass:"order-one-two"},[_c('div',{staticClass:"order-one-two-left"},[_c('p',{staticClass:"left-p"},[_vm._v("待结算金额")]),_vm._v(" "),_c('p',{staticClass:"left-twoP"},[_vm._v("\n          ¥\n          "),_c('span',{staticClass:"left-span"},[_vm._v(_vm._s(_vm.totalToBeSettleAmount.toLocaleString()))])])]),_vm._v(" "),_c('div',{staticClass:"order-one-two-right",on:{"click":_vm.onclickClose}},[_c('span',[_vm._v("一键结算")])])]),_vm._v(" "),_c('div',{staticClass:"order-one-three"},[_c('div',{staticClass:"order-one-three-span"},[_c('p',[_vm._v("待退回(元)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.totalRefundAmount.toLocaleString()))])]),_vm._v(" "),_c('div',{staticClass:"order-one-three-span order-one-three-Twospan"},[_c('p',[_vm._v("结算中(元)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.totalSettlingAmount.toLocaleString()))])]),_vm._v(" "),_c('div',{staticClass:"order-one-three-span",staticStyle:{"margin-left":"20px"}},[_c('p',[_vm._v("累计结算(元)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.totalSettleAmount.toLocaleString()))])])])]),_vm._v(" "),_c('div',{staticClass:"order-two"},[_c('van-sticky',{on:{"scroll":_vm.vanStickyScroll}},[(_vm.offsetTopState)?_c('div',{staticClass:"home-header-fixed header"},[_vm._v("账目")]):_vm._e()]),_vm._v(" "),_c('van-tabs',{ref:"getheight",attrs:{"swipeable":"","sticky":""},on:{"change":_vm.change,"click":_vm.onclickHighlight},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.wholeList),function(item,index){return _c('van-tab',{key:index + '+only',attrs:{"title":item.name}},[_c('van-pull-refresh',{on:{"refresh":_vm.onRefresh},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}},[_c('van-list',{attrs:{"finished":_vm.finished,"immediate-check":false,"finished-text":_vm.finishedText},on:{"load":_vm.onLoadList},model:{value:(_vm.isUpLoading),callback:function ($$v) {_vm.isUpLoading=$$v},expression:"isUpLoading"}},[_vm._l((_vm.shopList),function(isitem){return _c('div',{key:isitem.id},[_c('div',{staticClass:"order-two-one",on:{"click":function($event){return _vm.onClickShop(isitem)}}},[_c('div',{staticClass:"order-two-two"},[_c('div',{staticClass:"order-two-two-left"},[_c('span',[_vm._v("订单号："+_vm._s(isitem.serialNumber))])]),_vm._v(" "),_c('div',{staticClass:"order-two-two-right"},[_c('span',{class:isitem.statusName == '已取消' ||
                        isitem.statusName == '待退款' ||
                        isitem.statusName == '已退款' ||
                        isitem.statusName == '退款中'
                          ? 'aaa'
                          : isitem.statusName == '已完成'
                          ? 'bbb'
                          : 'ccc'},[_vm._v(_vm._s(isitem.statusName))])])]),_vm._v(" "),_vm._l((isitem.paymentGoodsList),function(items,index){return _c('div',{key:index,staticClass:"completerecords-two"},[_c('div',{staticClass:"completerecords-two-left"},[_c('img',{attrs:{"src":items.productNormsImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"completerecords-two-right"},[_c('div',{staticClass:"completerecords-two-right-one"},[_c('span',[_vm._v(_vm._s(_vm.ellipsis || items.productName))]),_vm._v(" "),_c('span',[_vm._v("(货号："+_vm._s(items.artNo)+")")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"right-one-span"},[_vm._v("\n                        "+_vm._s(items.productNormsName)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"completerecords-two-right-two"},[_c('p',[_vm._v("\n                        ￥\n                        "),_c('span',{staticClass:"completerecords-onespan"},[_vm._v(_vm._s(items.costPrice))]),_vm._v(" "),_c('span',{staticClass:"completerecords-twospan"},[_vm._v("x"+_vm._s(items.number))])])])])])}),_vm._v(" "),(
                    isitem.statusName == '待结算' ||
                    isitem.statusName == '待退款'
                  )?_c('div',{staticClass:"completerecords-three"},[_c('div',{staticClass:"completerecords-three-left"},[_c('span',[_vm._v("\n                      "+_vm._s(isitem.status == "1" ? "待结算金额" : "待退款金额")+"￥\n                    ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(isitem.totalAmount))])]),_vm._v(" "),_c('div',{staticClass:"completerecords-three-right",on:{"click":function($event){return _vm.onclickAccount(isitem, index)}}},[_c('span',[_vm._v(_vm._s(isitem.status == "1" ? "结算" : "退款"))])])]):_vm._e()],2)])}),_vm._v(" "),(_vm.imgState)?_c('div',[_c('div',{staticClass:"imgState",staticStyle:{"text-align":"center","height":"65vh"}},[_c('img',{attrs:{"src":__webpack_require__("hFqa"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("您还没有账户明细哦")])])]):_vm._e()],2)],1)],1)}),1)],1),_vm._v(" "),(_vm.CloseState)?_c('div',{staticClass:"order-footer"},[_c('vSettleAccounts',{attrs:{"token":_vm.token,"settleObj":_vm.settleObj},on:{"onclickImg":_vm.onclickImg,"onClickSumbit":_vm.onClickSumbit}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u7L+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__("wIWE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b1c17cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_vue__ = __webpack_require__("nFVn");
function injectStyle (ssrContext) {
  __webpack_require__("muJA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b1c17cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b1c17cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uAid":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-loading-wrapper"},[_c('div',{staticClass:"full-loading"},[_c('div',{staticClass:"inner-loading"},[_c('img',{attrs:{"src":__webpack_require__("nYwz")}}),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.getTitle(_vm.title)))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_bean_user__ = __webpack_require__("8OU2");




var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["SET_USER_STATE"], function (state, user) {
  state.user = new __WEBPACK_IMPORTED_MODULE_2_common_bean_user__["a" /* default */](user);
});

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "vFEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settleAccounts_vue__ = __webpack_require__("kniT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6768e898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settleAccounts_vue__ = __webpack_require__("Qrsv");
function injectStyle (ssrContext) {
  __webpack_require__("rJFL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6768e898"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settleAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6768e898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settleAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wGIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      visible: false,
      message: ""
    };
  }
});

/***/ }),

/***/ "wIWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    arrow: String
  },
  created: function created() {}
});

/***/ }),

/***/ "wiYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_util__ = __webpack_require__("hhm8");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    commodityListDetails: {} //数据
  },
  data: function data() {
    return {
      orderTime: null, //用户下单时间：
      cancelTime: null //用户取消时间
    };
  },

  watch: {
    commodityListDetails: {
      handler: function handler(newVal) {
        var cancelTime = newVal.cancelTime,
            orderTime = newVal.orderTime;

        this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util__["e" /* formatDate */])(orderTime);
        this.cancelTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util__["e" /* formatDate */])(cancelTime);
      },

      deep: true
    }
  },
  created: function created() {
    var _commodityListDetails = this.commodityListDetails,
        orderTime = _commodityListDetails.orderTime,
        cancelTime = _commodityListDetails.cancelTime;

    if (orderTime) {
      this.orderTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util__["e" /* formatDate */])(orderTime);
    }
    if (cancelTime) {
      this.cancelTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_util__["e" /* formatDate */])(cancelTime);
    }
  }
});

/***/ }),

/***/ "wxrh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x+us":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":__webpack_require__("3Hpq")}}),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xB31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xCLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amountOf"},[_c('div',{staticClass:"completerecords-three-one"},[_c('span',[_vm._v("用户下单时间:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTime))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_full_loading_full_loading__ = __webpack_require__("WHH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_toast_toast__ = __webpack_require__("m/lI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__("Du/2");

//
//
//
//
//
//
//
//





//  import comm from './assets/css/comm.css'//初始化css 
// import resize from './assets/js/resize';//自适应屏幕  
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      textMsg: '',
      coinData: {},
      isLoading: false,
      interTime: null
    };
  },
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__))),
  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_2_base_toast_toast__["a" /* default */],
    FullLoading: __WEBPACK_IMPORTED_MODULE_1_base_full_loading_full_loading__["a" /* default */]
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ "xZXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  language: {
    name: '中文'
  },
  // footer
  footer: {
    navbar: {
      page: '首页',
      shop: '商城',
      trading: '交易',
      wallet: '钱包',
      mine: '我的'
    }
  },
  // 公共文字
  common: {
    zwgg: '暂无广告',
    szzjmm: '请设置交易密码',
    jzz: '加载中',
    jzwb: '已经全部加载完毕',
    czcg: '操作成功',
    txwz: '请填写完整',
    qx: '取消',
    fq: '放弃',
    qr: '确认',
    qd: '确定',
    jg: '价格',
    je: '金额',
    sl: '数量',
    gm: '购买',
    cs: '出售',
    zfb: '支付宝',
    wx: '微信',
    yhkzz: '银行卡转账',
    qdlhcz: '请登录后操作',
    xdcg: '下单成功',
    mr: '买入',
    mc: '卖出',
    jy: '交易',
    hp: '好评',
    xr: '信任',
    cp: '差评',
    buyFMVP: '去购买FMVP',
    qxdl: '请先登录',
    jytx: '交易提醒',
    zwsj: '暂无数据',
    qxzf: '取消支付',
    bjfk: '标记付款',
    type: '类型'
  },
  // page页
  page: {
    navbar: {
      title: 'FUNMVP'
    },
    cate: {
      game: '游戏',
      xss: '游戏驯兽师',
      exchange: '二手车兑换',
      otc: '场外交易',
      splendid: '精彩画面，任你游',
      bbDeal: '币币交易',
      realTime: '24h全球实时行情',
      xtgg: '系统公告',
      sstsjcnr: '实时推送精彩内容',
      ptjs: '平台介绍',
      ljwm: '让你更加的了解我们'
    }
  },
  // 游戏商城页
  shop: {
    navbar: {
      title: '商城',
      txt: '区块链游戏',
      car: '二手车',
      escdh: '二手车兑换'
    },
    subject: {
      yxye: '游戏余额',
      jryx: '进入游戏',
      zryx: '转入游戏',
      cz: '充值',
      qsrczsl: '请输入充值数量',
      czslbnwk: '充值数量不能为空'
    }
  },
  // 系统公告
  notice: {
    subject: {
      zwgg: '暂无公告',
      gg: '公告'
    }
  },
  // 场外交易-列表页
  otc: {
    navbar: {
      txt: '场外交易',
      buyB: '买币',
      sellB: '卖币',
      bbjy: '币币交易'
    },
    navtxt: {
      xz: '请选择',
      zfb: '支付宝',
      wx: '微信',
      yhk: '银行卡转账'
    },
    subject: {
      ysm: '已实名',
      wsm: '未实名',
      jy: '交易',
      hp: '好评',
      xr: '信任',
      xe: '限额',
      bj: '编辑',
      cs: '出售',
      gm: '购买',
      fbgm: '发布购买',
      fbcs: '发布出售',
      fb: '发布'
    }
  },
  // 发布广告
  buyPublish: {
    subject: {
      jybz: '交易币种',
      jg: '价格',
      yjl: '溢价率',
      gm: '购买',
      cs: '出售',
      zdj: '最低价',
      zgj: '最高价',
      kjyzdj: '广告可交易的最低价',
      kyjzgj: '广告可交易的最高价',
      zxj: '最小限额',
      zced: '单笔交易的最小额度',
      zdjg: '最大限额',
      zded: '单笔交易的最大额度',
      zl: '总量',
      ye: '余额',
      sbzl: '请输入币的总量',
      fkfs: '付款方式',
      zfb: '支付宝',
      wx: '微信',
      yhk: '银行卡',
      fkqx: '付款期限',
      qsfkqx: '请输入付款期限',
      fz: '分钟',
      ggly: '付款备注里不得出现币相关等字眼。（必填）',
      gjsz: '高级设置',
      kfsj: '开放时间',
      rhsh: '任何时候',
      zdy: '自定义',
      jfs: '仅粉丝',
      zjfb: '直接发布',
      bccg: '保存草稿',
      zgcjjg: '广告最高可成交的价格',
      zdcjjg: '广告最低可成交的价格',
      xqy: '星期一',
      xqe: '星期二',
      xqs: '星期三',
      xqi: '星期四',
      xqw: '星期五',
      xql: '星期六',
      xqt: '星期天',
      yjlv: '溢价率应在-50到50之间',
      gb: '关闭',
      gglx: '广告类型'
    }
  },
  // 购买页面
  otcBuy: {
    userMsg: {
      xe: '限额',
      jycs: '交易次数',
      xrcs: '信任次数',
      xrl: '好评率',
      lsjy: '历史交易'
    },
    subject: {
      ggly: '广告留言',
      nx: '你想',
      ds: '多少？',
      kyye: '可用余额',
      syjyl: '广告剩余可交易量',
      srsz: '请输入数字',
      srsi: '请输入数值',
      xldf: '联系对方',
      zjmm: '交易密码',
      qsrzj: '请输入交易密码',
      xdqr: '下单确定',
      xdtxt: '提醒：请确认价格再下单，下单后此交易的',
      xdtxw: '将冻结锁定，请放心',
      fq: '放弃',
      qr: '确认',
      qszjmm: '请输入交易密码',
      gmslje: '请输入购买数量与购买金额',
      ddtjcg: '订单提交成功'
    }
  },
  // 个人主页
  homepage: {
    subject: {
      jycs: '交易次数',
      xrcs: '信任次数',
      xrl: '好评率',
      lsjy: '历史交易',
      xr: '信任',
      hmd: '黑名单',
      grzy: '个人主页',
      yxr: '已信任',
      ylh: '已拉黑'

    }
  },
  // 币币交易
  trading: {
    bbDeal: {
      cwjy: '场外交易',
      bbjy: '',
      mr: '买入',
      mc: '卖出',
      xj: '限价',
      sj: '市价',
      pk: '盘口',
      sl: '数量',
      sczjjg: '以市场上最优价格',
      wtjg: '委托价格',
      zh: '折合',
      wtsl: '委托数量',
      jye: '交易额',
      ky: '可用',
      km: '可买',
      dj: '冻结',
      kmai: '可卖',
      mai: '卖',
      m: '买',
      dqwt: '当前委托',
      ls: '历史',
      cx: '撤销',
      sjcj: '实际成交',
      zwdd: '暂无订单',
      zxj: '最新价'
    },
    bbDepth: {
      xj: '现价',
      zf: '涨幅',
      zg: '最高',
      zd: '最低',
      cj: '成交',
      gd: '挂单',
      sdt: '深度图',
      jj: '简介',
      bkbwl: '不能为空或小于等于零',
      xsbdy: '小数部分不得大于4位',
      xsldy: '小数部分不得大于2位',
      cjsj: '成交时间',
      cjjg: '成交价格',
      cjl: '成交量',
      more: '更多'
    },
    putUp: {
      buy20: '买盘20档',
      sell20: '卖盘20档',
      sl: '数量',
      jg: '价格'
    }
  },
  // 历史委托
  historyEntrust: {
    subject: {
      mr: '买入',
      mc: '卖出',
      sj: '市价',
      ze: '委托量',
      sjcj: '成交均价',
      zwdd: '暂无订单',
      lswt: '历史委托订单',
      ycj: '已成交'
    }
  },
  // 钱包
  wallet: {
    subject: {
      zzc: '总资产',
      b: '币',
      bzzc: '币种资产',
      dj: '冻结',
      ky: '可用',
      zr: '充币',
      zc: '提币',
      zd: '账单',
      cz: '去购买',
      tx: '去出售',
      ddjl: '订单记录',
      wdzc: '我的资产',
      xyzsf: '请先进行身份验证',
      szjymm: '请先设置交易密码'
    }
  },
  // 转入
  walletInto: {
    subject: {
      qbtscz: '钱包地址禁止充值除此币种之外其他资产,任何此币种之外的资产充值将不可找回',
      qbjz: '钱包地址禁止充值除',
      qbzw: '之外其他资产，任何',
      qbzh: '资产充值将不可找回',
      zrdz: '我的转入地址',
      dz: '地址',
      jl: '记录',
      fzskdz: '复制收款地址',
      zr: '转入',
      gbzc: '该机型不支持点击复制',
      fzcg: '复制成功'
    }
  },
  // 转出
  walletOut: {
    subject: {
      zc: '转出',
      kyye: '可用余额',
      jl: '记录',
      jsdz: '接受地址',
      qsrzzdz: '请输入转币地址',
      zzsl: '转账数量',
      qsrsl: '请输入转币数量',
      zjmm: '交易密码',
      qsrzjmm: '请输入交易密码',
      txsm: '提现说明',
      qsrsm: '请输入提现说明',
      kgf: '矿工费率',
      kgfzz: '矿工费将在可用余额中扣除，余额不足将从转账金额扣除',
      zzssmf: '在平台内相互转账是实时到账且免费的。',
      qrzz: '确认转账'
    }
  },
  // 转账记录
  walletBill: {
    subject: {
      zwjl: '暂无记录',
      qb: '全部',
      cb: '充币',
      tb: '提币',
      jymr: '交易买入',
      jymc: '交易卖出',
      zzjl: '转账记录',
      sxf: '手续费',
      yxzr: '游戏转入',
      yxzc: '游戏转出',
      djjd: '冻结解冻'
    }
  },
  // 账单详情
  billDetail: {
    subject: {
      bdqje: '变动前金额',
      bdhje: '变动后金额',
      sxf: '手续费',
      bdsj: '变动时间',
      jymx: '明细状态',
      zdxq: '账单详情'
    }
  },
  // 买卖fmvp
  walletBuy: {
    subject: {
      gmb: '购买FMVP币',
      csb: '出售FMVP币',
      zjbz: '自己币种',
      dj: '单价',
      gmje: '输入购买金额',
      gmsl: '输入购买数量',
      csje: '输入出售金额',
      cssl: '输入出售数量',
      sxf: '手续费',
      ky: '可用',
      zffs: '付款方式',
      qsrzh: '请输入自己的支付宝账号（以便确认）',
      bzxx: '付款备注里不得出现 BTC/ETH/FMVP、数字货币、区块链等字眼。',
      qxz: '请选择',
      zhhkh: '请输入账号或卡号',
      zjmm: '交易密码',
      qszjmm: '请输入交易密码',
      qrgm: '确认购买',
      qrcs: '确认出售',
      dksm: '请填写打款说明',
      jeyzzj: '金额应在1与2之间',
      jeyz: '金额应在',
      y: '与',
      zj: '之间',
      dbxz: '单笔限制',
      zded: '最低额度',
      zfb: '最低额度'
    }
  },
  // 订单记录
  walletRecord: {
    subject: {
      zje: '总金额',
      zwdd: '暂无订单',
      ddjl: '订单记录'
    }
  },
  // 订单详情
  orderDetail: {
    subject: {
      lx: '类型',
      skr: '收款人',
      skfs: '收款方式',
      zh: '账号',
      khh: '开户行',
      ptrz: '收款账户经过平台认证，请放心收款',
      wcfk: '我已完成付款',
      qxjy: '取消交易',
      dzf: '待支付',
      dqr: '待确认',
      ywc: '已完成',
      yqx: '已取消',
      ptyqx: '平台已取消',
      ddxq: '订单详情',
      ggly: '广告留言',
      otcBusiness: 'otc商家'
    }
  },
  // 个人主页
  mine: {
    subject: {
      jy: '交易',
      hpl: '好评率',
      xr: '信任',
      wygm: '我要购买',
      wycs: '我要出售',
      wdgg: '我的广告',
      wddd: '我的订单',
      jyds: '交易对手',
      yqhy: '邀请好友',
      aqzx: '安全中心',
      gywm: '关于我们',
      grzx: '个人中心',
      ghcg: '更换成功',
      tpsc: '图片上传出错',
      nyxxx: '您有新消息'
    }
  },
  // 我的广告
  myAdvertising: {
    subject: {
      dfb: '待发布',
      yfb: '已发布',
      xe: '限额',
      fb: '发布',
      bj: '编辑',
      xj: '下架',
      zwgg: '暂无广告',
      wdgg: '我的广告',
      type: '类型'
    }
  },
  // 我的订单
  myOrder: {
    subject: {
      jxz: '进行中',
      yjs: '已结束',
      jyje: '交易金额',
      jysl: '交易数量',
      ddbh: '订单编号：',
      zwdd: '暂无订单',
      wddd: '我的订单',
      wd: '未读'
    }
  },
  // 我的订单详情
  myOrderDetail: {
    subject: {
      ddbh: '订单编号：',
      jyje: '交易金额',
      jysl: '交易数量',
      jyjg: '交易价格',
      mj: '买家',
      maij: '卖家',
      pj: '评价',
      pjyj: '对这次交易非常满意，下次继续合作。',
      ltnr: '请输入聊天内容',
      zcly: '仲裁理由',
      sqly: '请输入申请理由',
      jypj: '交易评价',
      yhyx: '交易有何印象？快來评价吧',
      klpj: '快來评价吧',
      ddxq: '订单详情',
      qdp: '请点评',
      pjsh: '评价成功, 其中含有关键字，需平台进行审核',
      pjcg: '评价成功',
      ddbcd: '订单將在拖管中保持至',
      zdqx: '逾期未支付交易將自动取消',
      bjfk: '标记付款',
      qxjy: '取消交易',
      sfhb: '释放货币',
      sqlybk: '申请理由不能为空',
      fqcg: '仲裁发起成功',
      sqzc: '申请仲裁'
    }
  },
  // 交易对手
  myGuest: {
    subject: {
      wxrd: '我信任的',
      xrwd: '信任我的',
      wpbd: '我屏蔽的',
      jycs: '交易次数',
      xrrs: '信任人数',
      hpl: '好评率',
      zwxx: '暂无信息',
      jyds: '交易对手'
    }
  },
  // 邀请好友
  myInviteFriends: {
    subject: {
      yqnjr: '邀请您加入XXX',
      casb: '长按识别二维码',
      yqhy: '邀请好友',
      fuzzs: '下载至本地',
      fz: '复制',
      bzbd: '复制您的专属邀请链接'
    }
  },
  // 安全中心
  securityCenter: {
    subject: {
      jymm: '交易密码',
      sfrz: '身份认证',
      ggrz: '谷歌认证',
      ykq: '已开启',
      bdyx: '绑定邮箱',
      ybdyx: '已绑定邮箱',
      bdsjh: '绑定手机号',
      ybdsjh: '已绑定手机号',
      xgdlmm: '修改登录密码',
      tcdl: '退出登录',
      aqzx: '安全中心'
    }
  },
  // 修改交易密码
  securityTradePassword: {
    subject: {
      zg: '中国',
      sryzm: '输入验证码',
      hqyzm: '获取验证码',
      cxhq: '重新获取',
      mmjw: '密码6位-16位',
      qrmm: '确认密码',
      qd: '确 定',
      xgjymm: '修改交易密码',
      szjymm: '设置交易密码',
      txwz: '请填写完整',
      mmbyz: '密码不一致，请重新输入',
      czcg: '重置密码成功',
      szcg: '设置密码成功'
    }
  },
  // 身份认证
  securityIdentity: {
    subject: {
      sfzrz: '身份证认证',
      hzrz: '护照认证',
      jzrz: '驾照认证',
      wrz: '未认证',
      sfrz: '身份认证'
    }
  },
  // 进行身份认证
  securityIdcard: {
    subject: {
      qsrxm: '请输入姓名',
      qsr: '请输入',
      h: '号',
      sc: '上传',
      zm: '正面',
      fm: '反面',
      qd: '确 定',
      fqcg: '认证发起成功',
      sfz: '身份证',
      hz: '护照',
      jz: '驾照',
      rz: '认证',
      tpcc: '图片上传出错'
    }
  },
  // google认证
  securityGoogle: {
    subject: {
      mm: '密码',
      ggyzm: '谷歌验证码',
      sjyzm: '手机验证码',
      hqyzm: '获取验证码',
      cxhq: '重新获取',
      qd: '确 定',
      ggrz: '谷歌认证',
      kqcg: '开启成功',
      gbcg: '关闭成功'
    }
  },
  // 绑定邮箱
  bindEmail: {
    subject: {
      sryx: '请输入邮箱',
      sryz: '请输入验证码',
      hqyz: '获取验证码',
      cxhq: '重新获取',
      qd: '确 定',
      bdyx: '绑定邮箱'
    }
  },
  // 绑定手机
  securityPhone: {
    subject: {
      sjh: '请输入手机号',
      yzm: '请输入验证码',
      hqyzm: '获取验证码',
      cxhq: '重新获取',
      qd: '确 定',
      qtx: '请填写手机号',
      txwz: '请填写完整'
    }
  },
  // 修改登录密码
  exitLoginPassword: {
    subject: {
      sryxsj: '请输入邮箱或手机号',
      yzm: '输入验证码',
      hqyzm: '获取验证码',
      cxhq: '重新获取',
      xmm: '请输入6-16位的新密码',
      jmm: '请输入旧密码',
      ywsz: '英文数字组合6位-16位',
      qrmm: '确认密码',
      qd: '确 定',
      xgdlmm: '修改登录密码',
      zhmm: '找回密码',
      mmbyz: '密码不一致，请重新输入',
      czmmcg: '重置密码成功'

    }
  },
  // 登录
  login: {
    subject: {
      hyhl: '欢迎回来',
      srzh: '请输入账号',
      srldsl: '请输入密码（英文数字组合6位-16位）',
      dl: '登录',
      ljzc: '立即注册',
      wjmm: '忘记密码？'
    }
  },
  // 注册
  registered: {
    subject: {
      zc: '注册',
      sjzc: '手机注册',
      yxzc: '欢迎加入COWEX',
      zcfs: '请使用邮箱注册',
      srnc: '请输入用户昵称',
      srsjh: '请输入手机号',
      sryxh: '请输入邮箱账号',
      sryzm: '请输入验证码',
      hqyzm: '获取验证码',
      cxfs: '重新发送',
      ldslw: '英文数字组合6位-16位',
      qrmm: '请确认密码',
      wyjs: '我已阅读并同意',
      xytk: '《COWEX注册协议》',
      zcxy: '注册协议',
      sjhwk: '手机号不能为空',
      yxhwk: '邮箱号不能为空',
      txwz: '请填写完整',
      mmbyz: '密码不一致，请重新输入',
      zccg: '注册成功'
    }
  },
  //协议
  aboutprivacy: {
    subject: {
      ptjs: '平台介绍',
      yhxy: '用户协议',
      ystk: '隐私条款',
      flsm: '法律声明',
      fvsm: '费率说明',
      lxwm: '联系我们',
      gg: '公告',
      bzzx: '帮助中心',
      gywm: '关于我们'
    }
  },
  // 聊天
  messageChat: {
    subject: {
      ltnr: '输入聊天内容',
      sdsm: '说点什么吧',
      fs: '发送',
      xxnrbnwk: '消息内容不能为空'
    }
  },
  // 错误信息
  error: {
    subject: {
      notNull: '不能为空'
    }
  }
});

/***/ }),

/***/ "xgP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forthe_vue__ = __webpack_require__("EfWu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fabdc20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forthe_vue__ = __webpack_require__("xCLB");
function injectStyle (ssrContext) {
  __webpack_require__("d22Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fabdc20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forthe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fabdc20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forthe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y/jF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("DyAP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f399ee3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("x+us");
function injectStyle (ssrContext) {
  __webpack_require__("wxrh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f399ee3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f399ee3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zO3H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1a160c9dfde7fd0571f7.js